module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("antlr4/index");

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

// Generated from /home/teamcity/TeamCity/buildAgent/temp/buildTmp/tmp-100813XKcWzE2qNJ8/Transforms.g4 by ANTLR 4.7
// jshint ignore: start
var antlr4 = __webpack_require__(0);

// This class defines a complete listener for a parse tree produced by TransformsParser.
function TransformsListener() {
	antlr4.tree.ParseTreeListener.call(this);
	return this;
}

TransformsListener.prototype = Object.create(antlr4.tree.ParseTreeListener.prototype);
TransformsListener.prototype.constructor = TransformsListener;

// Enter a parse tree produced by TransformsParser#parseSemanticOp.
TransformsListener.prototype.enterParseSemanticOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#parseSemanticOp.
TransformsListener.prototype.exitParseSemanticOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#SemanticFill.
TransformsListener.prototype.enterSemanticFill = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#SemanticFill.
TransformsListener.prototype.exitSemanticFill = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#SemanticFillCoalesce.
TransformsListener.prototype.enterSemanticFillCoalesce = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#SemanticFillCoalesce.
TransformsListener.prototype.exitSemanticFillCoalesce = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#SemanticMultiFormula.
TransformsListener.prototype.enterSemanticMultiFormula = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#SemanticMultiFormula.
TransformsListener.prototype.exitSemanticMultiFormula = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#SemanticFormula.
TransformsListener.prototype.enterSemanticFormula = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#SemanticFormula.
TransformsListener.prototype.exitSemanticFormula = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#SemanticUnpivot.
TransformsListener.prototype.enterSemanticUnpivot = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#SemanticUnpivot.
TransformsListener.prototype.exitSemanticUnpivot = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#SemanticScript.
TransformsListener.prototype.enterSemanticScript = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#SemanticScript.
TransformsListener.prototype.exitSemanticScript = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#semantic_unpivot_clause.
TransformsListener.prototype.enterSemantic_unpivot_clause = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#semantic_unpivot_clause.
TransformsListener.prototype.exitSemantic_unpivot_clause = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#semantic_multi_formula_clause.
TransformsListener.prototype.enterSemantic_multi_formula_clause = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#semantic_multi_formula_clause.
TransformsListener.prototype.exitSemantic_multi_formula_clause = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#dep_value.
TransformsListener.prototype.enterDep_value = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#dep_value.
TransformsListener.prototype.exitDep_value = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#ops.
TransformsListener.prototype.enterOps = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#ops.
TransformsListener.prototype.exitOps = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#script.
TransformsListener.prototype.enterScript = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#script.
TransformsListener.prototype.exitScript = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#op.
TransformsListener.prototype.enterOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#op.
TransformsListener.prototype.exitOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#selectOp.
TransformsListener.prototype.enterSelectOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#selectOp.
TransformsListener.prototype.exitSelectOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#groupByOp.
TransformsListener.prototype.enterGroupByOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#groupByOp.
TransformsListener.prototype.exitGroupByOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#mergeOp.
TransformsListener.prototype.enterMergeOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#mergeOp.
TransformsListener.prototype.exitMergeOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#windowOp.
TransformsListener.prototype.enterWindowOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#windowOp.
TransformsListener.prototype.exitWindowOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#pivotOp.
TransformsListener.prototype.enterPivotOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#pivotOp.
TransformsListener.prototype.exitPivotOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#unpivotOp.
TransformsListener.prototype.enterUnpivotOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#unpivotOp.
TransformsListener.prototype.exitUnpivotOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#rowsOp.
TransformsListener.prototype.enterRowsOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#rowsOp.
TransformsListener.prototype.exitRowsOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#lookupOp.
TransformsListener.prototype.enterLookupOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#lookupOp.
TransformsListener.prototype.exitLookupOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#explodeOp.
TransformsListener.prototype.enterExplodeOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#explodeOp.
TransformsListener.prototype.exitExplodeOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#filterOp.
TransformsListener.prototype.enterFilterOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#filterOp.
TransformsListener.prototype.exitFilterOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#joinOp.
TransformsListener.prototype.enterJoinOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#joinOp.
TransformsListener.prototype.exitJoinOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#sortOp.
TransformsListener.prototype.enterSortOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#sortOp.
TransformsListener.prototype.exitSortOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#unionOp.
TransformsListener.prototype.enterUnionOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#unionOp.
TransformsListener.prototype.exitUnionOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#dropOp.
TransformsListener.prototype.enterDropOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#dropOp.
TransformsListener.prototype.exitDropOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#repartitionOp.
TransformsListener.prototype.enterRepartitionOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#repartitionOp.
TransformsListener.prototype.exitRepartitionOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#checkpointOp.
TransformsListener.prototype.enterCheckpointOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#checkpointOp.
TransformsListener.prototype.exitCheckpointOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#useHintOp.
TransformsListener.prototype.enterUseHintOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#useHintOp.
TransformsListener.prototype.exitUseHintOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#hintOp.
TransformsListener.prototype.enterHintOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#hintOp.
TransformsListener.prototype.exitHintOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#sampleOp.
TransformsListener.prototype.enterSampleOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#sampleOp.
TransformsListener.prototype.exitSampleOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#useOp.
TransformsListener.prototype.enterUseOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#useOp.
TransformsListener.prototype.exitUseOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#labelOp.
TransformsListener.prototype.enterLabelOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#labelOp.
TransformsListener.prototype.exitLabelOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#blockOp.
TransformsListener.prototype.enterBlockOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#blockOp.
TransformsListener.prototype.exitBlockOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#enforcePKOp.
TransformsListener.prototype.enterEnforcePKOp = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#enforcePKOp.
TransformsListener.prototype.exitEnforcePKOp = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#selector_pre.
TransformsListener.prototype.enterSelector_pre = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#selector_pre.
TransformsListener.prototype.exitSelector_pre = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#selector_post.
TransformsListener.prototype.enterSelector_post = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#selector_post.
TransformsListener.prototype.exitSelector_post = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#pivot_when_clause.
TransformsListener.prototype.enterPivot_when_clause = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#pivot_when_clause.
TransformsListener.prototype.exitPivot_when_clause = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#pivot_else_clause.
TransformsListener.prototype.enterPivot_else_clause = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#pivot_else_clause.
TransformsListener.prototype.exitPivot_else_clause = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#row_clause.
TransformsListener.prototype.enterRow_clause = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#row_clause.
TransformsListener.prototype.exitRow_clause = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#named_exprs.
TransformsListener.prototype.enterNamed_exprs = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#named_exprs.
TransformsListener.prototype.exitNamed_exprs = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#exprs.
TransformsListener.prototype.enterExprs = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#exprs.
TransformsListener.prototype.exitExprs = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#join_type.
TransformsListener.prototype.enterJoin_type = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#join_type.
TransformsListener.prototype.exitJoin_type = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#named_expr.
TransformsListener.prototype.enterNamed_expr = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#named_expr.
TransformsListener.prototype.exitNamed_expr = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#rename_expr.
TransformsListener.prototype.enterRename_expr = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#rename_expr.
TransformsListener.prototype.exitRename_expr = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#rename_from.
TransformsListener.prototype.enterRename_from = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#rename_from.
TransformsListener.prototype.exitRename_from = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#rename_to.
TransformsListener.prototype.enterRename_to = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#rename_to.
TransformsListener.prototype.exitRename_to = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#sort_clause.
TransformsListener.prototype.enterSort_clause = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#sort_clause.
TransformsListener.prototype.exitSort_clause = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#window_frame.
TransformsListener.prototype.enterWindow_frame = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#window_frame.
TransformsListener.prototype.exitWindow_frame = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#window_frame_interval.
TransformsListener.prototype.enterWindow_frame_interval = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#window_frame_interval.
TransformsListener.prototype.exitWindow_frame_interval = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#window_frame_boundary.
TransformsListener.prototype.enterWindow_frame_boundary = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#window_frame_boundary.
TransformsListener.prototype.exitWindow_frame_boundary = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#parseExpr.
TransformsListener.prototype.enterParseExpr = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#parseExpr.
TransformsListener.prototype.exitParseExpr = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#IsEmpty.
TransformsListener.prototype.enterIsEmpty = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#IsEmpty.
TransformsListener.prototype.exitIsEmpty = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#Multiplication.
TransformsListener.prototype.enterMultiplication = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#Multiplication.
TransformsListener.prototype.exitMultiplication = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#Or.
TransformsListener.prototype.enterOr = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#Or.
TransformsListener.prototype.exitOr = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#Negation.
TransformsListener.prototype.enterNegation = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#Negation.
TransformsListener.prototype.exitNegation = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#LT.
TransformsListener.prototype.enterLT = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#LT.
TransformsListener.prototype.exitLT = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#ConvertStruct.
TransformsListener.prototype.enterConvertStruct = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#ConvertStruct.
TransformsListener.prototype.exitConvertStruct = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#NotNull.
TransformsListener.prototype.enterNotNull = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#NotNull.
TransformsListener.prototype.exitNotNull = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#Case.
TransformsListener.prototype.enterCase = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#Case.
TransformsListener.prototype.exitCase = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#Concat.
TransformsListener.prototype.enterConcat = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#Concat.
TransformsListener.prototype.exitConcat = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#Identifier.
TransformsListener.prototype.enterIdentifier = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#Identifier.
TransformsListener.prototype.exitIdentifier = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#Literal.
TransformsListener.prototype.enterLiteral = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#Literal.
TransformsListener.prototype.exitLiteral = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#Division.
TransformsListener.prototype.enterDivision = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#Division.
TransformsListener.prototype.exitDivision = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#ConvertArray.
TransformsListener.prototype.enterConvertArray = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#ConvertArray.
TransformsListener.prototype.exitConvertArray = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#Call.
TransformsListener.prototype.enterCall = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#Call.
TransformsListener.prototype.exitCall = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#Addition.
TransformsListener.prototype.enterAddition = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#Addition.
TransformsListener.prototype.exitAddition = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#GetField.
TransformsListener.prototype.enterGetField = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#GetField.
TransformsListener.prototype.exitGetField = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#Modulo.
TransformsListener.prototype.enterModulo = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#Modulo.
TransformsListener.prototype.exitModulo = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#Reduce.
TransformsListener.prototype.enterReduce = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#Reduce.
TransformsListener.prototype.exitReduce = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#GT.
TransformsListener.prototype.enterGT = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#GT.
TransformsListener.prototype.exitGT = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#NotEquals.
TransformsListener.prototype.enterNotEquals = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#NotEquals.
TransformsListener.prototype.exitNotEquals = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#Not.
TransformsListener.prototype.enterNot = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#Not.
TransformsListener.prototype.exitNot = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#Equals.
TransformsListener.prototype.enterEquals = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#Equals.
TransformsListener.prototype.exitEquals = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#Subtraction.
TransformsListener.prototype.enterSubtraction = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#Subtraction.
TransformsListener.prototype.exitSubtraction = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#Filter.
TransformsListener.prototype.enterFilter = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#Filter.
TransformsListener.prototype.exitFilter = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#And.
TransformsListener.prototype.enterAnd = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#And.
TransformsListener.prototype.exitAnd = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#GTE.
TransformsListener.prototype.enterGTE = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#GTE.
TransformsListener.prototype.exitGTE = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#IsNull.
TransformsListener.prototype.enterIsNull = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#IsNull.
TransformsListener.prototype.exitIsNull = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#NotEmpty.
TransformsListener.prototype.enterNotEmpty = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#NotEmpty.
TransformsListener.prototype.exitNotEmpty = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#LTE.
TransformsListener.prototype.enterLTE = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#LTE.
TransformsListener.prototype.exitLTE = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#Map.
TransformsListener.prototype.enterMap = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#Map.
TransformsListener.prototype.exitMap = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#Paren.
TransformsListener.prototype.enterParen = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#Paren.
TransformsListener.prototype.exitParen = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#unpack_expr.
TransformsListener.prototype.enterUnpack_expr = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#unpack_expr.
TransformsListener.prototype.exitUnpack_expr = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#literalRecord.
TransformsListener.prototype.enterLiteralRecord = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#literalRecord.
TransformsListener.prototype.exitLiteralRecord = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#record_fields.
TransformsListener.prototype.enterRecord_fields = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#record_fields.
TransformsListener.prototype.exitRecord_fields = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#record_field.
TransformsListener.prototype.enterRecord_field = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#record_field.
TransformsListener.prototype.exitRecord_field = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#literalInteger.
TransformsListener.prototype.enterLiteralInteger = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#literalInteger.
TransformsListener.prototype.exitLiteralInteger = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#literalLong.
TransformsListener.prototype.enterLiteralLong = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#literalLong.
TransformsListener.prototype.exitLiteralLong = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#literalNumber.
TransformsListener.prototype.enterLiteralNumber = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#literalNumber.
TransformsListener.prototype.exitLiteralNumber = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#literalString.
TransformsListener.prototype.enterLiteralString = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#literalString.
TransformsListener.prototype.exitLiteralString = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#literalNull.
TransformsListener.prototype.enterLiteralNull = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#literalNull.
TransformsListener.prototype.exitLiteralNull = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#literalTrue.
TransformsListener.prototype.enterLiteralTrue = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#literalTrue.
TransformsListener.prototype.exitLiteralTrue = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#literalFalse.
TransformsListener.prototype.enterLiteralFalse = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#literalFalse.
TransformsListener.prototype.exitLiteralFalse = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#case_when_clause.
TransformsListener.prototype.enterCase_when_clause = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#case_when_clause.
TransformsListener.prototype.exitCase_when_clause = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#case_else_clause.
TransformsListener.prototype.enterCase_else_clause = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#case_else_clause.
TransformsListener.prototype.exitCase_else_clause = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#function_reference.
TransformsListener.prototype.enterFunction_reference = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#function_reference.
TransformsListener.prototype.exitFunction_reference = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#lambda.
TransformsListener.prototype.enterLambda = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#lambda.
TransformsListener.prototype.exitLambda = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#function_name.
TransformsListener.prototype.enterFunction_name = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#function_name.
TransformsListener.prototype.exitFunction_name = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#dataset.
TransformsListener.prototype.enterDataset = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#dataset.
TransformsListener.prototype.exitDataset = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#dataset_name.
TransformsListener.prototype.enterDataset_name = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#dataset_name.
TransformsListener.prototype.exitDataset_name = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#dataset_expr.
TransformsListener.prototype.enterDataset_expr = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#dataset_expr.
TransformsListener.prototype.exitDataset_expr = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#hint.
TransformsListener.prototype.enterHint = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#hint.
TransformsListener.prototype.exitHint = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#dataset_list.
TransformsListener.prototype.enterDataset_list = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#dataset_list.
TransformsListener.prototype.exitDataset_list = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#hint_list.
TransformsListener.prototype.enterHint_list = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#hint_list.
TransformsListener.prototype.exitHint_list = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#identifier_list.
TransformsListener.prototype.enterIdentifier_list = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#identifier_list.
TransformsListener.prototype.exitIdentifier_list = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#id.
TransformsListener.prototype.enterId = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#id.
TransformsListener.prototype.exitId = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#id_fragment.
TransformsListener.prototype.enterId_fragment = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#id_fragment.
TransformsListener.prototype.exitId_fragment = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#comments.
TransformsListener.prototype.enterComments = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#comments.
TransformsListener.prototype.exitComments = function(ctx) {
};


// Enter a parse tree produced by TransformsParser#comment.
TransformsListener.prototype.enterComment = function(ctx) {
};

// Exit a parse tree produced by TransformsParser#comment.
TransformsListener.prototype.exitComment = function(ctx) {
};



exports.TransformsListener = TransformsListener;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

// Generated from /home/teamcity/TeamCity/buildAgent/temp/buildTmp/tmp-100813XKcWzE2qNJ8/Transforms.g4 by ANTLR 4.7
// jshint ignore: start
var antlr4 = __webpack_require__(0);

// This class defines a complete generic visitor for a parse tree produced by TransformsParser.

function TransformsVisitor() {
	antlr4.tree.ParseTreeVisitor.call(this);
	return this;
}

TransformsVisitor.prototype = Object.create(antlr4.tree.ParseTreeVisitor.prototype);
TransformsVisitor.prototype.constructor = TransformsVisitor;

// Visit a parse tree produced by TransformsParser#parseSemanticOp.
TransformsVisitor.prototype.visitParseSemanticOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#SemanticFill.
TransformsVisitor.prototype.visitSemanticFill = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#SemanticFillCoalesce.
TransformsVisitor.prototype.visitSemanticFillCoalesce = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#SemanticMultiFormula.
TransformsVisitor.prototype.visitSemanticMultiFormula = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#SemanticFormula.
TransformsVisitor.prototype.visitSemanticFormula = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#SemanticUnpivot.
TransformsVisitor.prototype.visitSemanticUnpivot = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#SemanticScript.
TransformsVisitor.prototype.visitSemanticScript = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#semantic_unpivot_clause.
TransformsVisitor.prototype.visitSemantic_unpivot_clause = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#semantic_multi_formula_clause.
TransformsVisitor.prototype.visitSemantic_multi_formula_clause = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#dep_value.
TransformsVisitor.prototype.visitDep_value = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#ops.
TransformsVisitor.prototype.visitOps = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#script.
TransformsVisitor.prototype.visitScript = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#op.
TransformsVisitor.prototype.visitOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#selectOp.
TransformsVisitor.prototype.visitSelectOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#groupByOp.
TransformsVisitor.prototype.visitGroupByOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#mergeOp.
TransformsVisitor.prototype.visitMergeOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#windowOp.
TransformsVisitor.prototype.visitWindowOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#pivotOp.
TransformsVisitor.prototype.visitPivotOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#unpivotOp.
TransformsVisitor.prototype.visitUnpivotOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#rowsOp.
TransformsVisitor.prototype.visitRowsOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#lookupOp.
TransformsVisitor.prototype.visitLookupOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#explodeOp.
TransformsVisitor.prototype.visitExplodeOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#filterOp.
TransformsVisitor.prototype.visitFilterOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#joinOp.
TransformsVisitor.prototype.visitJoinOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#sortOp.
TransformsVisitor.prototype.visitSortOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#unionOp.
TransformsVisitor.prototype.visitUnionOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#dropOp.
TransformsVisitor.prototype.visitDropOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#repartitionOp.
TransformsVisitor.prototype.visitRepartitionOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#checkpointOp.
TransformsVisitor.prototype.visitCheckpointOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#useHintOp.
TransformsVisitor.prototype.visitUseHintOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#hintOp.
TransformsVisitor.prototype.visitHintOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#sampleOp.
TransformsVisitor.prototype.visitSampleOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#useOp.
TransformsVisitor.prototype.visitUseOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#labelOp.
TransformsVisitor.prototype.visitLabelOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#blockOp.
TransformsVisitor.prototype.visitBlockOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#enforcePKOp.
TransformsVisitor.prototype.visitEnforcePKOp = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#selector_pre.
TransformsVisitor.prototype.visitSelector_pre = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#selector_post.
TransformsVisitor.prototype.visitSelector_post = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#pivot_when_clause.
TransformsVisitor.prototype.visitPivot_when_clause = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#pivot_else_clause.
TransformsVisitor.prototype.visitPivot_else_clause = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#row_clause.
TransformsVisitor.prototype.visitRow_clause = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#named_exprs.
TransformsVisitor.prototype.visitNamed_exprs = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#exprs.
TransformsVisitor.prototype.visitExprs = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#join_type.
TransformsVisitor.prototype.visitJoin_type = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#named_expr.
TransformsVisitor.prototype.visitNamed_expr = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#rename_expr.
TransformsVisitor.prototype.visitRename_expr = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#rename_from.
TransformsVisitor.prototype.visitRename_from = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#rename_to.
TransformsVisitor.prototype.visitRename_to = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#sort_clause.
TransformsVisitor.prototype.visitSort_clause = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#window_frame.
TransformsVisitor.prototype.visitWindow_frame = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#window_frame_interval.
TransformsVisitor.prototype.visitWindow_frame_interval = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#window_frame_boundary.
TransformsVisitor.prototype.visitWindow_frame_boundary = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#parseExpr.
TransformsVisitor.prototype.visitParseExpr = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#IsEmpty.
TransformsVisitor.prototype.visitIsEmpty = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#Multiplication.
TransformsVisitor.prototype.visitMultiplication = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#Or.
TransformsVisitor.prototype.visitOr = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#Negation.
TransformsVisitor.prototype.visitNegation = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#LT.
TransformsVisitor.prototype.visitLT = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#ConvertStruct.
TransformsVisitor.prototype.visitConvertStruct = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#NotNull.
TransformsVisitor.prototype.visitNotNull = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#Case.
TransformsVisitor.prototype.visitCase = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#Concat.
TransformsVisitor.prototype.visitConcat = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#Identifier.
TransformsVisitor.prototype.visitIdentifier = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#Literal.
TransformsVisitor.prototype.visitLiteral = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#Division.
TransformsVisitor.prototype.visitDivision = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#ConvertArray.
TransformsVisitor.prototype.visitConvertArray = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#Call.
TransformsVisitor.prototype.visitCall = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#Addition.
TransformsVisitor.prototype.visitAddition = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#GetField.
TransformsVisitor.prototype.visitGetField = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#Modulo.
TransformsVisitor.prototype.visitModulo = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#Reduce.
TransformsVisitor.prototype.visitReduce = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#GT.
TransformsVisitor.prototype.visitGT = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#NotEquals.
TransformsVisitor.prototype.visitNotEquals = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#Not.
TransformsVisitor.prototype.visitNot = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#Equals.
TransformsVisitor.prototype.visitEquals = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#Subtraction.
TransformsVisitor.prototype.visitSubtraction = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#Filter.
TransformsVisitor.prototype.visitFilter = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#And.
TransformsVisitor.prototype.visitAnd = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#GTE.
TransformsVisitor.prototype.visitGTE = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#IsNull.
TransformsVisitor.prototype.visitIsNull = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#NotEmpty.
TransformsVisitor.prototype.visitNotEmpty = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#LTE.
TransformsVisitor.prototype.visitLTE = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#Map.
TransformsVisitor.prototype.visitMap = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#Paren.
TransformsVisitor.prototype.visitParen = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#unpack_expr.
TransformsVisitor.prototype.visitUnpack_expr = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#literalRecord.
TransformsVisitor.prototype.visitLiteralRecord = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#record_fields.
TransformsVisitor.prototype.visitRecord_fields = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#record_field.
TransformsVisitor.prototype.visitRecord_field = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#literalInteger.
TransformsVisitor.prototype.visitLiteralInteger = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#literalLong.
TransformsVisitor.prototype.visitLiteralLong = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#literalNumber.
TransformsVisitor.prototype.visitLiteralNumber = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#literalString.
TransformsVisitor.prototype.visitLiteralString = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#literalNull.
TransformsVisitor.prototype.visitLiteralNull = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#literalTrue.
TransformsVisitor.prototype.visitLiteralTrue = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#literalFalse.
TransformsVisitor.prototype.visitLiteralFalse = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#case_when_clause.
TransformsVisitor.prototype.visitCase_when_clause = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#case_else_clause.
TransformsVisitor.prototype.visitCase_else_clause = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#function_reference.
TransformsVisitor.prototype.visitFunction_reference = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#lambda.
TransformsVisitor.prototype.visitLambda = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#function_name.
TransformsVisitor.prototype.visitFunction_name = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#dataset.
TransformsVisitor.prototype.visitDataset = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#dataset_name.
TransformsVisitor.prototype.visitDataset_name = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#dataset_expr.
TransformsVisitor.prototype.visitDataset_expr = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#hint.
TransformsVisitor.prototype.visitHint = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#dataset_list.
TransformsVisitor.prototype.visitDataset_list = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#hint_list.
TransformsVisitor.prototype.visitHint_list = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#identifier_list.
TransformsVisitor.prototype.visitIdentifier_list = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#id.
TransformsVisitor.prototype.visitId = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#id_fragment.
TransformsVisitor.prototype.visitId_fragment = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#comments.
TransformsVisitor.prototype.visitComments = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by TransformsParser#comment.
TransformsVisitor.prototype.visitComment = function(ctx) {
  return this.visitChildren(ctx);
};



exports.TransformsVisitor = TransformsVisitor;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

// Generated from /home/teamcity/TeamCity/buildAgent/temp/buildTmp/tmp-100813XKcWzE2qNJ8/Transforms.g4 by ANTLR 4.7
// jshint ignore: start
var antlr4 = __webpack_require__(0);


var serializedATN = ["\u0003\u608b\ua72a\u8133\ub9ed\u417c\u3be7\u7786\u5964",
    "\u0002f\u03bd\b\u0001\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004",
    "\u0004\t\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007\t",
    "\u0007\u0004\b\t\b\u0004\t\t\t\u0004\n\t\n\u0004\u000b\t\u000b\u0004",
    "\f\t\f\u0004\r\t\r\u0004\u000e\t\u000e\u0004\u000f\t\u000f\u0004\u0010",
    "\t\u0010\u0004\u0011\t\u0011\u0004\u0012\t\u0012\u0004\u0013\t\u0013",
    "\u0004\u0014\t\u0014\u0004\u0015\t\u0015\u0004\u0016\t\u0016\u0004\u0017",
    "\t\u0017\u0004\u0018\t\u0018\u0004\u0019\t\u0019\u0004\u001a\t\u001a",
    "\u0004\u001b\t\u001b\u0004\u001c\t\u001c\u0004\u001d\t\u001d\u0004\u001e",
    "\t\u001e\u0004\u001f\t\u001f\u0004 \t \u0004!\t!\u0004\"\t\"\u0004#",
    "\t#\u0004$\t$\u0004%\t%\u0004&\t&\u0004\'\t\'\u0004(\t(\u0004)\t)\u0004",
    "*\t*\u0004+\t+\u0004,\t,\u0004-\t-\u0004.\t.\u0004/\t/\u00040\t0\u0004",
    "1\t1\u00042\t2\u00043\t3\u00044\t4\u00045\t5\u00046\t6\u00047\t7\u0004",
    "8\t8\u00049\t9\u0004:\t:\u0004;\t;\u0004<\t<\u0004=\t=\u0004>\t>\u0004",
    "?\t?\u0004@\t@\u0004A\tA\u0004B\tB\u0004C\tC\u0004D\tD\u0004E\tE\u0004",
    "F\tF\u0004G\tG\u0004H\tH\u0004I\tI\u0004J\tJ\u0004K\tK\u0004L\tL\u0004",
    "M\tM\u0004N\tN\u0004O\tO\u0004P\tP\u0004Q\tQ\u0004R\tR\u0004S\tS\u0004",
    "T\tT\u0004U\tU\u0004V\tV\u0004W\tW\u0004X\tX\u0004Y\tY\u0004Z\tZ\u0004",
    "[\t[\u0004\\\t\\\u0004]\t]\u0004^\t^\u0004_\t_\u0004`\t`\u0004a\ta\u0004",
    "b\tb\u0004c\tc\u0004d\td\u0004e\te\u0004f\tf\u0004g\tg\u0004h\th\u0004",
    "i\ti\u0004j\tj\u0004k\tk\u0004l\tl\u0004m\tm\u0004n\tn\u0004o\to\u0004",
    "p\tp\u0004q\tq\u0004r\tr\u0004s\ts\u0004t\tt\u0004u\tu\u0004v\tv\u0004",
    "w\tw\u0004x\tx\u0004y\ty\u0004z\tz\u0004{\t{\u0004|\t|\u0004}\t}\u0004",
    "~\t~\u0004\u007f\t\u007f\u0004\u0080\t\u0080\u0004\u0081\t\u0081\u0004",
    "\u0082\t\u0082\u0004\u0083\t\u0083\u0003\u0002\u0003\u0002\u0003\u0003",
    "\u0003\u0003\u0003\u0004\u0003\u0004\u0003\u0005\u0003\u0005\u0003\u0006",
    "\u0003\u0006\u0003\u0007\u0003\u0007\u0003\b\u0003\b\u0003\t\u0003\t",
    "\u0003\n\u0003\n\u0003\n\u0003\u000b\u0003\u000b\u0003\f\u0003\f\u0003",
    "\r\u0003\r\u0003\r\u0003\u000e\u0003\u000e\u0003\u000e\u0003\u000f\u0003",
    "\u000f\u0003\u000f\u0003\u0010\u0003\u0010\u0003\u0011\u0003\u0011\u0003",
    "\u0011\u0003\u0012\u0003\u0012\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0014\u0003\u0014\u0003\u0015\u0003\u0015\u0003\u0016\u0003\u0016\u0003",
    "\u0017\u0003\u0017\u0003\u0017\u0003\u0018\u0003\u0018\u0003\u0019\u0003",
    "\u0019\u0003\u0019\u0003\u0019\u0003\u001a\u0003\u001a\u0003\u001a\u0003",
    "\u001a\u0003\u001b\u0003\u001b\u0003\u001b\u0003\u001b\u0003\u001b\u0003",
    "\u001b\u0003\u001c\u0003\u001c\u0003\u001c\u0003\u001d\u0003\u001d\u0003",
    "\u001d\u0003\u001d\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003",
    "\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001f\u0003\u001f\u0003",
    "\u001f\u0003 \u0003 \u0003 \u0003 \u0003 \u0003!\u0003!\u0003!\u0003",
    "!\u0003!\u0003!\u0003!\u0003!\u0003!\u0003!\u0003!\u0003\"\u0003\"\u0003",
    "\"\u0003\"\u0003\"\u0003\"\u0003\"\u0003\"\u0003\"\u0003#\u0003#\u0003",
    "#\u0003#\u0003#\u0003#\u0003#\u0003#\u0003#\u0003#\u0003$\u0003$\u0003",
    "$\u0003$\u0003$\u0003$\u0003%\u0003%\u0003%\u0003%\u0003%\u0003%\u0003",
    "%\u0003%\u0003&\u0003&\u0003&\u0003&\u0003&\u0003\'\u0003\'\u0003\'",
    "\u0003\'\u0003\'\u0003\'\u0003\'\u0003\'\u0003\'\u0003\'\u0003\'\u0003",
    "\'\u0003\'\u0003(\u0003(\u0003(\u0003(\u0003(\u0003)\u0003)\u0003)\u0003",
    ")\u0003)\u0003*\u0003*\u0003*\u0003*\u0003*\u0003*\u0003+\u0003+\u0003",
    "+\u0003+\u0003,\u0003,\u0003,\u0003,\u0003,\u0003,\u0003,\u0003,\u0003",
    "-\u0003-\u0003-\u0003-\u0003-\u0003-\u0003-\u0003-\u0003.\u0003.\u0003",
    ".\u0003.\u0003.\u0003.\u0003/\u0003/\u0003/\u0003/\u0003/\u0003/\u0003",
    "/\u00030\u00030\u00030\u00030\u00030\u00030\u00031\u00031\u00031\u0003",
    "1\u00031\u00031\u00031\u00031\u00031\u00031\u00032\u00032\u00032\u0003",
    "2\u00032\u00033\u00033\u00033\u00033\u00033\u00034\u00034\u00034\u0003",
    "4\u00034\u00034\u00035\u00035\u00035\u00035\u00035\u00036\u00036\u0003",
    "6\u00036\u00036\u00036\u00037\u00037\u00037\u00038\u00038\u00038\u0003",
    "8\u00038\u00039\u00039\u00039\u00039\u0003:\u0003:\u0003:\u0003:\u0003",
    ":\u0003:\u0003:\u0003;\u0003;\u0003;\u0003;\u0003;\u0003<\u0003<\u0003",
    "<\u0003<\u0003<\u0003<\u0003<\u0003=\u0003=\u0003=\u0003=\u0003=\u0003",
    ">\u0003>\u0003>\u0003>\u0003?\u0003?\u0003?\u0003?\u0003?\u0003?\u0003",
    "@\u0003@\u0003@\u0003@\u0003A\u0003A\u0003A\u0003A\u0003A\u0003B\u0003",
    "B\u0003B\u0003B\u0003B\u0003B\u0003C\u0003C\u0003C\u0003D\u0003D\u0003",
    "D\u0003E\u0003E\u0003E\u0003E\u0003E\u0003E\u0003F\u0003F\u0003F\u0003",
    "F\u0003F\u0003F\u0003G\u0003G\u0003G\u0003G\u0003G\u0003G\u0003H\u0003",
    "H\u0003H\u0003H\u0003H\u0003H\u0003H\u0003H\u0003H\u0003H\u0003I\u0003",
    "I\u0003I\u0003I\u0003I\u0003I\u0003I\u0003I\u0003J\u0003J\u0003J\u0003",
    "J\u0003J\u0003J\u0003K\u0003K\u0003K\u0003K\u0003K\u0003K\u0003K\u0003",
    "L\u0003L\u0003L\u0003L\u0003L\u0003L\u0003L\u0003L\u0003L\u0003L\u0003",
    "L\u0003L\u0003M\u0003M\u0003M\u0003M\u0003M\u0003M\u0003N\u0003N\u0003",
    "N\u0003N\u0003O\u0003O\u0003O\u0003O\u0003O\u0003P\u0003P\u0003P\u0003",
    "P\u0003P\u0003P\u0003P\u0003Q\u0003Q\u0003Q\u0003Q\u0003Q\u0003R\u0003",
    "R\u0003R\u0003R\u0003R\u0003S\u0003S\u0003S\u0003S\u0003S\u0003S\u0003",
    "S\u0003S\u0003S\u0003S\u0003T\u0003T\u0003T\u0003T\u0003T\u0003T\u0003",
    "U\u0003U\u0003U\u0003U\u0003U\u0003U\u0003U\u0003U\u0003V\u0003V\u0003",
    "V\u0003V\u0003W\u0003W\u0003W\u0003W\u0003W\u0003W\u0003W\u0003X\u0003",
    "X\u0003X\u0003X\u0003X\u0003Y\u0003Y\u0003Y\u0003Y\u0003Y\u0003Z\u0003",
    "Z\u0003Z\u0003Z\u0003Z\u0003Z\u0003Z\u0003[\u0003[\u0003[\u0003[\u0003",
    "[\u0003\\\u0003\\\u0003\\\u0007\\\u02d8\n\\\f\\\u000e\\\u02db\u000b",
    "\\\u0003\\\u0003\\\u0003]\u0003]\u0003]\u0003^\u0005^\u02e3\n^\u0003",
    "^\u0006^\u02e6\n^\r^\u000e^\u02e7\u0003_\u0005_\u02eb\n_\u0003_\u0006",
    "_\u02ee\n_\r_\u000e_\u02ef\u0003_\u0003_\u0007_\u02f4\n_\f_\u000e_\u02f7",
    "\u000b_\u0005_\u02f9\n_\u0003_\u0003_\u0005_\u02fd\n_\u0003_\u0006_",
    "\u0300\n_\r_\u000e_\u0301\u0005_\u0304\n_\u0003_\u0005_\u0307\n_\u0003",
    "_\u0003_\u0006_\u030b\n_\r_\u000e_\u030c\u0003_\u0003_\u0005_\u0311",
    "\n_\u0003_\u0006_\u0314\n_\r_\u000e_\u0315\u0005_\u0318\n_\u0003_\u0005",
    "_\u031b\n_\u0003_\u0003_\u0003_\u0003_\u0003_\u0003_\u0003_\u0003_\u0003",
    "_\u0003_\u0003_\u0005_\u0328\n_\u0003`\u0003`\u0007`\u032c\n`\f`\u000e",
    "`\u032f\u000b`\u0003`\u0003`\u0003`\u0003`\u0007`\u0335\n`\f`\u000e",
    "`\u0338\u000b`\u0003`\u0005`\u033b\n`\u0003a\u0006a\u033e\na\ra\u000e",
    "a\u033f\u0003a\u0003a\u0003b\u0003b\u0003b\u0003b\u0007b\u0348\nb\f",
    "b\u000eb\u034b\u000bb\u0003b\u0003b\u0003c\u0003c\u0003c\u0003c\u0007",
    "c\u0353\nc\fc\u000ec\u0356\u000bc\u0003c\u0003c\u0003d\u0003d\u0003",
    "d\u0003d\u0007d\u035e\nd\fd\u000ed\u0361\u000bd\u0003d\u0003d\u0003",
    "d\u0003d\u0003d\u0003e\u0003e\u0003e\u0003e\u0003e\u0003e\u0003e\u0005",
    "e\u036f\ne\u0007e\u0371\ne\fe\u000ee\u0374\u000be\u0003e\u0003e\u0003",
    "e\u0003e\u0003f\u0003f\u0003f\u0003f\u0003f\u0003f\u0003f\u0003f\u0005",
    "f\u0382\nf\u0003g\u0003g\u0003h\u0003h\u0003i\u0003i\u0003j\u0003j\u0003",
    "k\u0003k\u0003l\u0003l\u0003m\u0003m\u0003n\u0003n\u0003o\u0003o\u0003",
    "p\u0003p\u0003q\u0003q\u0003r\u0003r\u0003s\u0003s\u0003t\u0003t\u0003",
    "u\u0003u\u0003v\u0003v\u0003w\u0003w\u0003x\u0003x\u0003y\u0003y\u0003",
    "z\u0003z\u0003{\u0003{\u0003|\u0003|\u0003}\u0003}\u0003~\u0003~\u0003",
    "\u007f\u0003\u007f\u0003\u0080\u0003\u0080\u0003\u0081\u0003\u0081\u0003",
    "\u0082\u0003\u0082\u0003\u0083\u0003\u0083\u0003\u035f\u0002\u0084\u0003",
    "\u0003\u0005\u0004\u0007\u0005\t\u0006\u000b\u0007\r\b\u000f\t\u0011",
    "\n\u0013\u000b\u0015\f\u0017\r\u0019\u000e\u001b\u000f\u001d\u0010\u001f",
    "\u0011!\u0012#\u0013%\u0014\'\u0015)\u0016+\u0017-\u0018/\u00191\u001a",
    "3\u001b5\u001c7\u001d9\u001e;\u001f= ?!A\"C#E$G%I&K\'M(O)Q*S+U,W-Y.",
    "[/]0_1a2c3e4g5i6k7m8o9q:s;u<w=y>{?}@\u007fA\u0081B\u0083C\u0085D\u0087",
    "E\u0089F\u008bG\u008dH\u008fI\u0091J\u0093K\u0095L\u0097M\u0099N\u009b",
    "O\u009dP\u009fQ\u00a1R\u00a3S\u00a5T\u00a7U\u00a9V\u00abW\u00adX\u00af",
    "Y\u00b1Z\u00b3[\u00b5\\\u00b7]\u00b9^\u00bb_\u00bd`\u00bfa\u00c1b\u00c3",
    "c\u00c5d\u00c7e\u00c9f\u00cb\u0002\u00cd\u0002\u00cf\u0002\u00d1\u0002",
    "\u00d3\u0002\u00d5\u0002\u00d7\u0002\u00d9\u0002\u00db\u0002\u00dd\u0002",
    "\u00df\u0002\u00e1\u0002\u00e3\u0002\u00e5\u0002\u00e7\u0002\u00e9\u0002",
    "\u00eb\u0002\u00ed\u0002\u00ef\u0002\u00f1\u0002\u00f3\u0002\u00f5\u0002",
    "\u00f7\u0002\u00f9\u0002\u00fb\u0002\u00fd\u0002\u00ff\u0002\u0101\u0002",
    "\u0103\u0002\u0105\u0002\u0003\u0002(\u0004\u0002))^^\u0004\u0002--",
    "//\u0005\u0002C\\aac|\u0006\u00022;C\\aac|\u0003\u0002$$\u0005\u0002",
    "\u000b\r\u000f\u000f\"\"\u0004\u0002\f\f\u000f\u000f\u0003\u0002,,\u0003",
    "\u000211\n\u0002))11^^ddhhppttvv\u0003\u00022;\u0005\u00022;CHch\u0004",
    "\u0002CCcc\u0004\u0002DDdd\u0004\u0002EEee\u0004\u0002FFff\u0004\u0002",
    "GGgg\u0004\u0002HHhh\u0004\u0002IIii\u0004\u0002JJjj\u0004\u0002KKk",
    "k\u0004\u0002LLll\u0004\u0002MMmm\u0004\u0002NNnn\u0004\u0002OOoo\u0004",
    "\u0002PPpp\u0004\u0002QQqq\u0004\u0002RRrr\u0004\u0002SSss\u0004\u0002",
    "TTtt\u0004\u0002UUuu\u0004\u0002VVvv\u0004\u0002WWww\u0004\u0002XXx",
    "x\u0004\u0002YYyy\u0004\u0002ZZzz\u0004\u0002[[{{\u0004\u0002\\\\||",
    "\u0002\u03be\u0002\u0003\u0003\u0002\u0002\u0002\u0002\u0005\u0003\u0002",
    "\u0002\u0002\u0002\u0007\u0003\u0002\u0002\u0002\u0002\t\u0003\u0002",
    "\u0002\u0002\u0002\u000b\u0003\u0002\u0002\u0002\u0002\r\u0003\u0002",
    "\u0002\u0002\u0002\u000f\u0003\u0002\u0002\u0002\u0002\u0011\u0003\u0002",
    "\u0002\u0002\u0002\u0013\u0003\u0002\u0002\u0002\u0002\u0015\u0003\u0002",
    "\u0002\u0002\u0002\u0017\u0003\u0002\u0002\u0002\u0002\u0019\u0003\u0002",
    "\u0002\u0002\u0002\u001b\u0003\u0002\u0002\u0002\u0002\u001d\u0003\u0002",
    "\u0002\u0002\u0002\u001f\u0003\u0002\u0002\u0002\u0002!\u0003\u0002",
    "\u0002\u0002\u0002#\u0003\u0002\u0002\u0002\u0002%\u0003\u0002\u0002",
    "\u0002\u0002\'\u0003\u0002\u0002\u0002\u0002)\u0003\u0002\u0002\u0002",
    "\u0002+\u0003\u0002\u0002\u0002\u0002-\u0003\u0002\u0002\u0002\u0002",
    "/\u0003\u0002\u0002\u0002\u00021\u0003\u0002\u0002\u0002\u00023\u0003",
    "\u0002\u0002\u0002\u00025\u0003\u0002\u0002\u0002\u00027\u0003\u0002",
    "\u0002\u0002\u00029\u0003\u0002\u0002\u0002\u0002;\u0003\u0002\u0002",
    "\u0002\u0002=\u0003\u0002\u0002\u0002\u0002?\u0003\u0002\u0002\u0002",
    "\u0002A\u0003\u0002\u0002\u0002\u0002C\u0003\u0002\u0002\u0002\u0002",
    "E\u0003\u0002\u0002\u0002\u0002G\u0003\u0002\u0002\u0002\u0002I\u0003",
    "\u0002\u0002\u0002\u0002K\u0003\u0002\u0002\u0002\u0002M\u0003\u0002",
    "\u0002\u0002\u0002O\u0003\u0002\u0002\u0002\u0002Q\u0003\u0002\u0002",
    "\u0002\u0002S\u0003\u0002\u0002\u0002\u0002U\u0003\u0002\u0002\u0002",
    "\u0002W\u0003\u0002\u0002\u0002\u0002Y\u0003\u0002\u0002\u0002\u0002",
    "[\u0003\u0002\u0002\u0002\u0002]\u0003\u0002\u0002\u0002\u0002_\u0003",
    "\u0002\u0002\u0002\u0002a\u0003\u0002\u0002\u0002\u0002c\u0003\u0002",
    "\u0002\u0002\u0002e\u0003\u0002\u0002\u0002\u0002g\u0003\u0002\u0002",
    "\u0002\u0002i\u0003\u0002\u0002\u0002\u0002k\u0003\u0002\u0002\u0002",
    "\u0002m\u0003\u0002\u0002\u0002\u0002o\u0003\u0002\u0002\u0002\u0002",
    "q\u0003\u0002\u0002\u0002\u0002s\u0003\u0002\u0002\u0002\u0002u\u0003",
    "\u0002\u0002\u0002\u0002w\u0003\u0002\u0002\u0002\u0002y\u0003\u0002",
    "\u0002\u0002\u0002{\u0003\u0002\u0002\u0002\u0002}\u0003\u0002\u0002",
    "\u0002\u0002\u007f\u0003\u0002\u0002\u0002\u0002\u0081\u0003\u0002\u0002",
    "\u0002\u0002\u0083\u0003\u0002\u0002\u0002\u0002\u0085\u0003\u0002\u0002",
    "\u0002\u0002\u0087\u0003\u0002\u0002\u0002\u0002\u0089\u0003\u0002\u0002",
    "\u0002\u0002\u008b\u0003\u0002\u0002\u0002\u0002\u008d\u0003\u0002\u0002",
    "\u0002\u0002\u008f\u0003\u0002\u0002\u0002\u0002\u0091\u0003\u0002\u0002",
    "\u0002\u0002\u0093\u0003\u0002\u0002\u0002\u0002\u0095\u0003\u0002\u0002",
    "\u0002\u0002\u0097\u0003\u0002\u0002\u0002\u0002\u0099\u0003\u0002\u0002",
    "\u0002\u0002\u009b\u0003\u0002\u0002\u0002\u0002\u009d\u0003\u0002\u0002",
    "\u0002\u0002\u009f\u0003\u0002\u0002\u0002\u0002\u00a1\u0003\u0002\u0002",
    "\u0002\u0002\u00a3\u0003\u0002\u0002\u0002\u0002\u00a5\u0003\u0002\u0002",
    "\u0002\u0002\u00a7\u0003\u0002\u0002\u0002\u0002\u00a9\u0003\u0002\u0002",
    "\u0002\u0002\u00ab\u0003\u0002\u0002\u0002\u0002\u00ad\u0003\u0002\u0002",
    "\u0002\u0002\u00af\u0003\u0002\u0002\u0002\u0002\u00b1\u0003\u0002\u0002",
    "\u0002\u0002\u00b3\u0003\u0002\u0002\u0002\u0002\u00b5\u0003\u0002\u0002",
    "\u0002\u0002\u00b7\u0003\u0002\u0002\u0002\u0002\u00b9\u0003\u0002\u0002",
    "\u0002\u0002\u00bb\u0003\u0002\u0002\u0002\u0002\u00bd\u0003\u0002\u0002",
    "\u0002\u0002\u00bf\u0003\u0002\u0002\u0002\u0002\u00c1\u0003\u0002\u0002",
    "\u0002\u0002\u00c3\u0003\u0002\u0002\u0002\u0002\u00c5\u0003\u0002\u0002",
    "\u0002\u0002\u00c7\u0003\u0002\u0002\u0002\u0002\u00c9\u0003\u0002\u0002",
    "\u0002\u0003\u0107\u0003\u0002\u0002\u0002\u0005\u0109\u0003\u0002\u0002",
    "\u0002\u0007\u010b\u0003\u0002\u0002\u0002\t\u010d\u0003\u0002\u0002",
    "\u0002\u000b\u010f\u0003\u0002\u0002\u0002\r\u0111\u0003\u0002\u0002",
    "\u0002\u000f\u0113\u0003\u0002\u0002\u0002\u0011\u0115\u0003\u0002\u0002",
    "\u0002\u0013\u0117\u0003\u0002\u0002\u0002\u0015\u011a\u0003\u0002\u0002",
    "\u0002\u0017\u011c\u0003\u0002\u0002\u0002\u0019\u011e\u0003\u0002\u0002",
    "\u0002\u001b\u0121\u0003\u0002\u0002\u0002\u001d\u0124\u0003\u0002\u0002",
    "\u0002\u001f\u0127\u0003\u0002\u0002\u0002!\u0129\u0003\u0002\u0002",
    "\u0002#\u012c\u0003\u0002\u0002\u0002%\u012e\u0003\u0002\u0002\u0002",
    "\'\u0131\u0003\u0002\u0002\u0002)\u0133\u0003\u0002\u0002\u0002+\u0135",
    "\u0003\u0002\u0002\u0002-\u0137\u0003\u0002\u0002\u0002/\u013a\u0003",
    "\u0002\u0002\u00021\u013c\u0003\u0002\u0002\u00023\u0140\u0003\u0002",
    "\u0002\u00025\u0144\u0003\u0002\u0002\u00027\u014a\u0003\u0002\u0002",
    "\u00029\u014d\u0003\u0002\u0002\u0002;\u0151\u0003\u0002\u0002\u0002",
    "=\u0159\u0003\u0002\u0002\u0002?\u015c\u0003\u0002\u0002\u0002A\u0161",
    "\u0003\u0002\u0002\u0002C\u016c\u0003\u0002\u0002\u0002E\u0175\u0003",
    "\u0002\u0002\u0002G\u017f\u0003\u0002\u0002\u0002I\u0185\u0003\u0002",
    "\u0002\u0002K\u018d\u0003\u0002\u0002\u0002M\u0192\u0003\u0002\u0002",
    "\u0002O\u019f\u0003\u0002\u0002\u0002Q\u01a4\u0003\u0002\u0002\u0002",
    "S\u01a9\u0003\u0002\u0002\u0002U\u01af\u0003\u0002\u0002\u0002W\u01b3",
    "\u0003\u0002\u0002\u0002Y\u01bb\u0003\u0002\u0002\u0002[\u01c3\u0003",
    "\u0002\u0002\u0002]\u01c9\u0003\u0002\u0002\u0002_\u01d0\u0003\u0002",
    "\u0002\u0002a\u01d6\u0003\u0002\u0002\u0002c\u01e0\u0003\u0002\u0002",
    "\u0002e\u01e5\u0003\u0002\u0002\u0002g\u01ea\u0003\u0002\u0002\u0002",
    "i\u01f0\u0003\u0002\u0002\u0002k\u01f5\u0003\u0002\u0002\u0002m\u01fb",
    "\u0003\u0002\u0002\u0002o\u01fe\u0003\u0002\u0002\u0002q\u0203\u0003",
    "\u0002\u0002\u0002s\u0207\u0003\u0002\u0002\u0002u\u020e\u0003\u0002",
    "\u0002\u0002w\u0213\u0003\u0002\u0002\u0002y\u021a\u0003\u0002\u0002",
    "\u0002{\u021f\u0003\u0002\u0002\u0002}\u0223\u0003\u0002\u0002\u0002",
    "\u007f\u0229\u0003\u0002\u0002\u0002\u0081\u022d\u0003\u0002\u0002\u0002",
    "\u0083\u0232\u0003\u0002\u0002\u0002\u0085\u0238\u0003\u0002\u0002\u0002",
    "\u0087\u023b\u0003\u0002\u0002\u0002\u0089\u023e\u0003\u0002\u0002\u0002",
    "\u008b\u0244\u0003\u0002\u0002\u0002\u008d\u024a\u0003\u0002\u0002\u0002",
    "\u008f\u0250\u0003\u0002\u0002\u0002\u0091\u025a\u0003\u0002\u0002\u0002",
    "\u0093\u0262\u0003\u0002\u0002\u0002\u0095\u0268\u0003\u0002\u0002\u0002",
    "\u0097\u026f\u0003\u0002\u0002\u0002\u0099\u027b\u0003\u0002\u0002\u0002",
    "\u009b\u0281\u0003\u0002\u0002\u0002\u009d\u0285\u0003\u0002\u0002\u0002",
    "\u009f\u028a\u0003\u0002\u0002\u0002\u00a1\u0291\u0003\u0002\u0002\u0002",
    "\u00a3\u0296\u0003\u0002\u0002\u0002\u00a5\u029b\u0003\u0002\u0002\u0002",
    "\u00a7\u02a5\u0003\u0002\u0002\u0002\u00a9\u02ab\u0003\u0002\u0002\u0002",
    "\u00ab\u02b3\u0003\u0002\u0002\u0002\u00ad\u02b7\u0003\u0002\u0002\u0002",
    "\u00af\u02be\u0003\u0002\u0002\u0002\u00b1\u02c3\u0003\u0002\u0002\u0002",
    "\u00b3\u02c8\u0003\u0002\u0002\u0002\u00b5\u02cf\u0003\u0002\u0002\u0002",
    "\u00b7\u02d4\u0003\u0002\u0002\u0002\u00b9\u02de\u0003\u0002\u0002\u0002",
    "\u00bb\u02e2\u0003\u0002\u0002\u0002\u00bd\u0327\u0003\u0002\u0002\u0002",
    "\u00bf\u033a\u0003\u0002\u0002\u0002\u00c1\u033d\u0003\u0002\u0002\u0002",
    "\u00c3\u0343\u0003\u0002\u0002\u0002\u00c5\u034e\u0003\u0002\u0002\u0002",
    "\u00c7\u0359\u0003\u0002\u0002\u0002\u00c9\u0367\u0003\u0002\u0002\u0002",
    "\u00cb\u0379\u0003\u0002\u0002\u0002\u00cd\u0383\u0003\u0002\u0002\u0002",
    "\u00cf\u0385\u0003\u0002\u0002\u0002\u00d1\u0387\u0003\u0002\u0002\u0002",
    "\u00d3\u0389\u0003\u0002\u0002\u0002\u00d5\u038b\u0003\u0002\u0002\u0002",
    "\u00d7\u038d\u0003\u0002\u0002\u0002\u00d9\u038f\u0003\u0002\u0002\u0002",
    "\u00db\u0391\u0003\u0002\u0002\u0002\u00dd\u0393\u0003\u0002\u0002\u0002",
    "\u00df\u0395\u0003\u0002\u0002\u0002\u00e1\u0397\u0003\u0002\u0002\u0002",
    "\u00e3\u0399\u0003\u0002\u0002\u0002\u00e5\u039b\u0003\u0002\u0002\u0002",
    "\u00e7\u039d\u0003\u0002\u0002\u0002\u00e9\u039f\u0003\u0002\u0002\u0002",
    "\u00eb\u03a1\u0003\u0002\u0002\u0002\u00ed\u03a3\u0003\u0002\u0002\u0002",
    "\u00ef\u03a5\u0003\u0002\u0002\u0002\u00f1\u03a7\u0003\u0002\u0002\u0002",
    "\u00f3\u03a9\u0003\u0002\u0002\u0002\u00f5\u03ab\u0003\u0002\u0002\u0002",
    "\u00f7\u03ad\u0003\u0002\u0002\u0002\u00f9\u03af\u0003\u0002\u0002\u0002",
    "\u00fb\u03b1\u0003\u0002\u0002\u0002\u00fd\u03b3\u0003\u0002\u0002\u0002",
    "\u00ff\u03b5\u0003\u0002\u0002\u0002\u0101\u03b7\u0003\u0002\u0002\u0002",
    "\u0103\u03b9\u0003\u0002\u0002\u0002\u0105\u03bb\u0003\u0002\u0002\u0002",
    "\u0107\u0108\u0007,\u0002\u0002\u0108\u0004\u0003\u0002\u0002\u0002",
    "\u0109\u010a\u0007.\u0002\u0002\u010a\u0006\u0003\u0002\u0002\u0002",
    "\u010b\u010c\u0007*\u0002\u0002\u010c\b\u0003\u0002\u0002\u0002\u010d",
    "\u010e\u0007+\u0002\u0002\u010e\n\u0003\u0002\u0002\u0002\u010f\u0110",
    "\u0007=\u0002\u0002\u0110\f\u0003\u0002\u0002\u0002\u0111\u0112\u0007",
    "<\u0002\u0002\u0112\u000e\u0003\u0002\u0002\u0002\u0113\u0114\u0007",
    "}\u0002\u0002\u0114\u0010\u0003\u0002\u0002\u0002\u0115\u0116\u0007",
    "\u007f\u0002\u0002\u0116\u0012\u0003\u0002\u0002\u0002\u0117\u0118\u0007",
    "/\u0002\u0002\u0118\u0119\u0007@\u0002\u0002\u0119\u0014\u0003\u0002",
    "\u0002\u0002\u011a\u011b\u0007/\u0002\u0002\u011b\u0016\u0003\u0002",
    "\u0002\u0002\u011c\u011d\u0007?\u0002\u0002\u011d\u0018\u0003\u0002",
    "\u0002\u0002\u011e\u011f\u0007?\u0002\u0002\u011f\u0120\u0007?\u0002",
    "\u0002\u0120\u001a\u0003\u0002\u0002\u0002\u0121\u0122\u0007#\u0002",
    "\u0002\u0122\u0123\u0007?\u0002\u0002\u0123\u001c\u0003\u0002\u0002",
    "\u0002\u0124\u0125\u0007>\u0002\u0002\u0125\u0126\u0007@\u0002\u0002",
    "\u0126\u001e\u0003\u0002\u0002\u0002\u0127\u0128\u0007@\u0002\u0002",
    "\u0128 \u0003\u0002\u0002\u0002\u0129\u012a\u0007@\u0002\u0002\u012a",
    "\u012b\u0007?\u0002\u0002\u012b\"\u0003\u0002\u0002\u0002\u012c\u012d",
    "\u0007>\u0002\u0002\u012d$\u0003\u0002\u0002\u0002\u012e\u012f\u0007",
    ">\u0002\u0002\u012f\u0130\u0007?\u0002\u0002\u0130&\u0003\u0002\u0002",
    "\u0002\u0131\u0132\u00071\u0002\u0002\u0132(\u0003\u0002\u0002\u0002",
    "\u0133\u0134\u0007\'\u0002\u0002\u0134*\u0003\u0002\u0002\u0002\u0135",
    "\u0136\u0007-\u0002\u0002\u0136,\u0003\u0002\u0002\u0002\u0137\u0138",
    "\u0007~\u0002\u0002\u0138\u0139\u0007~\u0002\u0002\u0139.\u0003\u0002",
    "\u0002\u0002\u013a\u013b\u00070\u0002\u0002\u013b0\u0003\u0002\u0002",
    "\u0002\u013c\u013d\u0005\u00d1i\u0002\u013d\u013e\u0005\u00e7t\u0002",
    "\u013e\u013f\u0005\u00e7t\u0002\u013f2\u0003\u0002\u0002\u0002\u0140",
    "\u0141\u0005\u00d1i\u0002\u0141\u0142\u0005\u00ebv\u0002\u0142\u0143",
    "\u0005\u00d7l\u0002\u01434\u0003\u0002\u0002\u0002\u0144\u0145\u0005",
    "\u00d1i\u0002\u0145\u0146\u0005\u00f3z\u0002\u0146\u0147\u0005\u00f3",
    "z\u0002\u0147\u0148\u0005\u00d1i\u0002\u0148\u0149\u0005\u0101\u0081",
    "\u0002\u01496\u0003\u0002\u0002\u0002\u014a\u014b\u0005\u00d1i\u0002",
    "\u014b\u014c\u0005\u00f5{\u0002\u014c8\u0003\u0002\u0002\u0002\u014d",
    "\u014e\u0005\u00d1i\u0002\u014e\u014f\u0005\u00f5{\u0002\u014f\u0150",
    "\u0005\u00d5k\u0002\u0150:\u0003\u0002\u0002\u0002\u0151\u0152\u0005",
    "\u00d3j\u0002\u0152\u0153\u0005\u00d9m\u0002\u0153\u0154\u0005\u00f7",
    "|\u0002\u0154\u0155\u0005\u00fd\u007f\u0002\u0155\u0156\u0005\u00d9",
    "m\u0002\u0156\u0157\u0005\u00d9m\u0002\u0157\u0158\u0005\u00ebv\u0002",
    "\u0158<\u0003\u0002\u0002\u0002\u0159\u015a\u0005\u00d3j\u0002\u015a",
    "\u015b\u0005\u0101\u0081\u0002\u015b>\u0003\u0002\u0002\u0002\u015c",
    "\u015d\u0005\u00d5k\u0002\u015d\u015e\u0005\u00d1i\u0002\u015e\u015f",
    "\u0005\u00f5{\u0002\u015f\u0160\u0005\u00d9m\u0002\u0160@\u0003\u0002",
    "\u0002\u0002\u0161\u0162\u0005\u00d5k\u0002\u0162\u0163\u0005\u00df",
    "p\u0002\u0163\u0164\u0005\u00d9m\u0002\u0164\u0165\u0005\u00d5k\u0002",
    "\u0165\u0166\u0005\u00e5s\u0002\u0166\u0167\u0005\u00efx\u0002\u0167",
    "\u0168\u0005\u00edw\u0002\u0168\u0169\u0005\u00e1q\u0002\u0169\u016a",
    "\u0005\u00ebv\u0002\u016a\u016b\u0005\u00f7|\u0002\u016bB\u0003\u0002",
    "\u0002\u0002\u016c\u016d\u0005\u00d1i\u0002\u016d\u016e\u0005\u00f3",
    "z\u0002\u016e\u016f\u0005\u00f3z\u0002\u016f\u0170\u0005\u00d1i\u0002",
    "\u0170\u0171\u0005\u0101\u0081\u0002\u0171\u0172\u0005\u0105\u0083\u0002",
    "\u0172\u0173\u0005\u00edw\u0002\u0173\u0174\u0005\u00dbn\u0002\u0174",
    "D\u0003\u0002\u0002\u0002\u0175\u0176\u0005\u00f5{\u0002\u0176\u0177",
    "\u0005\u00f7|\u0002\u0177\u0178\u0005\u00f3z\u0002\u0178\u0179\u0005",
    "\u00f9}\u0002\u0179\u017a\u0005\u00d5k\u0002\u017a\u017b\u0005\u00f7",
    "|\u0002\u017b\u017c\u0005\u0105\u0083\u0002\u017c\u017d\u0005\u00ed",
    "w\u0002\u017d\u017e\u0005\u00dbn\u0002\u017eF\u0003\u0002\u0002\u0002",
    "\u017f\u0180\u0005\u00d5k\u0002\u0180\u0181\u0005\u00f3z\u0002\u0181",
    "\u0182\u0005\u00edw\u0002\u0182\u0183\u0005\u00f5{\u0002\u0183\u0184",
    "\u0005\u00f5{\u0002\u0184H\u0003\u0002\u0002\u0002\u0185\u0186\u0005",
    "\u00d5k\u0002\u0186\u0187\u0005\u00f9}\u0002\u0187\u0188\u0005\u00f3",
    "z\u0002\u0188\u0189\u0005\u00f3z\u0002\u0189\u018a\u0005\u00d9m\u0002",
    "\u018a\u018b\u0005\u00ebv\u0002\u018b\u018c\u0005\u00f7|\u0002\u018c",
    "J\u0003\u0002\u0002\u0002\u018d\u018e\u0005\u00d7l\u0002\u018e\u018f",
    "\u0005\u00d9m\u0002\u018f\u0190\u0005\u00f5{\u0002\u0190\u0191\u0005",
    "\u00d5k\u0002\u0191L\u0003\u0002\u0002\u0002\u0192\u0193\u0005\u00d7",
    "l\u0002\u0193\u0194\u0005\u00e1q\u0002\u0194\u0195\u0005\u00f5{\u0002",
    "\u0195\u0196\u0005\u00d1i\u0002\u0196\u0197\u0005\u00e9u\u0002\u0197",
    "\u0198\u0005\u00d3j\u0002\u0198\u0199\u0005\u00e1q\u0002\u0199\u019a",
    "\u0005\u00ddo\u0002\u019a\u019b\u0005\u00f9}\u0002\u019b\u019c\u0005",
    "\u00d1i\u0002\u019c\u019d\u0005\u00f7|\u0002\u019d\u019e\u0005\u00d9",
    "m\u0002\u019eN\u0003\u0002\u0002\u0002\u019f\u01a0\u0005\u00d7l\u0002",
    "\u01a0\u01a1\u0005\u00f3z\u0002\u01a1\u01a2\u0005\u00edw\u0002\u01a2",
    "\u01a3\u0005\u00efx\u0002\u01a3P\u0003\u0002\u0002\u0002\u01a4\u01a5",
    "\u0005\u00d9m\u0002\u01a5\u01a6\u0005\u00e7t\u0002\u01a6\u01a7\u0005",
    "\u00f5{\u0002\u01a7\u01a8\u0005\u00d9m\u0002\u01a8R\u0003\u0002\u0002",
    "\u0002\u01a9\u01aa\u0005\u00d9m\u0002\u01aa\u01ab\u0005\u00e9u\u0002",
    "\u01ab\u01ac\u0005\u00efx\u0002\u01ac\u01ad\u0005\u00f7|\u0002\u01ad",
    "\u01ae\u0005\u0101\u0081\u0002\u01aeT\u0003\u0002\u0002\u0002\u01af",
    "\u01b0\u0005\u00d9m\u0002\u01b0\u01b1\u0005\u00ebv\u0002\u01b1\u01b2",
    "\u0005\u00d7l\u0002\u01b2V\u0003\u0002\u0002\u0002\u01b3\u01b4\u0005",
    "\u00d9m\u0002\u01b4\u01b5\u0005\u00ebv\u0002\u01b5\u01b6\u0005\u00db",
    "n\u0002\u01b6\u01b7\u0005\u00edw\u0002\u01b7\u01b8\u0005\u00f3z\u0002",
    "\u01b8\u01b9\u0005\u00d5k\u0002\u01b9\u01ba\u0005\u00d9m\u0002\u01ba",
    "X\u0003\u0002\u0002\u0002\u01bb\u01bc\u0005\u00d9m\u0002\u01bc\u01bd",
    "\u0005\u00ff\u0080\u0002\u01bd\u01be\u0005\u00efx\u0002\u01be\u01bf",
    "\u0005\u00e7t\u0002\u01bf\u01c0\u0005\u00edw\u0002\u01c0\u01c1\u0005",
    "\u00d7l\u0002\u01c1\u01c2\u0005\u00d9m\u0002\u01c2Z\u0003\u0002\u0002",
    "\u0002\u01c3\u01c4\u0005\u00dbn\u0002\u01c4\u01c5\u0005\u00d1i\u0002",
    "\u01c5\u01c6\u0005\u00e7t\u0002\u01c6\u01c7\u0005\u00f5{\u0002\u01c7",
    "\u01c8\u0005\u00d9m\u0002\u01c8\\\u0003\u0002\u0002\u0002\u01c9\u01ca",
    "\u0005\u00dbn\u0002\u01ca\u01cb\u0005\u00e1q\u0002\u01cb\u01cc\u0005",
    "\u00e7t\u0002\u01cc\u01cd\u0005\u00f7|\u0002\u01cd\u01ce\u0005\u00d9",
    "m\u0002\u01ce\u01cf\u0005\u00f3z\u0002\u01cf^\u0003\u0002\u0002\u0002",
    "\u01d0\u01d1\u0005\u00dbn\u0002\u01d1\u01d2\u0005\u00e1q\u0002\u01d2",
    "\u01d3\u0005\u00f3z\u0002\u01d3\u01d4\u0005\u00f5{\u0002\u01d4\u01d5",
    "\u0005\u00f7|\u0002\u01d5`\u0003\u0002\u0002\u0002\u01d6\u01d7\u0005",
    "\u00dbn\u0002\u01d7\u01d8\u0005\u00edw\u0002\u01d8\u01d9\u0005\u00e7",
    "t\u0002\u01d9\u01da\u0005\u00e7t\u0002\u01da\u01db\u0005\u00edw\u0002",
    "\u01db\u01dc\u0005\u00fd\u007f\u0002\u01dc\u01dd\u0005\u00e1q\u0002",
    "\u01dd\u01de\u0005\u00ebv\u0002\u01de\u01df\u0005\u00ddo\u0002\u01df",
    "b\u0003\u0002\u0002\u0002\u01e0\u01e1\u0005\u00dbn\u0002\u01e1\u01e2",
    "\u0005\u00f3z\u0002\u01e2\u01e3\u0005\u00edw\u0002\u01e3\u01e4\u0005",
    "\u00e9u\u0002\u01e4d\u0003\u0002\u0002\u0002\u01e5\u01e6\u0005\u00db",
    "n\u0002\u01e6\u01e7\u0005\u00f9}\u0002\u01e7\u01e8\u0005\u00e7t\u0002",
    "\u01e8\u01e9\u0005\u00e7t\u0002\u01e9f\u0003\u0002\u0002\u0002\u01ea",
    "\u01eb\u0005\u00ddo\u0002\u01eb\u01ec\u0005\u00f3z\u0002\u01ec\u01ed",
    "\u0005\u00edw\u0002\u01ed\u01ee\u0005\u00f9}\u0002\u01ee\u01ef\u0005",
    "\u00efx\u0002\u01efh\u0003\u0002\u0002\u0002\u01f0\u01f1\u0005\u00df",
    "p\u0002\u01f1\u01f2\u0005\u00e1q\u0002\u01f2\u01f3\u0005\u00ebv\u0002",
    "\u01f3\u01f4\u0005\u00f7|\u0002\u01f4j\u0003\u0002\u0002\u0002\u01f5",
    "\u01f6\u0005\u00e1q\u0002\u01f6\u01f7\u0005\u00ebv\u0002\u01f7\u01f8",
    "\u0005\u00ebv\u0002\u01f8\u01f9\u0005\u00d9m\u0002\u01f9\u01fa\u0005",
    "\u00f3z\u0002\u01fal\u0003\u0002\u0002\u0002\u01fb\u01fc\u0005\u00e1",
    "q\u0002\u01fc\u01fd\u0005\u00f5{\u0002\u01fdn\u0003\u0002\u0002\u0002",
    "\u01fe\u01ff\u0005\u00e3r\u0002\u01ff\u0200\u0005\u00edw\u0002\u0200",
    "\u0201\u0005\u00e1q\u0002\u0201\u0202\u0005\u00ebv\u0002\u0202p\u0003",
    "\u0002\u0002\u0002\u0203\u0204\u0005\u00e5s\u0002\u0204\u0205\u0005",
    "\u00d9m\u0002\u0205\u0206\u0005\u0101\u0081\u0002\u0206r\u0003\u0002",
    "\u0002\u0002\u0207\u0208\u0005\u00e7t\u0002\u0208\u0209\u0005\u00d1",
    "i\u0002\u0209\u020a\u0005\u00e9u\u0002\u020a\u020b\u0005\u00d3j\u0002",
    "\u020b\u020c\u0005\u00d7l\u0002\u020c\u020d\u0005\u00d1i\u0002\u020d",
    "t\u0003\u0002\u0002\u0002\u020e\u020f\u0005\u00e7t\u0002\u020f\u0210",
    "\u0005\u00d1i\u0002\u0210\u0211\u0005\u00f5{\u0002\u0211\u0212\u0005",
    "\u00f7|\u0002\u0212v\u0003\u0002\u0002\u0002\u0213\u0214\u0005\u00e7",
    "t\u0002\u0214\u0215\u0005\u00edw\u0002\u0215\u0216\u0005\u00edw\u0002",
    "\u0216\u0217\u0005\u00e5s\u0002\u0217\u0218\u0005\u00f9}\u0002\u0218",
    "\u0219\u0005\u00efx\u0002\u0219x\u0003\u0002\u0002\u0002\u021a\u021b",
    "\u0005\u00e7t\u0002\u021b\u021c\u0005\u00d9m\u0002\u021c\u021d\u0005",
    "\u00dbn\u0002\u021d\u021e\u0005\u00f7|\u0002\u021ez\u0003\u0002\u0002",
    "\u0002\u021f\u0220\u0005\u00e9u\u0002\u0220\u0221\u0005\u00d1i\u0002",
    "\u0221\u0222\u0005\u00efx\u0002\u0222|\u0003\u0002\u0002\u0002\u0223",
    "\u0224\u0005\u00e9u\u0002\u0224\u0225\u0005\u00d9m\u0002\u0225\u0226",
    "\u0005\u00f3z\u0002\u0226\u0227\u0005\u00ddo\u0002\u0227\u0228\u0005",
    "\u00d9m\u0002\u0228~\u0003\u0002\u0002\u0002\u0229\u022a\u0005\u00eb",
    "v\u0002\u022a\u022b\u0005\u00edw\u0002\u022b\u022c\u0005\u00f7|\u0002",
    "\u022c\u0080\u0003\u0002\u0002\u0002\u022d\u022e\u0005\u00ebv\u0002",
    "\u022e\u022f\u0005\u00f9}\u0002\u022f\u0230\u0005\u00e7t\u0002\u0230",
    "\u0231\u0005\u00e7t\u0002\u0231\u0082\u0003\u0002\u0002\u0002\u0232",
    "\u0233\u0005\u00ebv\u0002\u0233\u0234\u0005\u00f9}\u0002\u0234\u0235",
    "\u0005\u00e7t\u0002\u0235\u0236\u0005\u00e7t\u0002\u0236\u0237\u0005",
    "\u00f5{\u0002\u0237\u0084\u0003\u0002\u0002\u0002\u0238\u0239\u0005",
    "\u00edw\u0002\u0239\u023a\u0005\u00ebv\u0002\u023a\u0086\u0003\u0002",
    "\u0002\u0002\u023b\u023c\u0005\u00edw\u0002\u023c\u023d\u0005\u00f3",
    "z\u0002\u023d\u0088\u0003\u0002\u0002\u0002\u023e\u023f\u0005\u00ed",
    "w\u0002\u023f\u0240\u0005\u00f3z\u0002\u0240\u0241\u0005\u00d7l\u0002",
    "\u0241\u0242\u0005\u00d9m\u0002\u0242\u0243\u0005\u00f3z\u0002\u0243",
    "\u008a\u0003\u0002\u0002\u0002\u0244\u0245\u0005\u00edw\u0002\u0245",
    "\u0246\u0005\u00f9}\u0002\u0246\u0247\u0005\u00f7|\u0002\u0247\u0248",
    "\u0005\u00d9m\u0002\u0248\u0249\u0005\u00f3z\u0002\u0249\u008c\u0003",
    "\u0002\u0002\u0002\u024a\u024b\u0005\u00efx\u0002\u024b\u024c\u0005",
    "\u00e1q\u0002\u024c\u024d\u0005\u00fb~\u0002\u024d\u024e\u0005\u00ed",
    "w\u0002\u024e\u024f\u0005\u00f7|\u0002\u024f\u008e\u0003\u0002\u0002",
    "\u0002\u0250\u0251\u0005\u00efx\u0002\u0251\u0252\u0005\u00f3z\u0002",
    "\u0252\u0253\u0005\u00d9m\u0002\u0253\u0254\u0005\u00d5k\u0002\u0254",
    "\u0255\u0005\u00d9m\u0002\u0255\u0256\u0005\u00d7l\u0002\u0256\u0257",
    "\u0005\u00e1q\u0002\u0257\u0258\u0005\u00ebv\u0002\u0258\u0259\u0005",
    "\u00ddo\u0002\u0259\u0090\u0003\u0002\u0002\u0002\u025a\u025b\u0005",
    "\u00efx\u0002\u025b\u025c\u0005\u00f3z\u0002\u025c\u025d\u0005\u00e1",
    "q\u0002\u025d\u025e\u0005\u00e9u\u0002\u025e\u025f\u0005\u00d1i\u0002",
    "\u025f\u0260\u0005\u00f3z\u0002\u0260\u0261\u0005\u0101\u0081\u0002",
    "\u0261\u0092\u0003\u0002\u0002\u0002\u0262\u0263\u0005\u00f3z\u0002",
    "\u0263\u0264\u0005\u00d1i\u0002\u0264\u0265\u0005\u00ebv\u0002\u0265",
    "\u0266\u0005\u00ddo\u0002\u0266\u0267\u0005\u00d9m\u0002\u0267\u0094",
    "\u0003\u0002\u0002\u0002\u0268\u0269\u0005\u00f3z\u0002\u0269\u026a",
    "\u0005\u00d9m\u0002\u026a\u026b\u0005\u00d7l\u0002\u026b\u026c\u0005",
    "\u00f9}\u0002\u026c\u026d\u0005\u00d5k\u0002\u026d\u026e\u0005\u00d9",
    "m\u0002\u026e\u0096\u0003\u0002\u0002\u0002\u026f\u0270\u0005\u00f3",
    "z\u0002\u0270\u0271\u0005\u00d9m\u0002\u0271\u0272\u0005\u00efx\u0002",
    "\u0272\u0273\u0005\u00d1i\u0002\u0273\u0274\u0005\u00f3z\u0002\u0274",
    "\u0275\u0005\u00f7|\u0002\u0275\u0276\u0005\u00e1q\u0002\u0276\u0277",
    "\u0005\u00f7|\u0002\u0277\u0278\u0005\u00e1q\u0002\u0278\u0279\u0005",
    "\u00edw\u0002\u0279\u027a\u0005\u00ebv\u0002\u027a\u0098\u0003\u0002",
    "\u0002\u0002\u027b\u027c\u0005\u00f3z\u0002\u027c\u027d\u0005\u00e1",
    "q\u0002\u027d\u027e\u0005\u00ddo\u0002\u027e\u027f\u0005\u00dfp\u0002",
    "\u027f\u0280\u0005\u00f7|\u0002\u0280\u009a\u0003\u0002\u0002\u0002",
    "\u0281\u0282\u0005\u00f3z\u0002\u0282\u0283\u0005\u00edw\u0002\u0283",
    "\u0284\u0005\u00fd\u007f\u0002\u0284\u009c\u0003\u0002\u0002\u0002\u0285",
    "\u0286\u0005\u00f3z\u0002\u0286\u0287\u0005\u00edw\u0002\u0287\u0288",
    "\u0005\u00fd\u007f\u0002\u0288\u0289\u0005\u00f5{\u0002\u0289\u009e",
    "\u0003\u0002\u0002\u0002\u028a\u028b\u0005\u00f5{\u0002\u028b\u028c",
    "\u0005\u00d9m\u0002\u028c\u028d\u0005\u00e7t\u0002\u028d\u028e\u0005",
    "\u00d9m\u0002\u028e\u028f\u0005\u00d5k\u0002\u028f\u0290\u0005\u00f7",
    "|\u0002\u0290\u00a0\u0003\u0002\u0002\u0002\u0291\u0292\u0005\u00f7",
    "|\u0002\u0292\u0293\u0005\u00dfp\u0002\u0293\u0294\u0005\u00d9m\u0002",
    "\u0294\u0295\u0005\u00ebv\u0002\u0295\u00a2\u0003\u0002\u0002\u0002",
    "\u0296\u0297\u0005\u00f7|\u0002\u0297\u0298\u0005\u00f3z\u0002\u0298",
    "\u0299\u0005\u00f9}\u0002\u0299\u029a\u0005\u00d9m\u0002\u029a\u00a4",
    "\u0003\u0002\u0002\u0002\u029b\u029c\u0005\u00f9}\u0002\u029c\u029d",
    "\u0005\u00ebv\u0002\u029d\u029e\u0005\u00d3j\u0002\u029e\u029f\u0005",
    "\u00edw\u0002\u029f\u02a0\u0005\u00f9}\u0002\u02a0\u02a1\u0005\u00eb",
    "v\u0002\u02a1\u02a2\u0005\u00d7l\u0002\u02a2\u02a3\u0005\u00d9m\u0002",
    "\u02a3\u02a4\u0005\u00d7l\u0002\u02a4\u00a6\u0003\u0002\u0002\u0002",
    "\u02a5\u02a6\u0005\u00f9}\u0002\u02a6\u02a7\u0005\u00ebv\u0002\u02a7",
    "\u02a8\u0005\u00e1q\u0002\u02a8\u02a9\u0005\u00edw\u0002\u02a9\u02aa",
    "\u0005\u00ebv\u0002\u02aa\u00a8\u0003\u0002\u0002\u0002\u02ab\u02ac",
    "\u0005\u00f9}\u0002\u02ac\u02ad\u0005\u00ebv\u0002\u02ad\u02ae\u0005",
    "\u00efx\u0002\u02ae\u02af\u0005\u00e1q\u0002\u02af\u02b0\u0005\u00fb",
    "~\u0002\u02b0\u02b1\u0005\u00edw\u0002\u02b1\u02b2\u0005\u00f7|\u0002",
    "\u02b2\u00aa\u0003\u0002\u0002\u0002\u02b3\u02b4\u0005\u00f9}\u0002",
    "\u02b4\u02b5\u0005\u00f5{\u0002\u02b5\u02b6\u0005\u00d9m\u0002\u02b6",
    "\u00ac\u0003\u0002\u0002\u0002\u02b7\u02b8\u0005\u00fd\u007f\u0002\u02b8",
    "\u02b9\u0005\u00e1q\u0002\u02b9\u02ba\u0005\u00ebv\u0002\u02ba\u02bb",
    "\u0005\u00d7l\u0002\u02bb\u02bc\u0005\u00edw\u0002\u02bc\u02bd\u0005",
    "\u00fd\u007f\u0002\u02bd\u00ae\u0003\u0002\u0002\u0002\u02be\u02bf\u0005",
    "\u00fd\u007f\u0002\u02bf\u02c0\u0005\u00e1q\u0002\u02c0\u02c1\u0005",
    "\u00f7|\u0002\u02c1\u02c2\u0005\u00dfp\u0002\u02c2\u00b0\u0003\u0002",
    "\u0002\u0002\u02c3\u02c4\u0005\u00fd\u007f\u0002\u02c4\u02c5\u0005\u00df",
    "p\u0002\u02c5\u02c6\u0005\u00d9m\u0002\u02c6\u02c7\u0005\u00ebv\u0002",
    "\u02c7\u00b2\u0003\u0002\u0002\u0002\u02c8\u02c9\u0005\u00f5{\u0002",
    "\u02c9\u02ca\u0005\u00d1i\u0002\u02ca\u02cb\u0005\u00e9u\u0002\u02cb",
    "\u02cc\u0005\u00efx\u0002\u02cc\u02cd\u0005\u00e7t\u0002\u02cd\u02ce",
    "\u0005\u00d9m\u0002\u02ce\u00b4\u0003\u0002\u0002\u0002\u02cf\u02d0",
    "\u0005\u00f5{\u0002\u02d0\u02d1\u0005\u00d9m\u0002\u02d1\u02d2\u0005",
    "\u00d9m\u0002\u02d2\u02d3\u0005\u00d7l\u0002\u02d3\u00b6\u0003\u0002",
    "\u0002\u0002\u02d4\u02d9\u0007)\u0002\u0002\u02d5\u02d8\u0005\u00cb",
    "f\u0002\u02d6\u02d8\n\u0002\u0002\u0002\u02d7\u02d5\u0003\u0002\u0002",
    "\u0002\u02d7\u02d6\u0003\u0002\u0002\u0002\u02d8\u02db\u0003\u0002\u0002",
    "\u0002\u02d9\u02d7\u0003\u0002\u0002\u0002\u02d9\u02da\u0003\u0002\u0002",
    "\u0002\u02da\u02dc\u0003\u0002\u0002\u0002\u02db\u02d9\u0003\u0002\u0002",
    "\u0002\u02dc\u02dd\u0007)\u0002\u0002\u02dd\u00b8\u0003\u0002\u0002",
    "\u0002\u02de\u02df\u0005\u00bb^\u0002\u02df\u02e0\u0007N\u0002\u0002",
    "\u02e0\u00ba\u0003\u0002\u0002\u0002\u02e1\u02e3\u0007/\u0002\u0002",
    "\u02e2\u02e1\u0003\u0002\u0002\u0002\u02e2\u02e3\u0003\u0002\u0002\u0002",
    "\u02e3\u02e5\u0003\u0002\u0002\u0002\u02e4\u02e6\u0005\u00cdg\u0002",
    "\u02e5\u02e4\u0003\u0002\u0002\u0002\u02e6\u02e7\u0003\u0002\u0002\u0002",
    "\u02e7\u02e5\u0003\u0002\u0002\u0002\u02e7\u02e8\u0003\u0002\u0002\u0002",
    "\u02e8\u00bc\u0003\u0002\u0002\u0002\u02e9\u02eb\u0007/\u0002\u0002",
    "\u02ea\u02e9\u0003\u0002\u0002\u0002\u02ea\u02eb\u0003\u0002\u0002\u0002",
    "\u02eb\u02ed\u0003\u0002\u0002\u0002\u02ec\u02ee\u0005\u00cdg\u0002",
    "\u02ed\u02ec\u0003\u0002\u0002\u0002\u02ee\u02ef\u0003\u0002\u0002\u0002",
    "\u02ef\u02ed\u0003\u0002\u0002\u0002\u02ef\u02f0\u0003\u0002\u0002\u0002",
    "\u02f0\u02f8\u0003\u0002\u0002\u0002\u02f1\u02f5\u00070\u0002\u0002",
    "\u02f2\u02f4\u0005\u00cdg\u0002\u02f3\u02f2\u0003\u0002\u0002\u0002",
    "\u02f4\u02f7\u0003\u0002\u0002\u0002\u02f5\u02f3\u0003\u0002\u0002\u0002",
    "\u02f5\u02f6\u0003\u0002\u0002\u0002\u02f6\u02f9\u0003\u0002\u0002\u0002",
    "\u02f7\u02f5\u0003\u0002\u0002\u0002\u02f8\u02f1\u0003\u0002\u0002\u0002",
    "\u02f8\u02f9\u0003\u0002\u0002\u0002\u02f9\u0303\u0003\u0002\u0002\u0002",
    "\u02fa\u02fc\u0005\u00d9m\u0002\u02fb\u02fd\t\u0003\u0002\u0002\u02fc",
    "\u02fb\u0003\u0002\u0002\u0002\u02fc\u02fd\u0003\u0002\u0002\u0002\u02fd",
    "\u02ff\u0003\u0002\u0002\u0002\u02fe\u0300\u0005\u00cdg\u0002\u02ff",
    "\u02fe\u0003\u0002\u0002\u0002\u0300\u0301\u0003\u0002\u0002\u0002\u0301",
    "\u02ff\u0003\u0002\u0002\u0002\u0301\u0302\u0003\u0002\u0002\u0002\u0302",
    "\u0304\u0003\u0002\u0002\u0002\u0303\u02fa\u0003\u0002\u0002\u0002\u0303",
    "\u0304\u0003\u0002\u0002\u0002\u0304\u0328\u0003\u0002\u0002\u0002\u0305",
    "\u0307\u0007/\u0002\u0002\u0306\u0305\u0003\u0002\u0002\u0002\u0306",
    "\u0307\u0003\u0002\u0002\u0002\u0307\u0308\u0003\u0002\u0002\u0002\u0308",
    "\u030a\u00070\u0002\u0002\u0309\u030b\u0005\u00cdg\u0002\u030a\u0309",
    "\u0003\u0002\u0002\u0002\u030b\u030c\u0003\u0002\u0002\u0002\u030c\u030a",
    "\u0003\u0002\u0002\u0002\u030c\u030d\u0003\u0002\u0002\u0002\u030d\u0317",
    "\u0003\u0002\u0002\u0002\u030e\u0310\u0005\u00d9m\u0002\u030f\u0311",
    "\t\u0003\u0002\u0002\u0310\u030f\u0003\u0002\u0002\u0002\u0310\u0311",
    "\u0003\u0002\u0002\u0002\u0311\u0313\u0003\u0002\u0002\u0002\u0312\u0314",
    "\u0005\u00cdg\u0002\u0313\u0312\u0003\u0002\u0002\u0002\u0314\u0315",
    "\u0003\u0002\u0002\u0002\u0315\u0313\u0003\u0002\u0002\u0002\u0315\u0316",
    "\u0003\u0002\u0002\u0002\u0316\u0318\u0003\u0002\u0002\u0002\u0317\u030e",
    "\u0003\u0002\u0002\u0002\u0317\u0318\u0003\u0002\u0002\u0002\u0318\u0328",
    "\u0003\u0002\u0002\u0002\u0319\u031b\u0007/\u0002\u0002\u031a\u0319",
    "\u0003\u0002\u0002\u0002\u031a\u031b\u0003\u0002\u0002\u0002\u031b\u031c",
    "\u0003\u0002\u0002\u0002\u031c\u031d\u0007K\u0002\u0002\u031d\u031e",
    "\u0007p\u0002\u0002\u031e\u031f\u0007h\u0002\u0002\u031f\u0320\u0007",
    "k\u0002\u0002\u0320\u0321\u0007p\u0002\u0002\u0321\u0322\u0007k\u0002",
    "\u0002\u0322\u0323\u0007v\u0002\u0002\u0323\u0328\u0007{\u0002\u0002",
    "\u0324\u0325\u0007P\u0002\u0002\u0325\u0326\u0007c\u0002\u0002\u0326",
    "\u0328\u0007P\u0002\u0002\u0327\u02ea\u0003\u0002\u0002\u0002\u0327",
    "\u0306\u0003\u0002\u0002\u0002\u0327\u031a\u0003\u0002\u0002\u0002\u0327",
    "\u0324\u0003\u0002\u0002\u0002\u0328\u00be\u0003\u0002\u0002\u0002\u0329",
    "\u032d\t\u0004\u0002\u0002\u032a\u032c\t\u0005\u0002\u0002\u032b\u032a",
    "\u0003\u0002\u0002\u0002\u032c\u032f\u0003\u0002\u0002\u0002\u032d\u032b",
    "\u0003\u0002\u0002\u0002\u032d\u032e\u0003\u0002\u0002\u0002\u032e\u033b",
    "\u0003\u0002\u0002\u0002\u032f\u032d\u0003\u0002\u0002\u0002\u0330\u0336",
    "\u0007$\u0002\u0002\u0331\u0335\n\u0006\u0002\u0002\u0332\u0333\u0007",
    "$\u0002\u0002\u0333\u0335\u0007$\u0002\u0002\u0334\u0331\u0003\u0002",
    "\u0002\u0002\u0334\u0332\u0003\u0002\u0002\u0002\u0335\u0338\u0003\u0002",
    "\u0002\u0002\u0336\u0334\u0003\u0002\u0002\u0002\u0336\u0337\u0003\u0002",
    "\u0002\u0002\u0337\u0339\u0003\u0002\u0002\u0002\u0338\u0336\u0003\u0002",
    "\u0002\u0002\u0339\u033b\u0007$\u0002\u0002\u033a\u0329\u0003\u0002",
    "\u0002\u0002\u033a\u0330\u0003\u0002\u0002\u0002\u033b\u00c0\u0003\u0002",
    "\u0002\u0002\u033c\u033e\t\u0007\u0002\u0002\u033d\u033c\u0003\u0002",
    "\u0002\u0002\u033e\u033f\u0003\u0002\u0002\u0002\u033f\u033d\u0003\u0002",
    "\u0002\u0002\u033f\u0340\u0003\u0002\u0002\u0002\u0340\u0341\u0003\u0002",
    "\u0002\u0002\u0341\u0342\ba\u0002\u0002\u0342\u00c2\u0003\u0002\u0002",
    "\u0002\u0343\u0344\u0007/\u0002\u0002\u0344\u0345\u0007/\u0002\u0002",
    "\u0345\u0349\u0003\u0002\u0002\u0002\u0346\u0348\n\b\u0002\u0002\u0347",
    "\u0346\u0003\u0002\u0002\u0002\u0348\u034b\u0003\u0002\u0002\u0002\u0349",
    "\u0347\u0003\u0002\u0002\u0002\u0349\u034a\u0003\u0002\u0002\u0002\u034a",
    "\u034c\u0003\u0002\u0002\u0002\u034b\u0349\u0003\u0002\u0002\u0002\u034c",
    "\u034d\bb\u0003\u0002\u034d\u00c4\u0003\u0002\u0002\u0002\u034e\u034f",
    "\u00071\u0002\u0002\u034f\u0350\u00071\u0002\u0002\u0350\u0354\u0003",
    "\u0002\u0002\u0002\u0351\u0353\n\b\u0002\u0002\u0352\u0351\u0003\u0002",
    "\u0002\u0002\u0353\u0356\u0003\u0002\u0002\u0002\u0354\u0352\u0003\u0002",
    "\u0002\u0002\u0354\u0355\u0003\u0002\u0002\u0002\u0355\u0357\u0003\u0002",
    "\u0002\u0002\u0356\u0354\u0003\u0002\u0002\u0002\u0357\u0358\bc\u0003",
    "\u0002\u0358\u00c6\u0003\u0002\u0002\u0002\u0359\u035a\u00071\u0002",
    "\u0002\u035a\u035b\u0007,\u0002\u0002\u035b\u035f\u0003\u0002\u0002",
    "\u0002\u035c\u035e\u000b\u0002\u0002\u0002\u035d\u035c\u0003\u0002\u0002",
    "\u0002\u035e\u0361\u0003\u0002\u0002\u0002\u035f\u0360\u0003\u0002\u0002",
    "\u0002\u035f\u035d\u0003\u0002\u0002\u0002\u0360\u0362\u0003\u0002\u0002",
    "\u0002\u0361\u035f\u0003\u0002\u0002\u0002\u0362\u0363\u0007,\u0002",
    "\u0002\u0363\u0364\u00071\u0002\u0002\u0364\u0365\u0003\u0002\u0002",
    "\u0002\u0365\u0366\bd\u0003\u0002\u0366\u00c8\u0003\u0002\u0002\u0002",
    "\u0367\u0368\u00071\u0002\u0002\u0368\u0369\u0007,\u0002\u0002\u0369",
    "\u0372\u0003\u0002\u0002\u0002\u036a\u0371\n\t\u0002\u0002\u036b\u036e",
    "\u0007,\u0002\u0002\u036c\u036f\n\n\u0002\u0002\u036d\u036f\u0007\u0002",
    "\u0002\u0003\u036e\u036c\u0003\u0002\u0002\u0002\u036e\u036d\u0003\u0002",
    "\u0002\u0002\u036f\u0371\u0003\u0002\u0002\u0002\u0370\u036a\u0003\u0002",
    "\u0002\u0002\u0370\u036b\u0003\u0002\u0002\u0002\u0371\u0374\u0003\u0002",
    "\u0002\u0002\u0372\u0370\u0003\u0002\u0002\u0002\u0372\u0373\u0003\u0002",
    "\u0002\u0002\u0373\u0375\u0003\u0002\u0002\u0002\u0374\u0372\u0003\u0002",
    "\u0002\u0002\u0375\u0376\u0007\u0002\u0002\u0003\u0376\u0377\u0003\u0002",
    "\u0002\u0002\u0377\u0378\be\u0004\u0002\u0378\u00ca\u0003\u0002\u0002",
    "\u0002\u0379\u0381\u0007^\u0002\u0002\u037a\u0382\t\u000b\u0002\u0002",
    "\u037b\u037c\u0007w\u0002\u0002\u037c\u037d\u0005\u00cfh\u0002\u037d",
    "\u037e\u0005\u00cfh\u0002\u037e\u037f\u0005\u00cfh\u0002\u037f\u0380",
    "\u0005\u00cfh\u0002\u0380\u0382\u0003\u0002\u0002\u0002\u0381\u037a",
    "\u0003\u0002\u0002\u0002\u0381\u037b\u0003\u0002\u0002\u0002\u0382\u00cc",
    "\u0003\u0002\u0002\u0002\u0383\u0384\t\f\u0002\u0002\u0384\u00ce\u0003",
    "\u0002\u0002\u0002\u0385\u0386\t\r\u0002\u0002\u0386\u00d0\u0003\u0002",
    "\u0002\u0002\u0387\u0388\t\u000e\u0002\u0002\u0388\u00d2\u0003\u0002",
    "\u0002\u0002\u0389\u038a\t\u000f\u0002\u0002\u038a\u00d4\u0003\u0002",
    "\u0002\u0002\u038b\u038c\t\u0010\u0002\u0002\u038c\u00d6\u0003\u0002",
    "\u0002\u0002\u038d\u038e\t\u0011\u0002\u0002\u038e\u00d8\u0003\u0002",
    "\u0002\u0002\u038f\u0390\t\u0012\u0002\u0002\u0390\u00da\u0003\u0002",
    "\u0002\u0002\u0391\u0392\t\u0013\u0002\u0002\u0392\u00dc\u0003\u0002",
    "\u0002\u0002\u0393\u0394\t\u0014\u0002\u0002\u0394\u00de\u0003\u0002",
    "\u0002\u0002\u0395\u0396\t\u0015\u0002\u0002\u0396\u00e0\u0003\u0002",
    "\u0002\u0002\u0397\u0398\t\u0016\u0002\u0002\u0398\u00e2\u0003\u0002",
    "\u0002\u0002\u0399\u039a\t\u0017\u0002\u0002\u039a\u00e4\u0003\u0002",
    "\u0002\u0002\u039b\u039c\t\u0018\u0002\u0002\u039c\u00e6\u0003\u0002",
    "\u0002\u0002\u039d\u039e\t\u0019\u0002\u0002\u039e\u00e8\u0003\u0002",
    "\u0002\u0002\u039f\u03a0\t\u001a\u0002\u0002\u03a0\u00ea\u0003\u0002",
    "\u0002\u0002\u03a1\u03a2\t\u001b\u0002\u0002\u03a2\u00ec\u0003\u0002",
    "\u0002\u0002\u03a3\u03a4\t\u001c\u0002\u0002\u03a4\u00ee\u0003\u0002",
    "\u0002\u0002\u03a5\u03a6\t\u001d\u0002\u0002\u03a6\u00f0\u0003\u0002",
    "\u0002\u0002\u03a7\u03a8\t\u001e\u0002\u0002\u03a8\u00f2\u0003\u0002",
    "\u0002\u0002\u03a9\u03aa\t\u001f\u0002\u0002\u03aa\u00f4\u0003\u0002",
    "\u0002\u0002\u03ab\u03ac\t \u0002\u0002\u03ac\u00f6\u0003\u0002\u0002",
    "\u0002\u03ad\u03ae\t!\u0002\u0002\u03ae\u00f8\u0003\u0002\u0002\u0002",
    "\u03af\u03b0\t\"\u0002\u0002\u03b0\u00fa\u0003\u0002\u0002\u0002\u03b1",
    "\u03b2\t#\u0002\u0002\u03b2\u00fc\u0003\u0002\u0002\u0002\u03b3\u03b4",
    "\t$\u0002\u0002\u03b4\u00fe\u0003\u0002\u0002\u0002\u03b5\u03b6\t%\u0002",
    "\u0002\u03b6\u0100\u0003\u0002\u0002\u0002\u03b7\u03b8\t&\u0002\u0002",
    "\u03b8\u0102\u0003\u0002\u0002\u0002\u03b9\u03ba\t\'\u0002\u0002\u03ba",
    "\u0104\u0003\u0002\u0002\u0002\u03bb\u03bc\u00070\u0002\u0002\u03bc",
    "\u0106\u0003\u0002\u0002\u0002!\u0002\u02d7\u02d9\u02e2\u02e7\u02ea",
    "\u02ef\u02f5\u02f8\u02fc\u0301\u0303\u0306\u030c\u0310\u0315\u0317\u031a",
    "\u0327\u032d\u0334\u0336\u033a\u033f\u0349\u0354\u035f\u036e\u0370\u0372",
    "\u0381\u0005\u0002\u0003\u0002\u0002\u0004\u0002\u0002\u0005\u0002"].join("");


var atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

var decisionsToDFA = atn.decisionToState.map( function(ds, index) { return new antlr4.dfa.DFA(ds, index); });

function TransformsLexer(input) {
	antlr4.Lexer.call(this, input);
    this._interp = new antlr4.atn.LexerATNSimulator(this, atn, decisionsToDFA, new antlr4.PredictionContextCache());
    return this;
}

TransformsLexer.prototype = Object.create(antlr4.Lexer.prototype);
TransformsLexer.prototype.constructor = TransformsLexer;

TransformsLexer.EOF = antlr4.Token.EOF;
TransformsLexer.T__0 = 1;
TransformsLexer.T__1 = 2;
TransformsLexer.T__2 = 3;
TransformsLexer.T__3 = 4;
TransformsLexer.T__4 = 5;
TransformsLexer.T__5 = 6;
TransformsLexer.T__6 = 7;
TransformsLexer.T__7 = 8;
TransformsLexer.T__8 = 9;
TransformsLexer.T__9 = 10;
TransformsLexer.T__10 = 11;
TransformsLexer.T__11 = 12;
TransformsLexer.T__12 = 13;
TransformsLexer.T__13 = 14;
TransformsLexer.T__14 = 15;
TransformsLexer.T__15 = 16;
TransformsLexer.T__16 = 17;
TransformsLexer.T__17 = 18;
TransformsLexer.T__18 = 19;
TransformsLexer.T__19 = 20;
TransformsLexer.T__20 = 21;
TransformsLexer.T__21 = 22;
TransformsLexer.T__22 = 23;
TransformsLexer.K_ALL = 24;
TransformsLexer.K_AND = 25;
TransformsLexer.K_ARRAY = 26;
TransformsLexer.K_AS = 27;
TransformsLexer.K_ASC = 28;
TransformsLexer.K_BETWEEN = 29;
TransformsLexer.K_BY = 30;
TransformsLexer.K_CASE = 31;
TransformsLexer.K_CHECKPOINT = 32;
TransformsLexer.K_CONVERT_ARRAY = 33;
TransformsLexer.K_CONVERT_STRUCT = 34;
TransformsLexer.K_CROSS = 35;
TransformsLexer.K_CURRENT = 36;
TransformsLexer.K_DESC = 37;
TransformsLexer.K_DISAMBIGUATE = 38;
TransformsLexer.K_DROP = 39;
TransformsLexer.K_ELSE = 40;
TransformsLexer.K_EMPTY = 41;
TransformsLexer.K_END = 42;
TransformsLexer.K_ENFORCE = 43;
TransformsLexer.K_EXPLODE = 44;
TransformsLexer.K_FALSE = 45;
TransformsLexer.K_FILTER = 46;
TransformsLexer.K_FIRST = 47;
TransformsLexer.K_FOLLOWING = 48;
TransformsLexer.K_FROM = 49;
TransformsLexer.K_FULL = 50;
TransformsLexer.K_GROUP = 51;
TransformsLexer.K_HINT = 52;
TransformsLexer.K_INNER = 53;
TransformsLexer.K_IS = 54;
TransformsLexer.K_JOIN = 55;
TransformsLexer.K_KEY = 56;
TransformsLexer.K_LAMBDA = 57;
TransformsLexer.K_LAST = 58;
TransformsLexer.K_LOOKUP = 59;
TransformsLexer.K_LEFT = 60;
TransformsLexer.K_MAP = 61;
TransformsLexer.K_MERGE = 62;
TransformsLexer.K_NOT = 63;
TransformsLexer.K_NULL = 64;
TransformsLexer.K_NULLS = 65;
TransformsLexer.K_ON = 66;
TransformsLexer.K_OR = 67;
TransformsLexer.K_ORDER = 68;
TransformsLexer.K_OUTER = 69;
TransformsLexer.K_PIVOT = 70;
TransformsLexer.K_PRECEDING = 71;
TransformsLexer.K_PRIMARY = 72;
TransformsLexer.K_RANGE = 73;
TransformsLexer.K_REDUCE = 74;
TransformsLexer.K_REPARTITION = 75;
TransformsLexer.K_RIGHT = 76;
TransformsLexer.K_ROW = 77;
TransformsLexer.K_ROWS = 78;
TransformsLexer.K_SELECT = 79;
TransformsLexer.K_THEN = 80;
TransformsLexer.K_TRUE = 81;
TransformsLexer.K_UNBOUNDED = 82;
TransformsLexer.K_UNION = 83;
TransformsLexer.K_UNPIVOT = 84;
TransformsLexer.K_USE = 85;
TransformsLexer.K_WINDOW = 86;
TransformsLexer.K_WITH = 87;
TransformsLexer.K_WHEN = 88;
TransformsLexer.K_SAMPLE = 89;
TransformsLexer.K_SEED = 90;
TransformsLexer.STRING_LITERAL = 91;
TransformsLexer.LONG_LITERAL = 92;
TransformsLexer.INTEGER_LITERAL = 93;
TransformsLexer.NUMERIC_LITERAL = 94;
TransformsLexer.IDENTIFIER = 95;
TransformsLexer.SPACES = 96;
TransformsLexer.SINGLE_LINE_COMMENT_SQL = 97;
TransformsLexer.SINGLE_LINE_COMMENT_C = 98;
TransformsLexer.MULTILINE_COMMENT = 99;
TransformsLexer.UNCLOSED_MULTILINE_COMMENT = 100;

TransformsLexer.prototype.channelNames = [ "DEFAULT_TOKEN_CHANNEL", "HIDDEN" ];

TransformsLexer.prototype.modeNames = [ "DEFAULT_MODE" ];

TransformsLexer.prototype.literalNames = [ null, "'*'", "','", "'('", "')'", 
                                           "';'", "':'", "'{'", "'}'", "'->'", 
                                           "'-'", "'='", "'=='", "'!='", 
                                           "'<>'", "'>'", "'>='", "'<'", 
                                           "'<='", "'/'", "'%'", "'+'", 
                                           "'||'", "'.'" ];

TransformsLexer.prototype.symbolicNames = [ null, null, null, null, null, 
                                            null, null, null, null, null, 
                                            null, null, null, null, null, 
                                            null, null, null, null, null, 
                                            null, null, null, null, "K_ALL", 
                                            "K_AND", "K_ARRAY", "K_AS", 
                                            "K_ASC", "K_BETWEEN", "K_BY", 
                                            "K_CASE", "K_CHECKPOINT", "K_CONVERT_ARRAY", 
                                            "K_CONVERT_STRUCT", "K_CROSS", 
                                            "K_CURRENT", "K_DESC", "K_DISAMBIGUATE", 
                                            "K_DROP", "K_ELSE", "K_EMPTY", 
                                            "K_END", "K_ENFORCE", "K_EXPLODE", 
                                            "K_FALSE", "K_FILTER", "K_FIRST", 
                                            "K_FOLLOWING", "K_FROM", "K_FULL", 
                                            "K_GROUP", "K_HINT", "K_INNER", 
                                            "K_IS", "K_JOIN", "K_KEY", "K_LAMBDA", 
                                            "K_LAST", "K_LOOKUP", "K_LEFT", 
                                            "K_MAP", "K_MERGE", "K_NOT", 
                                            "K_NULL", "K_NULLS", "K_ON", 
                                            "K_OR", "K_ORDER", "K_OUTER", 
                                            "K_PIVOT", "K_PRECEDING", "K_PRIMARY", 
                                            "K_RANGE", "K_REDUCE", "K_REPARTITION", 
                                            "K_RIGHT", "K_ROW", "K_ROWS", 
                                            "K_SELECT", "K_THEN", "K_TRUE", 
                                            "K_UNBOUNDED", "K_UNION", "K_UNPIVOT", 
                                            "K_USE", "K_WINDOW", "K_WITH", 
                                            "K_WHEN", "K_SAMPLE", "K_SEED", 
                                            "STRING_LITERAL", "LONG_LITERAL", 
                                            "INTEGER_LITERAL", "NUMERIC_LITERAL", 
                                            "IDENTIFIER", "SPACES", "SINGLE_LINE_COMMENT_SQL", 
                                            "SINGLE_LINE_COMMENT_C", "MULTILINE_COMMENT", 
                                            "UNCLOSED_MULTILINE_COMMENT" ];

TransformsLexer.prototype.ruleNames = [ "T__0", "T__1", "T__2", "T__3", 
                                        "T__4", "T__5", "T__6", "T__7", 
                                        "T__8", "T__9", "T__10", "T__11", 
                                        "T__12", "T__13", "T__14", "T__15", 
                                        "T__16", "T__17", "T__18", "T__19", 
                                        "T__20", "T__21", "T__22", "K_ALL", 
                                        "K_AND", "K_ARRAY", "K_AS", "K_ASC", 
                                        "K_BETWEEN", "K_BY", "K_CASE", "K_CHECKPOINT", 
                                        "K_CONVERT_ARRAY", "K_CONVERT_STRUCT", 
                                        "K_CROSS", "K_CURRENT", "K_DESC", 
                                        "K_DISAMBIGUATE", "K_DROP", "K_ELSE", 
                                        "K_EMPTY", "K_END", "K_ENFORCE", 
                                        "K_EXPLODE", "K_FALSE", "K_FILTER", 
                                        "K_FIRST", "K_FOLLOWING", "K_FROM", 
                                        "K_FULL", "K_GROUP", "K_HINT", "K_INNER", 
                                        "K_IS", "K_JOIN", "K_KEY", "K_LAMBDA", 
                                        "K_LAST", "K_LOOKUP", "K_LEFT", 
                                        "K_MAP", "K_MERGE", "K_NOT", "K_NULL", 
                                        "K_NULLS", "K_ON", "K_OR", "K_ORDER", 
                                        "K_OUTER", "K_PIVOT", "K_PRECEDING", 
                                        "K_PRIMARY", "K_RANGE", "K_REDUCE", 
                                        "K_REPARTITION", "K_RIGHT", "K_ROW", 
                                        "K_ROWS", "K_SELECT", "K_THEN", 
                                        "K_TRUE", "K_UNBOUNDED", "K_UNION", 
                                        "K_UNPIVOT", "K_USE", "K_WINDOW", 
                                        "K_WITH", "K_WHEN", "K_SAMPLE", 
                                        "K_SEED", "STRING_LITERAL", "LONG_LITERAL", 
                                        "INTEGER_LITERAL", "NUMERIC_LITERAL", 
                                        "IDENTIFIER", "SPACES", "SINGLE_LINE_COMMENT_SQL", 
                                        "SINGLE_LINE_COMMENT_C", "MULTILINE_COMMENT", 
                                        "UNCLOSED_MULTILINE_COMMENT", "ESC", 
                                        "DIGIT", "HEX", "A", "B", "C", "D", 
                                        "E", "F", "G", "H", "I", "J", "K", 
                                        "L", "M", "N", "O", "P", "Q", "R", 
                                        "S", "T", "U", "V", "W", "X", "Y", 
                                        "Z", "DOT" ];

TransformsLexer.prototype.grammarFileName = "Transforms.g4";



exports.TransformsLexer = TransformsLexer;



/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

// Generated from /home/teamcity/TeamCity/buildAgent/temp/buildTmp/tmp-100813XKcWzE2qNJ8/Transforms.g4 by ANTLR 4.7
// jshint ignore: start
var antlr4 = __webpack_require__(0);
var TransformsListener = __webpack_require__(1).TransformsListener;
var TransformsVisitor = __webpack_require__(2).TransformsVisitor;

var grammarFileName = "Transforms.g4";

var serializedATN = ["\u0003\u608b\ua72a\u8133\ub9ed\u417c\u3be7\u7786\u5964",
    "\u0003f\u0367\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004\u0004\t",
    "\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007\t\u0007\u0004",
    "\b\t\b\u0004\t\t\t\u0004\n\t\n\u0004\u000b\t\u000b\u0004\f\t\f\u0004",
    "\r\t\r\u0004\u000e\t\u000e\u0004\u000f\t\u000f\u0004\u0010\t\u0010\u0004",
    "\u0011\t\u0011\u0004\u0012\t\u0012\u0004\u0013\t\u0013\u0004\u0014\t",
    "\u0014\u0004\u0015\t\u0015\u0004\u0016\t\u0016\u0004\u0017\t\u0017\u0004",
    "\u0018\t\u0018\u0004\u0019\t\u0019\u0004\u001a\t\u001a\u0004\u001b\t",
    "\u001b\u0004\u001c\t\u001c\u0004\u001d\t\u001d\u0004\u001e\t\u001e\u0004",
    "\u001f\t\u001f\u0004 \t \u0004!\t!\u0004\"\t\"\u0004#\t#\u0004$\t$\u0004",
    "%\t%\u0004&\t&\u0004\'\t\'\u0004(\t(\u0004)\t)\u0004*\t*\u0004+\t+\u0004",
    ",\t,\u0004-\t-\u0004.\t.\u0004/\t/\u00040\t0\u00041\t1\u00042\t2\u0004",
    "3\t3\u00044\t4\u00045\t5\u00046\t6\u00047\t7\u00048\t8\u00049\t9\u0004",
    ":\t:\u0004;\t;\u0004<\t<\u0004=\t=\u0004>\t>\u0004?\t?\u0004@\t@\u0004",
    "A\tA\u0004B\tB\u0004C\tC\u0004D\tD\u0004E\tE\u0004F\tF\u0004G\tG\u0004",
    "H\tH\u0004I\tI\u0004J\tJ\u0004K\tK\u0004L\tL\u0004M\tM\u0003\u0002\u0003",
    "\u0002\u0003\u0002\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003",
    "\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003",
    "\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003",
    "\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003",
    "\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003",
    "\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0006\u0003\u00be\n\u0003",
    "\r\u0003\u000e\u0003\u00bf\u0003\u0003\u0003\u0003\u0003\u0003\u0003",
    "\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0007\u0003\u00ca",
    "\n\u0003\f\u0003\u000e\u0003\u00cd\u000b\u0003\u0003\u0003\u0003\u0003",
    "\u0003\u0003\u0003\u0003\u0007\u0003\u00d3\n\u0003\f\u0003\u000e\u0003",
    "\u00d6\u000b\u0003\u0003\u0003\u0005\u0003\u00d9\n\u0003\u0003\u0004",
    "\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004",
    "\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004",
    "\u0007\u0004\u00e8\n\u0004\f\u0004\u000e\u0004\u00eb\u000b\u0004\u0003",
    "\u0004\u0003\u0004\u0003\u0005\u0003\u0005\u0003\u0005\u0003\u0005\u0003",
    "\u0006\u0003\u0006\u0005\u0006\u00f5\n\u0006\u0003\u0007\u0003\u0007",
    "\u0003\u0007\u0003\b\u0005\b\u00fb\n\b\u0003\b\u0003\b\u0005\b\u00ff",
    "\n\b\u0007\b\u0101\n\b\f\b\u000e\b\u0104\u000b\b\u0003\t\u0003\t\u0003",
    "\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003",
    "\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003",
    "\t\u0003\t\u0003\t\u0005\t\u011d\n\t\u0003\n\u0003\n\u0003\n\u0005\n",
    "\u0122\n\n\u0003\u000b\u0003\u000b\u0005\u000b\u0126\n\u000b\u0003\u000b",
    "\u0003\u000b\u0003\u000b\u0003\f\u0003\f\u0003\f\u0003\f\u0003\r\u0003",
    "\r\u0005\r\u0131\n\r\u0003\r\u0003\r\u0003\r\u0005\r\u0136\n\r\u0003",
    "\r\u0005\r\u0139\n\r\u0005\r\u013b\n\r\u0003\u000e\u0003\u000e\u0005",
    "\u000e\u013f\n\u000e\u0003\u000e\u0007\u000e\u0142\n\u000e\f\u000e\u000e",
    "\u000e\u0145\u000b\u000e\u0003\u000e\u0005\u000e\u0148\n\u000e\u0003",
    "\u000e\u0003\u000e\u0005\u000e\u014c\n\u000e\u0003\u000f\u0003\u000f",
    "\u0003\u000f\u0003\u000f\u0007\u000f\u0152\n\u000f\f\u000f\u000e\u000f",
    "\u0155\u000b\u000f\u0005\u000f\u0157\n\u000f\u0003\u0010\u0003\u0010",
    "\u0003\u0010\u0003\u0010\u0007\u0010\u015d\n\u0010\f\u0010\u000e\u0010",
    "\u0160\u000b\u0010\u0005\u0010\u0162\n\u0010\u0003\u0011\u0003\u0011",
    "\u0003\u0011\u0003\u0011\u0003\u0011\u0003\u0011\u0005\u0011\u016a\n",
    "\u0011\u0003\u0011\u0003\u0011\u0003\u0011\u0005\u0011\u016f\n\u0011",
    "\u0003\u0012\u0003\u0012\u0005\u0012\u0173\n\u0012\u0003\u0012\u0005",
    "\u0012\u0176\n\u0012\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0014",
    "\u0005\u0014\u017c\n\u0014\u0003\u0014\u0003\u0014\u0005\u0014\u0180",
    "\n\u0014\u0003\u0014\u0003\u0014\u0003\u0014\u0005\u0014\u0185\n\u0014",
    "\u0003\u0014\u0003\u0014\u0003\u0014\u0005\u0014\u018a\n\u0014\u0003",
    "\u0015\u0003\u0015\u0003\u0015\u0003\u0015\u0003\u0015\u0007\u0015\u0191",
    "\n\u0015\f\u0015\u000e\u0015\u0194\u000b\u0015\u0005\u0015\u0196\n\u0015",
    "\u0003\u0016\u0003\u0016\u0003\u0016\u0005\u0016\u019b\n\u0016\u0003",
    "\u0016\u0005\u0016\u019e\n\u0016\u0003\u0017\u0003\u0017\u0005\u0017",
    "\u01a2\n\u0017\u0003\u0018\u0003\u0018\u0005\u0018\u01a6\n\u0018\u0003",
    "\u0018\u0003\u0018\u0005\u0018\u01aa\n\u0018\u0003\u0019\u0003\u0019",
    "\u0003\u001a\u0003\u001a\u0003\u001a\u0003\u001a\u0005\u001a\u01b2\n",
    "\u001a\u0003\u001a\u0003\u001a\u0003\u001b\u0003\u001b\u0003\u001b\u0005",
    "\u001b\u01b9\n\u001b\u0003\u001b\u0003\u001b\u0003\u001b\u0003\u001c",
    "\u0003\u001c\u0005\u001c\u01c0\n\u001c\u0003\u001c\u0003\u001c\u0005",
    "\u001c\u01c4\n\u001c\u0003\u001d\u0003\u001d\u0005\u001d\u01c8\n\u001d",
    "\u0003\u001e\u0005\u001e\u01cb\n\u001e\u0003\u001e\u0003\u001e\u0005",
    "\u001e\u01cf\n\u001e\u0003\u001f\u0003\u001f\u0003\u001f\u0003\u001f",
    "\u0003 \u0003 \u0003 \u0003 \u0005 \u01d9\n \u0003 \u0003 \u0003 \u0005",
    " \u01de\n \u0005 \u01e0\n \u0003!\u0003!\u0003!\u0005!\u01e5\n!\u0003",
    "\"\u0003\"\u0003\"\u0005\"\u01ea\n\"\u0003#\u0003#\u0005#\u01ee\n#\u0003",
    "#\u0003#\u0005#\u01f2\n#\u0003$\u0003$\u0003$\u0003$\u0003%\u0003%\u0005",
    "%\u01fa\n%\u0003%\u0003%\u0003&\u0003&\u0003&\u0007&\u0201\n&\f&\u000e",
    "&\u0204\u000b&\u0003\'\u0003\'\u0003\'\u0007\'\u0209\n\'\f\'\u000e\'",
    "\u020c\u000b\'\u0003(\u0003(\u0003(\u0003(\u0003(\u0005(\u0213\n(\u0003",
    "(\u0003(\u0005(\u0217\n(\u0003(\u0003(\u0005(\u021b\n(\u0005(\u021d",
    "\n(\u0003)\u0003)\u0003)\u0003)\u0003)\u0005)\u0224\n)\u0003*\u0003",
    "*\u0003*\u0005*\u0229\n*\u0003+\u0005+\u022c\n+\u0003+\u0003+\u0003",
    ",\u0005,\u0231\n,\u0003,\u0003,\u0003-\u0003-\u0005-\u0237\n-\u0003",
    "-\u0003-\u0005-\u023b\n-\u0003.\u0003.\u0003.\u0005.\u0240\n.\u0003",
    "/\u0003/\u0003/\u0003/\u0003/\u00030\u00030\u00030\u00030\u00030\u0003",
    "0\u00030\u00030\u00030\u00030\u00030\u00030\u00050\u0253\n0\u00031\u0003",
    "1\u00031\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u0003",
    "2\u00052\u0261\n2\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u0003",
    "2\u00032\u00032\u00032\u00052\u026e\n2\u00032\u00072\u0271\n2\f2\u000e",
    "2\u0274\u000b2\u00032\u00052\u0277\n2\u00032\u00032\u00032\u00032\u0003",
    "2\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u0003",
    "2\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u0003",
    "2\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u0003",
    "2\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u00052\u02a4",
    "\n2\u00032\u00052\u02a7\n2\u00032\u00032\u00052\u02ab\n2\u00032\u0003",
    "2\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u0003",
    "2\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u0003",
    "2\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u0003",
    "2\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u0003",
    "2\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u0003",
    "2\u00032\u00032\u00032\u00032\u00032\u00032\u00032\u00072\u02e8\n2\f",
    "2\u000e2\u02eb\u000b2\u00033\u00033\u00033\u00033\u00033\u00034\u0003",
    "4\u00054\u02f4\n4\u00034\u00034\u00035\u00035\u00035\u00075\u02fb\n",
    "5\f5\u000e5\u02fe\u000b5\u00036\u00036\u00036\u00036\u00036\u00056\u0305",
    "\n6\u00037\u00037\u00038\u00038\u00039\u00039\u0003:\u0003:\u0003;\u0003",
    ";\u0003<\u0003<\u0003=\u0003=\u0003>\u0003>\u0003>\u0003>\u0003>\u0003",
    "?\u0003?\u0003?\u0003@\u0003@\u0005@\u031f\n@\u0003A\u0003A\u0005A\u0323",
    "\nA\u0003A\u0003A\u0003A\u0003B\u0003B\u0003C\u0003C\u0005C\u032c\n",
    "C\u0003D\u0003D\u0003E\u0003E\u0003E\u0005E\u0333\nE\u0003E\u0003E\u0003",
    "F\u0003F\u0003G\u0003G\u0003G\u0007G\u033c\nG\fG\u000eG\u033f\u000b",
    "G\u0003H\u0003H\u0003H\u0007H\u0344\nH\fH\u000eH\u0347\u000bH\u0003",
    "I\u0003I\u0003I\u0007I\u034c\nI\fI\u000eI\u034f\u000bI\u0003J\u0003",
    "J\u0003J\u0005J\u0354\nJ\u0007J\u0356\nJ\fJ\u000eJ\u0359\u000bJ\u0003",
    "K\u0003K\u0003L\u0007L\u035e\nL\fL\u000eL\u0361\u000bL\u0003L\u0003",
    "L\u0003M\u0003M\u0003M\u0002\u0003bN\u0002\u0004\u0006\b\n\f\u000e\u0010",
    "\u0012\u0014\u0016\u0018\u001a\u001c\u001e \"$&(*,.02468:<>@BDFHJLN",
    "PRTVXZ\\^`bdfhjlnprtvxz|~\u0080\u0082\u0084\u0086\u0088\u008a\u008c",
    "\u008e\u0090\u0092\u0094\u0096\u0098\u0002\n\u0004\u000277GG\u0004\u0002",
    "\u001e\u001e\'\'\u0004\u000211<<\u0004\u0002KKPP\u0003\u0002\r\u000e",
    "\u0003\u0002\u000f\u0010\u0014\u0002\u001a\u001a\u001c\u001c\u001f\u001f",
    "\"\"&&()--129:<=CCIKOPTTVVXX[\\aa\u0003\u0002ce\u0002\u03b7\u0002\u009a",
    "\u0003\u0002\u0002\u0002\u0004\u00d8\u0003\u0002\u0002\u0002\u0006\u00da",
    "\u0003\u0002\u0002\u0002\b\u00ee\u0003\u0002\u0002\u0002\n\u00f4\u0003",
    "\u0002\u0002\u0002\f\u00f6\u0003\u0002\u0002\u0002\u000e\u00fa\u0003",
    "\u0002\u0002\u0002\u0010\u011c\u0003\u0002\u0002\u0002\u0012\u011e\u0003",
    "\u0002\u0002\u0002\u0014\u0123\u0003\u0002\u0002\u0002\u0016\u012a\u0003",
    "\u0002\u0002\u0002\u0018\u012e\u0003\u0002\u0002\u0002\u001a\u013c\u0003",
    "\u0002\u0002\u0002\u001c\u014d\u0003\u0002\u0002\u0002\u001e\u0158\u0003",
    "\u0002\u0002\u0002 \u0163\u0003\u0002\u0002\u0002\"\u0170\u0003\u0002",
    "\u0002\u0002$\u0177\u0003\u0002\u0002\u0002&\u017b\u0003\u0002\u0002",
    "\u0002(\u018b\u0003\u0002\u0002\u0002*\u0197\u0003\u0002\u0002\u0002",
    ",\u019f\u0003\u0002\u0002\u0002.\u01a3\u0003\u0002\u0002\u00020\u01ab",
    "\u0003\u0002\u0002\u00022\u01ad\u0003\u0002\u0002\u00024\u01b5\u0003",
    "\u0002\u0002\u00026\u01bd\u0003\u0002\u0002\u00028\u01c5\u0003\u0002",
    "\u0002\u0002:\u01ca\u0003\u0002\u0002\u0002<\u01d0\u0003\u0002\u0002",
    "\u0002>\u01d4\u0003\u0002\u0002\u0002@\u01e1\u0003\u0002\u0002\u0002",
    "B\u01e6\u0003\u0002\u0002\u0002D\u01eb\u0003\u0002\u0002\u0002F\u01f3",
    "\u0003\u0002\u0002\u0002H\u01f7\u0003\u0002\u0002\u0002J\u01fd\u0003",
    "\u0002\u0002\u0002L\u0205\u0003\u0002\u0002\u0002N\u021c\u0003\u0002",
    "\u0002\u0002P\u0223\u0003\u0002\u0002\u0002R\u0225\u0003\u0002\u0002",
    "\u0002T\u022b\u0003\u0002\u0002\u0002V\u0230\u0003\u0002\u0002\u0002",
    "X\u0234\u0003\u0002\u0002\u0002Z\u023c\u0003\u0002\u0002\u0002\\\u0241",
    "\u0003\u0002\u0002\u0002^\u0252\u0003\u0002\u0002\u0002`\u0254\u0003",
    "\u0002\u0002\u0002b\u02aa\u0003\u0002\u0002\u0002d\u02ec\u0003\u0002",
    "\u0002\u0002f\u02f1\u0003\u0002\u0002\u0002h\u02f7\u0003\u0002\u0002",
    "\u0002j\u0304\u0003\u0002\u0002\u0002l\u0306\u0003\u0002\u0002\u0002",
    "n\u0308\u0003\u0002\u0002\u0002p\u030a\u0003\u0002\u0002\u0002r\u030c",
    "\u0003\u0002\u0002\u0002t\u030e\u0003\u0002\u0002\u0002v\u0310\u0003",
    "\u0002\u0002\u0002x\u0312\u0003\u0002\u0002\u0002z\u0314\u0003\u0002",
    "\u0002\u0002|\u0319\u0003\u0002\u0002\u0002~\u031e\u0003\u0002\u0002",
    "\u0002\u0080\u0320\u0003\u0002\u0002\u0002\u0082\u0327\u0003\u0002\u0002",
    "\u0002\u0084\u032b\u0003\u0002\u0002\u0002\u0086\u032d\u0003\u0002\u0002",
    "\u0002\u0088\u032f\u0003\u0002\u0002\u0002\u008a\u0336\u0003\u0002\u0002",
    "\u0002\u008c\u0338\u0003\u0002\u0002\u0002\u008e\u0340\u0003\u0002\u0002",
    "\u0002\u0090\u0348\u0003\u0002\u0002\u0002\u0092\u0350\u0003\u0002\u0002",
    "\u0002\u0094\u035a\u0003\u0002\u0002\u0002\u0096\u035f\u0003\u0002\u0002",
    "\u0002\u0098\u0364\u0003\u0002\u0002\u0002\u009a\u009b\u0005\u0004\u0003",
    "\u0002\u009b\u009c\u0007\u0002\u0002\u0003\u009c\u0003\u0003\u0002\u0002",
    "\u0002\u009d\u009e\u0007Q\u0002\u0002\u009e\u009f\u0007\u0003\u0002",
    "\u0002\u009f\u00a0\u0007\u0004\u0002\u0002\u00a0\u00a1\u0007]\u0002",
    "\u0002\u00a1\u00a2\u0007\u001d\u0002\u0002\u00a2\u00d9\u0005\u0092J",
    "\u0002\u00a3\u00a4\u0007Q\u0002\u0002\u00a4\u00a5\u0007\u0003\u0002",
    "\u0002\u00a5\u00a6\u0007\u0004\u0002\u0002\u00a6\u00a7\u0007!\u0002",
    "\u0002\u00a7\u00a8\u0007Z\u0002\u0002\u00a8\u00a9\u0005\u0092J\u0002",
    "\u00a9\u00aa\u00078\u0002\u0002\u00aa\u00ab\u0007A\u0002\u0002\u00ab",
    "\u00ac\u0007+\u0002\u0002\u00ac\u00ad\u0007R\u0002\u0002\u00ad\u00ae",
    "\u0005\u0092J\u0002\u00ae\u00af\u0007*\u0002\u0002\u00af\u00b0\u0007",
    "\u001c\u0002\u0002\u00b0\u00b1\u0007\u0005\u0002\u0002\u00b1\u00b2\u0007",
    "]\u0002\u0002\u00b2\u00b3\u0007\u0006\u0002\u0002\u00b3\u00b4\u0007",
    ",\u0002\u0002\u00b4\u00b5\u0007\u001d\u0002\u0002\u00b5\u00b6\u0005",
    "\u0092J\u0002\u00b6\u00d9\u0003\u0002\u0002\u0002\u00b7\u00b8\u0007",
    "Q\u0002\u0002\u00b8\u00b9\u0007\u0003\u0002\u0002\u00b9\u00ba\u0007",
    "\u0004\u0002\u0002\u00ba\u00bd\u0005\b\u0005\u0002\u00bb\u00bc\u0007",
    "\u0004\u0002\u0002\u00bc\u00be\u0005\b\u0005\u0002\u00bd\u00bb\u0003",
    "\u0002\u0002\u0002\u00be\u00bf\u0003\u0002\u0002\u0002\u00bf\u00bd\u0003",
    "\u0002\u0002\u0002\u00bf\u00c0\u0003\u0002\u0002\u0002\u00c0\u00d9\u0003",
    "\u0002\u0002\u0002\u00c1\u00c2\u0007Q\u0002\u0002\u00c2\u00c3\u0007",
    "\u0003\u0002\u0002\u00c3\u00c4\u0007\u0004\u0002\u0002\u00c4\u00c5\u0005",
    "b2\u0002\u00c5\u00c6\u0007\u001d\u0002\u0002\u00c6\u00cb\u0005\u0092",
    "J\u0002\u00c7\u00c8\u0007\u0004\u0002\u0002\u00c8\u00ca\u0005\u0092",
    "J\u0002\u00c9\u00c7\u0003\u0002\u0002\u0002\u00ca\u00cd\u0003\u0002",
    "\u0002\u0002\u00cb\u00c9\u0003\u0002\u0002\u0002\u00cb\u00cc\u0003\u0002",
    "\u0002\u0002\u00cc\u00d9\u0003\u0002\u0002\u0002\u00cd\u00cb\u0003\u0002",
    "\u0002\u0002\u00ce\u00cf\u0007V\u0002\u0002\u00cf\u00d4\u0005\u0006",
    "\u0004\u0002\u00d0\u00d1\u0007\u0004\u0002\u0002\u00d1\u00d3\u0005\u0006",
    "\u0004\u0002\u00d2\u00d0\u0003\u0002\u0002\u0002\u00d3\u00d6\u0003\u0002",
    "\u0002\u0002\u00d4\u00d2\u0003\u0002\u0002\u0002\u00d4\u00d5\u0003\u0002",
    "\u0002\u0002\u00d5\u00d9\u0003\u0002\u0002\u0002\u00d6\u00d4\u0003\u0002",
    "\u0002\u0002\u00d7\u00d9\u0005\u000e\b\u0002\u00d8\u009d\u0003\u0002",
    "\u0002\u0002\u00d8\u00a3\u0003\u0002\u0002\u0002\u00d8\u00b7\u0003\u0002",
    "\u0002\u0002\u00d8\u00c1\u0003\u0002\u0002\u0002\u00d8\u00ce\u0003\u0002",
    "\u0002\u0002\u00d8\u00d7\u0003\u0002\u0002\u0002\u00d9\u0005\u0003\u0002",
    "\u0002\u0002\u00da\u00db\u0007\u0005\u0002\u0002\u00db\u00dc\u0007]",
    "\u0002\u0002\u00dc\u00dd\u0007\u001d\u0002\u0002\u00dd\u00de\u0005\u0092",
    "J\u0002\u00de\u00df\u0007\u0004\u0002\u0002\u00df\u00e0\u0005\u0092",
    "J\u0002\u00e0\u00e1\u0007\u001d\u0002\u0002\u00e1\u00e9\u0005\u0092",
    "J\u0002\u00e2\u00e3\u0007\u0004\u0002\u0002\u00e3\u00e4\u0005\n\u0006",
    "\u0002\u00e4\u00e5\u0007\u001d\u0002\u0002\u00e5\u00e6\u0005\u0092J",
    "\u0002\u00e6\u00e8\u0003\u0002\u0002\u0002\u00e7\u00e2\u0003\u0002\u0002",
    "\u0002\u00e8\u00eb\u0003\u0002\u0002\u0002\u00e9\u00e7\u0003\u0002\u0002",
    "\u0002\u00e9\u00ea\u0003\u0002\u0002\u0002\u00ea\u00ec\u0003\u0002\u0002",
    "\u0002\u00eb\u00e9\u0003\u0002\u0002\u0002\u00ec\u00ed\u0007\u0006\u0002",
    "\u0002\u00ed\u0007\u0003\u0002\u0002\u0002\u00ee\u00ef\u0005b2\u0002",
    "\u00ef\u00f0\u0007\u001d\u0002\u0002\u00f0\u00f1\u0005\u0092J\u0002",
    "\u00f1\t\u0003\u0002\u0002\u0002\u00f2\u00f5\u0005\u0092J\u0002\u00f3",
    "\u00f5\u0007B\u0002\u0002\u00f4\u00f2\u0003\u0002\u0002\u0002\u00f4",
    "\u00f3\u0003\u0002\u0002\u0002\u00f5\u000b\u0003\u0002\u0002\u0002\u00f6",
    "\u00f7\u0005\u000e\b\u0002\u00f7\u00f8\u0007\u0002\u0002\u0003\u00f8",
    "\r\u0003\u0002\u0002\u0002\u00f9\u00fb\u0005\u0010\t\u0002\u00fa\u00f9",
    "\u0003\u0002\u0002\u0002\u00fa\u00fb\u0003\u0002\u0002\u0002\u00fb\u0102",
    "\u0003\u0002\u0002\u0002\u00fc\u00fe\u0007\u0007\u0002\u0002\u00fd\u00ff",
    "\u0005\u0010\t\u0002\u00fe\u00fd\u0003\u0002\u0002\u0002\u00fe\u00ff",
    "\u0003\u0002\u0002\u0002\u00ff\u0101\u0003\u0002\u0002\u0002\u0100\u00fc",
    "\u0003\u0002\u0002\u0002\u0101\u0104\u0003\u0002\u0002\u0002\u0102\u0100",
    "\u0003\u0002\u0002\u0002\u0102\u0103\u0003\u0002\u0002\u0002\u0103\u000f",
    "\u0003\u0002\u0002\u0002\u0104\u0102\u0003\u0002\u0002\u0002\u0105\u011d",
    "\u0005\u0012\n\u0002\u0106\u011d\u0005\u0014\u000b\u0002\u0107\u011d",
    "\u0005\u0016\f\u0002\u0108\u011d\u0005\u0018\r\u0002\u0109\u011d\u0005",
    "\u001a\u000e\u0002\u010a\u011d\u0005\u001c\u000f\u0002\u010b\u011d\u0005",
    "\"\u0012\u0002\u010c\u011d\u0005$\u0013\u0002\u010d\u011d\u0005&\u0014",
    "\u0002\u010e\u011d\u0005(\u0015\u0002\u010f\u011d\u0005*\u0016\u0002",
    "\u0110\u011d\u0005,\u0017\u0002\u0111\u011d\u0005.\u0018\u0002\u0112",
    "\u011d\u00050\u0019\u0002\u0113\u011d\u00052\u001a\u0002\u0114\u011d",
    "\u00054\u001b\u0002\u0115\u011d\u00056\u001c\u0002\u0116\u011d\u0005",
    "8\u001d\u0002\u0117\u011d\u0005:\u001e\u0002\u0118\u011d\u0005 \u0011",
    "\u0002\u0119\u011d\u0005<\u001f\u0002\u011a\u011d\u0005\u001e\u0010",
    "\u0002\u011b\u011d\u0005> \u0002\u011c\u0105\u0003\u0002\u0002\u0002",
    "\u011c\u0106\u0003\u0002\u0002\u0002\u011c\u0107\u0003\u0002\u0002\u0002",
    "\u011c\u0108\u0003\u0002\u0002\u0002\u011c\u0109\u0003\u0002\u0002\u0002",
    "\u011c\u010a\u0003\u0002\u0002\u0002\u011c\u010b\u0003\u0002\u0002\u0002",
    "\u011c\u010c\u0003\u0002\u0002\u0002\u011c\u010d\u0003\u0002\u0002\u0002",
    "\u011c\u010e\u0003\u0002\u0002\u0002\u011c\u010f\u0003\u0002\u0002\u0002",
    "\u011c\u0110\u0003\u0002\u0002\u0002\u011c\u0111\u0003\u0002\u0002\u0002",
    "\u011c\u0112\u0003\u0002\u0002\u0002\u011c\u0113\u0003\u0002\u0002\u0002",
    "\u011c\u0114\u0003\u0002\u0002\u0002\u011c\u0115\u0003\u0002\u0002\u0002",
    "\u011c\u0116\u0003\u0002\u0002\u0002\u011c\u0117\u0003\u0002\u0002\u0002",
    "\u011c\u0118\u0003\u0002\u0002\u0002\u011c\u0119\u0003\u0002\u0002\u0002",
    "\u011c\u011a\u0003\u0002\u0002\u0002\u011c\u011b\u0003\u0002\u0002\u0002",
    "\u011d\u0011\u0003\u0002\u0002\u0002\u011e\u0121\u0007Q\u0002\u0002",
    "\u011f\u0122\u0005@!\u0002\u0120\u0122\u0005B\"\u0002\u0121\u011f\u0003",
    "\u0002\u0002\u0002\u0121\u0120\u0003\u0002\u0002\u0002\u0121\u0122\u0003",
    "\u0002\u0002\u0002\u0122\u0013\u0003\u0002\u0002\u0002\u0123\u0125\u0007",
    "5\u0002\u0002\u0124\u0126\u0005J&\u0002\u0125\u0124\u0003\u0002\u0002",
    "\u0002\u0125\u0126\u0003\u0002\u0002\u0002\u0126\u0127\u0003\u0002\u0002",
    "\u0002\u0127\u0128\u0007 \u0002\u0002\u0128\u0129\u0005\u0090I\u0002",
    "\u0129\u0015\u0003\u0002\u0002\u0002\u012a\u012b\u0007@\u0002\u0002",
    "\u012b\u012c\u0007 \u0002\u0002\u012c\u012d\u0005\u0090I\u0002\u012d",
    "\u0017\u0003\u0002\u0002\u0002\u012e\u0130\u0007X\u0002\u0002\u012f",
    "\u0131\u0005J&\u0002\u0130\u012f\u0003\u0002\u0002\u0002\u0130\u0131",
    "\u0003\u0002\u0002\u0002\u0131\u013a\u0003\u0002\u0002\u0002\u0132\u0133",
    "\u0007 \u0002\u0002\u0133\u0135\u0005\u0090I\u0002\u0134\u0136\u0005",
    "(\u0015\u0002\u0135\u0134\u0003\u0002\u0002\u0002\u0135\u0136\u0003",
    "\u0002\u0002\u0002\u0136\u0138\u0003\u0002\u0002\u0002\u0137\u0139\u0005",
    "Z.\u0002\u0138\u0137\u0003\u0002\u0002\u0002\u0138\u0139\u0003\u0002",
    "\u0002\u0002\u0139\u013b\u0003\u0002\u0002\u0002\u013a\u0132\u0003\u0002",
    "\u0002\u0002\u013a\u013b\u0003\u0002\u0002\u0002\u013b\u0019\u0003\u0002",
    "\u0002\u0002\u013c\u013e\u0007H\u0002\u0002\u013d\u013f\u0005L\'\u0002",
    "\u013e\u013d\u0003\u0002\u0002\u0002\u013e\u013f\u0003\u0002\u0002\u0002",
    "\u013f\u0143\u0003\u0002\u0002\u0002\u0140\u0142\u0005D#\u0002\u0141",
    "\u0140\u0003\u0002\u0002\u0002\u0142\u0145\u0003\u0002\u0002\u0002\u0143",
    "\u0141\u0003\u0002\u0002\u0002\u0143\u0144\u0003\u0002\u0002\u0002\u0144",
    "\u0147\u0003\u0002\u0002\u0002\u0145\u0143\u0003\u0002\u0002\u0002\u0146",
    "\u0148\u0005F$\u0002\u0147\u0146\u0003\u0002\u0002\u0002\u0147\u0148",
    "\u0003\u0002\u0002\u0002\u0148\u014b\u0003\u0002\u0002\u0002\u0149\u014c",
    "\u0005\u0014\u000b\u0002\u014a\u014c\u0005\u0016\f\u0002\u014b\u0149",
    "\u0003\u0002\u0002\u0002\u014b\u014a\u0003\u0002\u0002\u0002\u014c\u001b",
    "\u0003\u0002\u0002\u0002\u014d\u0156\u0007V\u0002\u0002\u014e\u0153",
    "\u0005H%\u0002\u014f\u0150\u0007\u0004\u0002\u0002\u0150\u0152\u0005",
    "H%\u0002\u0151\u014f\u0003\u0002\u0002\u0002\u0152\u0155\u0003\u0002",
    "\u0002\u0002\u0153\u0151\u0003\u0002\u0002\u0002\u0153\u0154\u0003\u0002",
    "\u0002\u0002\u0154\u0157\u0003\u0002\u0002\u0002\u0155\u0153\u0003\u0002",
    "\u0002\u0002\u0156\u014e\u0003\u0002\u0002\u0002\u0156\u0157\u0003\u0002",
    "\u0002\u0002\u0157\u001d\u0003\u0002\u0002\u0002\u0158\u0161\u0007P",
    "\u0002\u0002\u0159\u015e\u0005H%\u0002\u015a\u015b\u0007\u0004\u0002",
    "\u0002\u015b\u015d\u0005H%\u0002\u015c\u015a\u0003\u0002\u0002\u0002",
    "\u015d\u0160\u0003\u0002\u0002\u0002\u015e\u015c\u0003\u0002\u0002\u0002",
    "\u015e\u015f\u0003\u0002\u0002\u0002\u015f\u0162\u0003\u0002\u0002\u0002",
    "\u0160\u015e\u0003\u0002\u0002\u0002\u0161\u0159\u0003\u0002\u0002\u0002",
    "\u0161\u0162\u0003\u0002\u0002\u0002\u0162\u001f\u0003\u0002\u0002\u0002",
    "\u0163\u016e\u0007=\u0002\u0002\u0164\u0165\u0005J&\u0002\u0165\u0166",
    "\u00073\u0002\u0002\u0166\u0169\u0005\u0084C\u0002\u0167\u0168\u0007",
    "\u001d\u0002\u0002\u0168\u016a\u0005\u0086D\u0002\u0169\u0167\u0003",
    "\u0002\u0002\u0002\u0169\u016a\u0003\u0002\u0002\u0002\u016a\u016b\u0003",
    "\u0002\u0002\u0002\u016b\u016c\u0007D\u0002\u0002\u016c\u016d\u0005",
    "b2\u0002\u016d\u016f\u0003\u0002\u0002\u0002\u016e\u0164\u0003\u0002",
    "\u0002\u0002\u016e\u016f\u0003\u0002\u0002\u0002\u016f!\u0003\u0002",
    "\u0002\u0002\u0170\u0172\u0007.\u0002\u0002\u0171\u0173\t\u0002\u0002",
    "\u0002\u0172\u0171\u0003\u0002\u0002\u0002\u0172\u0173\u0003\u0002\u0002",
    "\u0002\u0173\u0175\u0003\u0002\u0002\u0002\u0174\u0176\u0005J&\u0002",
    "\u0175\u0174\u0003\u0002\u0002\u0002\u0175\u0176\u0003\u0002\u0002\u0002",
    "\u0176#\u0003\u0002\u0002\u0002\u0177\u0178\u00070\u0002\u0002\u0178",
    "\u0179\u0005b2\u0002\u0179%\u0003\u0002\u0002\u0002\u017a\u017c\u0005",
    "N(\u0002\u017b\u017a\u0003\u0002\u0002\u0002\u017b\u017c\u0003\u0002",
    "\u0002\u0002\u017c\u017d\u0003\u0002\u0002\u0002\u017d\u0189\u00079",
    "\u0002\u0002\u017e\u0180\u0007Y\u0002\u0002\u017f\u017e\u0003\u0002",
    "\u0002\u0002\u017f\u0180\u0003\u0002\u0002\u0002\u0180\u0181\u0003\u0002",
    "\u0002\u0002\u0181\u0184\u0005\u0084C\u0002\u0182\u0183\u0007\u001d",
    "\u0002\u0002\u0183\u0185\u0005\u0086D\u0002\u0184\u0182\u0003\u0002",
    "\u0002\u0002\u0184\u0185\u0003\u0002\u0002\u0002\u0185\u0186\u0003\u0002",
    "\u0002\u0002\u0186\u0187\u0007D\u0002\u0002\u0187\u0188\u0005b2\u0002",
    "\u0188\u018a\u0003\u0002\u0002\u0002\u0189\u017f\u0003\u0002\u0002\u0002",
    "\u0189\u018a\u0003\u0002\u0002\u0002\u018a\'\u0003\u0002\u0002\u0002",
    "\u018b\u018c\u0007F\u0002\u0002\u018c\u0195\u0007 \u0002\u0002\u018d",
    "\u0192\u0005X-\u0002\u018e\u018f\u0007\u0004\u0002\u0002\u018f\u0191",
    "\u0005X-\u0002\u0190\u018e\u0003\u0002\u0002\u0002\u0191\u0194\u0003",
    "\u0002\u0002\u0002\u0192\u0190\u0003\u0002\u0002\u0002\u0192\u0193\u0003",
    "\u0002\u0002\u0002\u0193\u0196\u0003\u0002\u0002\u0002\u0194\u0192\u0003",
    "\u0002\u0002\u0002\u0195\u018d\u0003\u0002\u0002\u0002\u0195\u0196\u0003",
    "\u0002\u0002\u0002\u0196)\u0003\u0002\u0002\u0002\u0197\u0198\u0007",
    "U\u0002\u0002\u0198\u019a\u0007\u001a\u0002\u0002\u0199\u019b\u0007",
    "Y\u0002\u0002\u019a\u0199\u0003\u0002\u0002\u0002\u019a\u019b\u0003",
    "\u0002\u0002\u0002\u019b\u019d\u0003\u0002\u0002\u0002\u019c\u019e\u0005",
    "\u008cG\u0002\u019d\u019c\u0003\u0002\u0002\u0002\u019d\u019e\u0003",
    "\u0002\u0002\u0002\u019e+\u0003\u0002\u0002\u0002\u019f\u01a1\u0007",
    ")\u0002\u0002\u01a0\u01a2\u0005\u0090I\u0002\u01a1\u01a0\u0003\u0002",
    "\u0002\u0002\u01a1\u01a2\u0003\u0002\u0002\u0002\u01a2-\u0003\u0002",
    "\u0002\u0002\u01a3\u01a5\u0007M\u0002\u0002\u01a4\u01a6\u0005l7\u0002",
    "\u01a5\u01a4\u0003\u0002\u0002\u0002\u01a5\u01a6\u0003\u0002\u0002\u0002",
    "\u01a6\u01a9\u0003\u0002\u0002\u0002\u01a7\u01a8\u0007 \u0002\u0002",
    "\u01a8\u01aa\u0005L\'\u0002\u01a9\u01a7\u0003\u0002\u0002\u0002\u01a9",
    "\u01aa\u0003\u0002\u0002\u0002\u01aa/\u0003\u0002\u0002\u0002\u01ab",
    "\u01ac\u0007\"\u0002\u0002\u01ac1\u0003\u0002\u0002\u0002\u01ad\u01ae",
    "\u0007W\u0002\u0002\u01ae\u01af\u00076\u0002\u0002\u01af\u01b1\u0007",
    "\u0005\u0002\u0002\u01b0\u01b2\u0005\u008eH\u0002\u01b1\u01b0\u0003",
    "\u0002\u0002\u0002\u01b1\u01b2\u0003\u0002\u0002\u0002\u01b2\u01b3\u0003",
    "\u0002\u0002\u0002\u01b3\u01b4\u0007\u0006\u0002\u0002\u01b43\u0003",
    "\u0002\u0002\u0002\u01b5\u01b6\u00076\u0002\u0002\u01b6\u01b8\u0007",
    "\u0005\u0002\u0002\u01b7\u01b9\u0005\u008eH\u0002\u01b8\u01b7\u0003",
    "\u0002\u0002\u0002\u01b8\u01b9\u0003\u0002\u0002\u0002\u01b9\u01ba\u0003",
    "\u0002\u0002\u0002\u01ba\u01bb\u0007\u0006\u0002\u0002\u01bb\u01bc\u0005",
    "\u0010\t\u0002\u01bc5\u0003\u0002\u0002\u0002\u01bd\u01bf\u0007[\u0002",
    "\u0002\u01be\u01c0\u0005l7\u0002\u01bf\u01be\u0003\u0002\u0002\u0002",
    "\u01bf\u01c0\u0003\u0002\u0002\u0002\u01c0\u01c3\u0003\u0002\u0002\u0002",
    "\u01c1\u01c2\u0007\\\u0002\u0002\u01c2\u01c4\u0005l7\u0002\u01c3\u01c1",
    "\u0003\u0002\u0002\u0002\u01c3\u01c4\u0003\u0002\u0002\u0002\u01c47",
    "\u0003\u0002\u0002\u0002\u01c5\u01c7\u0007W\u0002\u0002\u01c6\u01c8",
    "\u0005\u0084C\u0002\u01c7\u01c6\u0003\u0002\u0002\u0002\u01c7\u01c8",
    "\u0003\u0002\u0002\u0002\u01c89\u0003\u0002\u0002\u0002\u01c9\u01cb",
    "\u0005\u0086D\u0002\u01ca\u01c9\u0003\u0002\u0002\u0002\u01ca\u01cb",
    "\u0003\u0002\u0002\u0002\u01cb\u01cc\u0003\u0002\u0002\u0002\u01cc\u01ce",
    "\u0007\b\u0002\u0002\u01cd\u01cf\u0005\u0010\t\u0002\u01ce\u01cd\u0003",
    "\u0002\u0002\u0002\u01ce\u01cf\u0003\u0002\u0002\u0002\u01cf;\u0003",
    "\u0002\u0002\u0002\u01d0\u01d1\u0007\t\u0002\u0002\u01d1\u01d2\u0005",
    "\u000e\b\u0002\u01d2\u01d3\u0007\n\u0002\u0002\u01d3=\u0003\u0002\u0002",
    "\u0002\u01d4\u01d5\u0007-\u0002\u0002\u01d5\u01d6\u0007J\u0002\u0002",
    "\u01d6\u01d8\u0007:\u0002\u0002\u01d7\u01d9\u0005J&\u0002\u01d8\u01d7",
    "\u0003\u0002\u0002\u0002\u01d8\u01d9\u0003\u0002\u0002\u0002\u01d9\u01df",
    "\u0003\u0002\u0002\u0002\u01da\u01db\u0007(\u0002\u0002\u01db\u01dd",
    "\u0007\u001d\u0002\u0002\u01dc\u01de\u0005\u0092J\u0002\u01dd\u01dc",
    "\u0003\u0002\u0002\u0002\u01dd\u01de\u0003\u0002\u0002\u0002\u01de\u01e0",
    "\u0003\u0002\u0002\u0002\u01df\u01da\u0003\u0002\u0002\u0002\u01df\u01e0",
    "\u0003\u0002\u0002\u0002\u01e0?\u0003\u0002\u0002\u0002\u01e1\u01e4",
    "\u0005J&\u0002\u01e2\u01e3\u0007\u0004\u0002\u0002\u01e3\u01e5\u0005",
    "B\"\u0002\u01e4\u01e2\u0003\u0002\u0002\u0002\u01e4\u01e5\u0003\u0002",
    "\u0002\u0002\u01e5A\u0003\u0002\u0002\u0002\u01e6\u01e9\u0005R*\u0002",
    "\u01e7\u01e8\u0007\u0004\u0002\u0002\u01e8\u01ea\u0005J&\u0002\u01e9",
    "\u01e7\u0003\u0002\u0002\u0002\u01e9\u01ea\u0003\u0002\u0002\u0002\u01ea",
    "C\u0003\u0002\u0002\u0002\u01eb\u01ed\u0007Z\u0002\u0002\u01ec\u01ee",
    "\u0005L\'\u0002\u01ed\u01ec\u0003\u0002\u0002\u0002\u01ed\u01ee\u0003",
    "\u0002\u0002\u0002\u01ee\u01ef\u0003\u0002\u0002\u0002\u01ef\u01f1\u0007",
    "Q\u0002\u0002\u01f0\u01f2\u0005J&\u0002\u01f1\u01f0\u0003\u0002\u0002",
    "\u0002\u01f1\u01f2\u0003\u0002\u0002\u0002\u01f2E\u0003\u0002\u0002",
    "\u0002\u01f3\u01f4\u0007*\u0002\u0002\u01f4\u01f5\u0007Q\u0002\u0002",
    "\u01f5\u01f6\u0005J&\u0002\u01f6G\u0003\u0002\u0002\u0002\u01f7\u01f9",
    "\u0007\u0005\u0002\u0002\u01f8\u01fa\u0005J&\u0002\u01f9\u01f8\u0003",
    "\u0002\u0002\u0002\u01f9\u01fa\u0003\u0002\u0002\u0002\u01fa\u01fb\u0003",
    "\u0002\u0002\u0002\u01fb\u01fc\u0007\u0006\u0002\u0002\u01fcI\u0003",
    "\u0002\u0002\u0002\u01fd\u0202\u0005P)\u0002\u01fe\u01ff\u0007\u0004",
    "\u0002\u0002\u01ff\u0201\u0005P)\u0002\u0200\u01fe\u0003\u0002\u0002",
    "\u0002\u0201\u0204\u0003\u0002\u0002\u0002\u0202\u0200\u0003\u0002\u0002",
    "\u0002\u0202\u0203\u0003\u0002\u0002\u0002\u0203K\u0003\u0002\u0002",
    "\u0002\u0204\u0202\u0003\u0002\u0002\u0002\u0205\u020a\u0005b2\u0002",
    "\u0206\u0207\u0007\u0004\u0002\u0002\u0207\u0209\u0005b2\u0002\u0208",
    "\u0206\u0003\u0002\u0002\u0002\u0209\u020c\u0003\u0002\u0002\u0002\u020a",
    "\u0208\u0003\u0002\u0002\u0002\u020a\u020b\u0003\u0002\u0002\u0002\u020b",
    "M\u0003\u0002\u0002\u0002\u020c\u020a\u0003\u0002\u0002\u0002\u020d",
    "\u021d\u00077\u0002\u0002\u020e\u021d\u0007%\u0002\u0002\u020f\u021d",
    "\u0007G\u0002\u0002\u0210\u0212\u00074\u0002\u0002\u0211\u0213\u0007",
    "G\u0002\u0002\u0212\u0211\u0003\u0002\u0002\u0002\u0212\u0213\u0003",
    "\u0002\u0002\u0002\u0213\u021d\u0003\u0002\u0002\u0002\u0214\u0216\u0007",
    ">\u0002\u0002\u0215\u0217\u0007G\u0002\u0002\u0216\u0215\u0003\u0002",
    "\u0002\u0002\u0216\u0217\u0003\u0002\u0002\u0002\u0217\u021d\u0003\u0002",
    "\u0002\u0002\u0218\u021a\u0007N\u0002\u0002\u0219\u021b\u0007G\u0002",
    "\u0002\u021a\u0219\u0003\u0002\u0002\u0002\u021a\u021b\u0003\u0002\u0002",
    "\u0002\u021b\u021d\u0003\u0002\u0002\u0002\u021c\u020d\u0003\u0002\u0002",
    "\u0002\u021c\u020e\u0003\u0002\u0002\u0002\u021c\u020f\u0003\u0002\u0002",
    "\u0002\u021c\u0210\u0003\u0002\u0002\u0002\u021c\u0214\u0003\u0002\u0002",
    "\u0002\u021c\u0218\u0003\u0002\u0002\u0002\u021dO\u0003\u0002\u0002",
    "\u0002\u021e\u0224\u0005\u0092J\u0002\u021f\u0220\u0005b2\u0002\u0220",
    "\u0221\u0007\u001d\u0002\u0002\u0221\u0222\u0005\u0092J\u0002\u0222",
    "\u0224\u0003\u0002\u0002\u0002\u0223\u021e\u0003\u0002\u0002\u0002\u0223",
    "\u021f\u0003\u0002\u0002\u0002\u0224Q\u0003\u0002\u0002\u0002\u0225",
    "\u0228\u0005T+\u0002\u0226\u0227\u0007\u001d\u0002\u0002\u0227\u0229",
    "\u0005V,\u0002\u0228\u0226\u0003\u0002\u0002\u0002\u0228\u0229\u0003",
    "\u0002\u0002\u0002\u0229S\u0003\u0002\u0002\u0002\u022a\u022c\u0005",
    "\u0092J\u0002\u022b\u022a\u0003\u0002\u0002\u0002\u022b\u022c\u0003",
    "\u0002\u0002\u0002\u022c\u022d\u0003\u0002\u0002\u0002\u022d\u022e\u0007",
    "\u0003\u0002\u0002\u022eU\u0003\u0002\u0002\u0002\u022f\u0231\u0005",
    "\u0092J\u0002\u0230\u022f\u0003\u0002\u0002\u0002\u0230\u0231\u0003",
    "\u0002\u0002\u0002\u0231\u0232\u0003\u0002\u0002\u0002\u0232\u0233\u0007",
    "\u0003\u0002\u0002\u0233W\u0003\u0002\u0002\u0002\u0234\u0236\u0005",
    "b2\u0002\u0235\u0237\t\u0003\u0002\u0002\u0236\u0235\u0003\u0002\u0002",
    "\u0002\u0236\u0237\u0003\u0002\u0002\u0002\u0237\u023a\u0003\u0002\u0002",
    "\u0002\u0238\u0239\u0007C\u0002\u0002\u0239\u023b\t\u0004\u0002\u0002",
    "\u023a\u0238\u0003\u0002\u0002\u0002\u023a\u023b\u0003\u0002\u0002\u0002",
    "\u023bY\u0003\u0002\u0002\u0002\u023c\u023f\t\u0005\u0002\u0002\u023d",
    "\u0240\u0005^0\u0002\u023e\u0240\u0005\\/\u0002\u023f\u023d\u0003\u0002",
    "\u0002\u0002\u023f\u023e\u0003\u0002\u0002\u0002\u0240[\u0003\u0002",
    "\u0002\u0002\u0241\u0242\u0007\u001f\u0002\u0002\u0242\u0243\u0005^",
    "0\u0002\u0243\u0244\u0007\u001b\u0002\u0002\u0244\u0245\u0005^0\u0002",
    "\u0245]\u0003\u0002\u0002\u0002\u0246\u0247\u0007T\u0002\u0002\u0247",
    "\u0253\u0007I\u0002\u0002\u0248\u0249\u0005l7\u0002\u0249\u024a\u0007",
    "I\u0002\u0002\u024a\u0253\u0003\u0002\u0002\u0002\u024b\u024c\u0007",
    "&\u0002\u0002\u024c\u0253\u0007O\u0002\u0002\u024d\u024e\u0005l7\u0002",
    "\u024e\u024f\u00072\u0002\u0002\u024f\u0253\u0003\u0002\u0002\u0002",
    "\u0250\u0251\u0007T\u0002\u0002\u0251\u0253\u00072\u0002\u0002\u0252",
    "\u0246\u0003\u0002\u0002\u0002\u0252\u0248\u0003\u0002\u0002\u0002\u0252",
    "\u024b\u0003\u0002\u0002\u0002\u0252\u024d\u0003\u0002\u0002\u0002\u0252",
    "\u0250\u0003\u0002\u0002\u0002\u0253_\u0003\u0002\u0002\u0002\u0254",
    "\u0255\u0005b2\u0002\u0255\u0256\u0007\u0002\u0002\u0003\u0256a\u0003",
    "\u0002\u0002\u0002\u0257\u0260\b2\u0001\u0002\u0258\u0261\u0005f4\u0002",
    "\u0259\u0261\u0005l7\u0002\u025a\u0261\u0005n8\u0002\u025b\u0261\u0005",
    "p9\u0002\u025c\u0261\u0005r:\u0002\u025d\u0261\u0005t;\u0002\u025e\u0261",
    "\u0005v<\u0002\u025f\u0261\u0005x=\u0002\u0260\u0258\u0003\u0002\u0002",
    "\u0002\u0260\u0259\u0003\u0002\u0002\u0002\u0260\u025a\u0003\u0002\u0002",
    "\u0002\u0260\u025b\u0003\u0002\u0002\u0002\u0260\u025c\u0003\u0002\u0002",
    "\u0002\u0260\u025d\u0003\u0002\u0002\u0002\u0260\u025e\u0003\u0002\u0002",
    "\u0002\u0260\u025f\u0003\u0002\u0002\u0002\u0261\u02ab\u0003\u0002\u0002",
    "\u0002\u0262\u02ab\u0005\u0092J\u0002\u0263\u0264\u0007\f\u0002\u0002",
    "\u0264\u02ab\u0005b2\u001e\u0265\u0266\u0007\u0005\u0002\u0002\u0266",
    "\u0267\u0005b2\u0002\u0267\u0268\u0007\u0006\u0002\u0002\u0268\u02ab",
    "\u0003\u0002\u0002\u0002\u0269\u026a\u0007A\u0002\u0002\u026a\u02ab",
    "\u0005b2\r\u026b\u026d\u0007!\u0002\u0002\u026c\u026e\u0005b2\u0002",
    "\u026d\u026c\u0003\u0002\u0002\u0002\u026d\u026e\u0003\u0002\u0002\u0002",
    "\u026e\u0272\u0003\u0002\u0002\u0002\u026f\u0271\u0005z>\u0002\u0270",
    "\u026f\u0003\u0002\u0002\u0002\u0271\u0274\u0003\u0002\u0002\u0002\u0272",
    "\u0270\u0003\u0002\u0002\u0002\u0272\u0273\u0003\u0002\u0002\u0002\u0273",
    "\u0276\u0003\u0002\u0002\u0002\u0274\u0272\u0003\u0002\u0002\u0002\u0275",
    "\u0277\u0005|?\u0002\u0276\u0275\u0003\u0002\u0002\u0002\u0276\u0277",
    "\u0003\u0002\u0002\u0002\u0277\u0278\u0003\u0002\u0002\u0002\u0278\u02ab",
    "\u0007,\u0002\u0002\u0279\u027a\u0007?\u0002\u0002\u027a\u027b\u0007",
    "\u0005\u0002\u0002\u027b\u027c\u0005~@\u0002\u027c\u027d\u0007\u0004",
    "\u0002\u0002\u027d\u027e\u0005b2\u0002\u027e\u027f\u0007\u0006\u0002",
    "\u0002\u027f\u02ab\u0003\u0002\u0002\u0002\u0280\u0281\u00070\u0002",
    "\u0002\u0281\u0282\u0007\u0005\u0002\u0002\u0282\u0283\u0005~@\u0002",
    "\u0283\u0284\u0007\u0004\u0002\u0002\u0284\u0285\u0005b2\u0002\u0285",
    "\u0286\u0007\u0006\u0002\u0002\u0286\u02ab\u0003\u0002\u0002\u0002\u0287",
    "\u0288\u0007L\u0002\u0002\u0288\u0289\u0007\u0005\u0002\u0002\u0289",
    "\u028a\u0005~@\u0002\u028a\u028b\u0007\u0004\u0002\u0002\u028b\u028c",
    "\u0005b2\u0002\u028c\u028d\u0007\u0004\u0002\u0002\u028d\u028e\u0005",
    "b2\u0002\u028e\u028f\u0007\u0006\u0002\u0002\u028f\u02ab\u0003\u0002",
    "\u0002\u0002\u0290\u0291\u0007#\u0002\u0002\u0291\u0292\u0007\u0005",
    "\u0002\u0002\u0292\u0293\u0005~@\u0002\u0293\u0294\u0007\u0004\u0002",
    "\u0002\u0294\u0295\u0005b2\u0002\u0295\u0296\u0007\u0006\u0002\u0002",
    "\u0296\u02ab\u0003\u0002\u0002\u0002\u0297\u0298\u0007$\u0002\u0002",
    "\u0298\u0299\u0007\u0005\u0002\u0002\u0299\u029a\u0005~@\u0002\u029a",
    "\u029b\u0007\u0004\u0002\u0002\u029b\u029c\u0005b2\u0002\u029c\u029d",
    "\u0007\u0006\u0002\u0002\u029d\u02ab\u0003\u0002\u0002\u0002\u029e\u029f",
    "\u0005\u0082B\u0002\u029f\u02a6\u0007\u0005\u0002\u0002\u02a0\u02a3",
    "\u0005L\'\u0002\u02a1\u02a2\u0007\u0004\u0002\u0002\u02a2\u02a4\u0005",
    "d3\u0002\u02a3\u02a1\u0003\u0002\u0002\u0002\u02a3\u02a4\u0003\u0002",
    "\u0002\u0002\u02a4\u02a7\u0003\u0002\u0002\u0002\u02a5\u02a7\u0005d",
    "3\u0002\u02a6\u02a0\u0003\u0002\u0002\u0002\u02a6\u02a5\u0003\u0002",
    "\u0002\u0002\u02a6\u02a7\u0003\u0002\u0002\u0002\u02a7\u02a8\u0003\u0002",
    "\u0002\u0002\u02a8\u02a9\u0007\u0006\u0002\u0002\u02a9\u02ab\u0003\u0002",
    "\u0002\u0002\u02aa\u0257\u0003\u0002\u0002\u0002\u02aa\u0262\u0003\u0002",
    "\u0002\u0002\u02aa\u0263\u0003\u0002\u0002\u0002\u02aa\u0265\u0003\u0002",
    "\u0002\u0002\u02aa\u0269\u0003\u0002\u0002\u0002\u02aa\u026b\u0003\u0002",
    "\u0002\u0002\u02aa\u0279\u0003\u0002\u0002\u0002\u02aa\u0280\u0003\u0002",
    "\u0002\u0002\u02aa\u0287\u0003\u0002\u0002\u0002\u02aa\u0290\u0003\u0002",
    "\u0002\u0002\u02aa\u0297\u0003\u0002\u0002\u0002\u02aa\u029e\u0003\u0002",
    "\u0002\u0002\u02ab\u02e9\u0003\u0002\u0002\u0002\u02ac\u02ad\f\u0019",
    "\u0002\u0002\u02ad\u02ae\t\u0006\u0002\u0002\u02ae\u02e8\u0005b2\u001a",
    "\u02af\u02b0\f\u0018\u0002\u0002\u02b0\u02b1\t\u0007\u0002\u0002\u02b1",
    "\u02e8\u0005b2\u0019\u02b2\u02b3\f\u0017\u0002\u0002\u02b3\u02b4\u0007",
    "\u0011\u0002\u0002\u02b4\u02e8\u0005b2\u0018\u02b5\u02b6\f\u0016\u0002",
    "\u0002\u02b6\u02b7\u0007\u0012\u0002\u0002\u02b7\u02e8\u0005b2\u0017",
    "\u02b8\u02b9\f\u0015\u0002\u0002\u02b9\u02ba\u0007\u0013\u0002\u0002",
    "\u02ba\u02e8\u0005b2\u0016\u02bb\u02bc\f\u0014\u0002\u0002\u02bc\u02bd",
    "\u0007\u0014\u0002\u0002\u02bd\u02e8\u0005b2\u0015\u02be\u02bf\f\u0013",
    "\u0002\u0002\u02bf\u02c0\u0007\u0003\u0002\u0002\u02c0\u02e8\u0005b",
    "2\u0014\u02c1\u02c2\f\u0012\u0002\u0002\u02c2\u02c3\u0007\u0015\u0002",
    "\u0002\u02c3\u02e8\u0005b2\u0013\u02c4\u02c5\f\u0011\u0002\u0002\u02c5",
    "\u02c6\u0007\u0016\u0002\u0002\u02c6\u02e8\u0005b2\u0012\u02c7\u02c8",
    "\f\u0010\u0002\u0002\u02c8\u02c9\u0007\u0017\u0002\u0002\u02c9\u02e8",
    "\u0005b2\u0011\u02ca\u02cb\f\u000f\u0002\u0002\u02cb\u02cc\u0007\f\u0002",
    "\u0002\u02cc\u02e8\u0005b2\u0010\u02cd\u02ce\f\f\u0002\u0002\u02ce\u02cf",
    "\u0007\u001b\u0002\u0002\u02cf\u02e8\u0005b2\r\u02d0\u02d1\f\u000b\u0002",
    "\u0002\u02d1\u02d2\u0007E\u0002\u0002\u02d2\u02e8\u0005b2\f\u02d3\u02d4",
    "\f\t\u0002\u0002\u02d4\u02d5\u0007\u0018\u0002\u0002\u02d5\u02e8\u0005",
    "b2\n\u02d6\u02d7\f\u001f\u0002\u0002\u02d7\u02d8\u0007\u000b\u0002\u0002",
    "\u02d8\u02e8\u0005\u0092J\u0002\u02d9\u02da\f\u001d\u0002\u0002\u02da",
    "\u02db\u00078\u0002\u0002\u02db\u02e8\u0007B\u0002\u0002\u02dc\u02dd",
    "\f\u001c\u0002\u0002\u02dd\u02de\u00078\u0002\u0002\u02de\u02df\u0007",
    "A\u0002\u0002\u02df\u02e8\u0007B\u0002\u0002\u02e0\u02e1\f\u001b\u0002",
    "\u0002\u02e1\u02e2\u00078\u0002\u0002\u02e2\u02e8\u0007+\u0002\u0002",
    "\u02e3\u02e4\f\u001a\u0002\u0002\u02e4\u02e5\u00078\u0002\u0002\u02e5",
    "\u02e6\u0007A\u0002\u0002\u02e6\u02e8\u0007+\u0002\u0002\u02e7\u02ac",
    "\u0003\u0002\u0002\u0002\u02e7\u02af\u0003\u0002\u0002\u0002\u02e7\u02b2",
    "\u0003\u0002\u0002\u0002\u02e7\u02b5\u0003\u0002\u0002\u0002\u02e7\u02b8",
    "\u0003\u0002\u0002\u0002\u02e7\u02bb\u0003\u0002\u0002\u0002\u02e7\u02be",
    "\u0003\u0002\u0002\u0002\u02e7\u02c1\u0003\u0002\u0002\u0002\u02e7\u02c4",
    "\u0003\u0002\u0002\u0002\u02e7\u02c7\u0003\u0002\u0002\u0002\u02e7\u02ca",
    "\u0003\u0002\u0002\u0002\u02e7\u02cd\u0003\u0002\u0002\u0002\u02e7\u02d0",
    "\u0003\u0002\u0002\u0002\u02e7\u02d3\u0003\u0002\u0002\u0002\u02e7\u02d6",
    "\u0003\u0002\u0002\u0002\u02e7\u02d9\u0003\u0002\u0002\u0002\u02e7\u02dc",
    "\u0003\u0002\u0002\u0002\u02e7\u02e0\u0003\u0002\u0002\u0002\u02e7\u02e3",
    "\u0003\u0002\u0002\u0002\u02e8\u02eb\u0003\u0002\u0002\u0002\u02e9\u02e7",
    "\u0003\u0002\u0002\u0002\u02e9\u02ea\u0003\u0002\u0002\u0002\u02eac",
    "\u0003\u0002\u0002\u0002\u02eb\u02e9\u0003\u0002\u0002\u0002\u02ec\u02ed",
    "\u0007\u0019\u0002\u0002\u02ed\u02ee\u0007\u0019\u0002\u0002\u02ee\u02ef",
    "\u0007\u0019\u0002\u0002\u02ef\u02f0\u0005b2\u0002\u02f0e\u0003\u0002",
    "\u0002\u0002\u02f1\u02f3\u0007\t\u0002\u0002\u02f2\u02f4\u0005h5\u0002",
    "\u02f3\u02f2\u0003\u0002\u0002\u0002\u02f3\u02f4\u0003\u0002\u0002\u0002",
    "\u02f4\u02f5\u0003\u0002\u0002\u0002\u02f5\u02f6\u0007\n\u0002\u0002",
    "\u02f6g\u0003\u0002\u0002\u0002\u02f7\u02fc\u0005j6\u0002\u02f8\u02f9",
    "\u0007\u0004\u0002\u0002\u02f9\u02fb\u0005j6\u0002\u02fa\u02f8\u0003",
    "\u0002\u0002\u0002\u02fb\u02fe\u0003\u0002\u0002\u0002\u02fc\u02fa\u0003",
    "\u0002\u0002\u0002\u02fc\u02fd\u0003\u0002\u0002\u0002\u02fdi\u0003",
    "\u0002\u0002\u0002\u02fe\u02fc\u0003\u0002\u0002\u0002\u02ff\u0305\u0005",
    "\u0092J\u0002\u0300\u0301\u0005\u0092J\u0002\u0301\u0302\u0007\b\u0002",
    "\u0002\u0302\u0303\u0005b2\u0002\u0303\u0305\u0003\u0002\u0002\u0002",
    "\u0304\u02ff\u0003\u0002\u0002\u0002\u0304\u0300\u0003\u0002\u0002\u0002",
    "\u0305k\u0003\u0002\u0002\u0002\u0306\u0307\u0007_\u0002\u0002\u0307",
    "m\u0003\u0002\u0002\u0002\u0308\u0309\u0007^\u0002\u0002\u0309o\u0003",
    "\u0002\u0002\u0002\u030a\u030b\u0007`\u0002\u0002\u030bq\u0003\u0002",
    "\u0002\u0002\u030c\u030d\u0007]\u0002\u0002\u030ds\u0003\u0002\u0002",
    "\u0002\u030e\u030f\u0007B\u0002\u0002\u030fu\u0003\u0002\u0002\u0002",
    "\u0310\u0311\u0007S\u0002\u0002\u0311w\u0003\u0002\u0002\u0002\u0312",
    "\u0313\u0007/\u0002\u0002\u0313y\u0003\u0002\u0002\u0002\u0314\u0315",
    "\u0007Z\u0002\u0002\u0315\u0316\u0005b2\u0002\u0316\u0317\u0007R\u0002",
    "\u0002\u0317\u0318\u0005b2\u0002\u0318{\u0003\u0002\u0002\u0002\u0319",
    "\u031a\u0007*\u0002\u0002\u031a\u031b\u0005b2\u0002\u031b}\u0003\u0002",
    "\u0002\u0002\u031c\u031f\u0005\u0082B\u0002\u031d\u031f\u0005\u0080",
    "A\u0002\u031e\u031c\u0003\u0002\u0002\u0002\u031e\u031d\u0003\u0002",
    "\u0002\u0002\u031f\u007f\u0003\u0002\u0002\u0002\u0320\u0322\u0007;",
    "\u0002\u0002\u0321\u0323\u0005\u0090I\u0002\u0322\u0321\u0003\u0002",
    "\u0002\u0002\u0322\u0323\u0003\u0002\u0002\u0002\u0323\u0324\u0003\u0002",
    "\u0002\u0002\u0324\u0325\u0007\b\u0002\u0002\u0325\u0326\u0005b2\u0002",
    "\u0326\u0081\u0003\u0002\u0002\u0002\u0327\u0328\u0005\u0092J\u0002",
    "\u0328\u0083\u0003\u0002\u0002\u0002\u0329\u032c\u0005\u0086D\u0002",
    "\u032a\u032c\u0005\u0088E\u0002\u032b\u0329\u0003\u0002\u0002\u0002",
    "\u032b\u032a\u0003\u0002\u0002\u0002\u032c\u0085\u0003\u0002\u0002\u0002",
    "\u032d\u032e\u0005\u0092J\u0002\u032e\u0087\u0003\u0002\u0002\u0002",
    "\u032f\u0330\u0005\u0082B\u0002\u0330\u0332\u0007\u0005\u0002\u0002",
    "\u0331\u0333\u0005\u008cG\u0002\u0332\u0331\u0003\u0002\u0002\u0002",
    "\u0332\u0333\u0003\u0002\u0002\u0002\u0333\u0334\u0003\u0002\u0002\u0002",
    "\u0334\u0335\u0007\u0006\u0002\u0002\u0335\u0089\u0003\u0002\u0002\u0002",
    "\u0336\u0337\u0005\u0092J\u0002\u0337\u008b\u0003\u0002\u0002\u0002",
    "\u0338\u033d\u0005\u0084C\u0002\u0339\u033a\u0007\u0004\u0002\u0002",
    "\u033a\u033c\u0005\u0084C\u0002\u033b\u0339\u0003\u0002\u0002\u0002",
    "\u033c\u033f\u0003\u0002\u0002\u0002\u033d\u033b\u0003\u0002\u0002\u0002",
    "\u033d\u033e\u0003\u0002\u0002\u0002\u033e\u008d\u0003\u0002\u0002\u0002",
    "\u033f\u033d\u0003\u0002\u0002\u0002\u0340\u0345\u0005\u008aF\u0002",
    "\u0341\u0342\u0007\u0004\u0002\u0002\u0342\u0344\u0005\u008aF\u0002",
    "\u0343\u0341\u0003\u0002\u0002\u0002\u0344\u0347\u0003\u0002\u0002\u0002",
    "\u0345\u0343\u0003\u0002\u0002\u0002\u0345\u0346\u0003\u0002\u0002\u0002",
    "\u0346\u008f\u0003\u0002\u0002\u0002\u0347\u0345\u0003\u0002\u0002\u0002",
    "\u0348\u034d\u0005\u0092J\u0002\u0349\u034a\u0007\u0004\u0002\u0002",
    "\u034a\u034c\u0005\u0092J\u0002\u034b\u0349\u0003\u0002\u0002\u0002",
    "\u034c\u034f\u0003\u0002\u0002\u0002\u034d\u034b\u0003\u0002\u0002\u0002",
    "\u034d\u034e\u0003\u0002\u0002\u0002\u034e\u0091\u0003\u0002\u0002\u0002",
    "\u034f\u034d\u0003\u0002\u0002\u0002\u0350\u0357\u0005\u0094K\u0002",
    "\u0351\u0353\u0007\u0019\u0002\u0002\u0352\u0354\u0005\u0094K\u0002",
    "\u0353\u0352\u0003\u0002\u0002\u0002\u0353\u0354\u0003\u0002\u0002\u0002",
    "\u0354\u0356\u0003\u0002\u0002\u0002\u0355\u0351\u0003\u0002\u0002\u0002",
    "\u0356\u0359\u0003\u0002\u0002\u0002\u0357\u0355\u0003\u0002\u0002\u0002",
    "\u0357\u0358\u0003\u0002\u0002\u0002\u0358\u0093\u0003\u0002\u0002\u0002",
    "\u0359\u0357\u0003\u0002\u0002\u0002\u035a\u035b\t\b\u0002\u0002\u035b",
    "\u0095\u0003\u0002\u0002\u0002\u035c\u035e\u0005\u0098M\u0002\u035d",
    "\u035c\u0003\u0002\u0002\u0002\u035e\u0361\u0003\u0002\u0002\u0002\u035f",
    "\u035d\u0003\u0002\u0002\u0002\u035f\u0360\u0003\u0002\u0002\u0002\u0360",
    "\u0362\u0003\u0002\u0002\u0002\u0361\u035f\u0003\u0002\u0002\u0002\u0362",
    "\u0363\u0007\u0002\u0002\u0003\u0363\u0097\u0003\u0002\u0002\u0002\u0364",
    "\u0365\t\t\u0002\u0002\u0365\u0099\u0003\u0002\u0002\u0002\\\u00bf\u00cb",
    "\u00d4\u00d8\u00e9\u00f4\u00fa\u00fe\u0102\u011c\u0121\u0125\u0130\u0135",
    "\u0138\u013a\u013e\u0143\u0147\u014b\u0153\u0156\u015e\u0161\u0169\u016e",
    "\u0172\u0175\u017b\u017f\u0184\u0189\u0192\u0195\u019a\u019d\u01a1\u01a5",
    "\u01a9\u01b1\u01b8\u01bf\u01c3\u01c7\u01ca\u01ce\u01d8\u01dd\u01df\u01e4",
    "\u01e9\u01ed\u01f1\u01f9\u0202\u020a\u0212\u0216\u021a\u021c\u0223\u0228",
    "\u022b\u0230\u0236\u023a\u023f\u0252\u0260\u026d\u0272\u0276\u02a3\u02a6",
    "\u02aa\u02e7\u02e9\u02f3\u02fc\u0304\u031e\u0322\u032b\u0332\u033d\u0345",
    "\u034d\u0353\u0357\u035f"].join("");


var atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

var decisionsToDFA = atn.decisionToState.map( function(ds, index) { return new antlr4.dfa.DFA(ds, index); });

var sharedContextCache = new antlr4.PredictionContextCache();

var literalNames = [ null, "'*'", "','", "'('", "')'", "';'", "':'", "'{'", 
                     "'}'", "'->'", "'-'", "'='", "'=='", "'!='", "'<>'", 
                     "'>'", "'>='", "'<'", "'<='", "'/'", "'%'", "'+'", 
                     "'||'", "'.'" ];

var symbolicNames = [ null, null, null, null, null, null, null, null, null, 
                      null, null, null, null, null, null, null, null, null, 
                      null, null, null, null, null, null, "K_ALL", "K_AND", 
                      "K_ARRAY", "K_AS", "K_ASC", "K_BETWEEN", "K_BY", "K_CASE", 
                      "K_CHECKPOINT", "K_CONVERT_ARRAY", "K_CONVERT_STRUCT", 
                      "K_CROSS", "K_CURRENT", "K_DESC", "K_DISAMBIGUATE", 
                      "K_DROP", "K_ELSE", "K_EMPTY", "K_END", "K_ENFORCE", 
                      "K_EXPLODE", "K_FALSE", "K_FILTER", "K_FIRST", "K_FOLLOWING", 
                      "K_FROM", "K_FULL", "K_GROUP", "K_HINT", "K_INNER", 
                      "K_IS", "K_JOIN", "K_KEY", "K_LAMBDA", "K_LAST", "K_LOOKUP", 
                      "K_LEFT", "K_MAP", "K_MERGE", "K_NOT", "K_NULL", "K_NULLS", 
                      "K_ON", "K_OR", "K_ORDER", "K_OUTER", "K_PIVOT", "K_PRECEDING", 
                      "K_PRIMARY", "K_RANGE", "K_REDUCE", "K_REPARTITION", 
                      "K_RIGHT", "K_ROW", "K_ROWS", "K_SELECT", "K_THEN", 
                      "K_TRUE", "K_UNBOUNDED", "K_UNION", "K_UNPIVOT", "K_USE", 
                      "K_WINDOW", "K_WITH", "K_WHEN", "K_SAMPLE", "K_SEED", 
                      "STRING_LITERAL", "LONG_LITERAL", "INTEGER_LITERAL", 
                      "NUMERIC_LITERAL", "IDENTIFIER", "SPACES", "SINGLE_LINE_COMMENT_SQL", 
                      "SINGLE_LINE_COMMENT_C", "MULTILINE_COMMENT", "UNCLOSED_MULTILINE_COMMENT" ];

var ruleNames =  [ "parseSemanticOp", "semantic_op", "semantic_unpivot_clause", 
                   "semantic_multi_formula_clause", "dep_value", "ops", 
                   "script", "op", "selectOp", "groupByOp", "mergeOp", "windowOp", 
                   "pivotOp", "unpivotOp", "rowsOp", "lookupOp", "explodeOp", 
                   "filterOp", "joinOp", "sortOp", "unionOp", "dropOp", 
                   "repartitionOp", "checkpointOp", "useHintOp", "hintOp", 
                   "sampleOp", "useOp", "labelOp", "blockOp", "enforcePKOp", 
                   "selector_pre", "selector_post", "pivot_when_clause", 
                   "pivot_else_clause", "row_clause", "named_exprs", "exprs", 
                   "join_type", "named_expr", "rename_expr", "rename_from", 
                   "rename_to", "sort_clause", "window_frame", "window_frame_interval", 
                   "window_frame_boundary", "parseExpr", "expr", "unpack_expr", 
                   "literalRecord", "record_fields", "record_field", "literalInteger", 
                   "literalLong", "literalNumber", "literalString", "literalNull", 
                   "literalTrue", "literalFalse", "case_when_clause", "case_else_clause", 
                   "function_reference", "lambda", "function_name", "dataset", 
                   "dataset_name", "dataset_expr", "hint", "dataset_list", 
                   "hint_list", "identifier_list", "id", "id_fragment", 
                   "comments", "comment" ];

function TransformsParser (input) {
	antlr4.Parser.call(this, input);
    this._interp = new antlr4.atn.ParserATNSimulator(this, atn, decisionsToDFA, sharedContextCache);
    this.ruleNames = ruleNames;
    this.literalNames = literalNames;
    this.symbolicNames = symbolicNames;
    return this;
}

TransformsParser.prototype = Object.create(antlr4.Parser.prototype);
TransformsParser.prototype.constructor = TransformsParser;

Object.defineProperty(TransformsParser.prototype, "atn", {
	get : function() {
		return atn;
	}
});

TransformsParser.EOF = antlr4.Token.EOF;
TransformsParser.T__0 = 1;
TransformsParser.T__1 = 2;
TransformsParser.T__2 = 3;
TransformsParser.T__3 = 4;
TransformsParser.T__4 = 5;
TransformsParser.T__5 = 6;
TransformsParser.T__6 = 7;
TransformsParser.T__7 = 8;
TransformsParser.T__8 = 9;
TransformsParser.T__9 = 10;
TransformsParser.T__10 = 11;
TransformsParser.T__11 = 12;
TransformsParser.T__12 = 13;
TransformsParser.T__13 = 14;
TransformsParser.T__14 = 15;
TransformsParser.T__15 = 16;
TransformsParser.T__16 = 17;
TransformsParser.T__17 = 18;
TransformsParser.T__18 = 19;
TransformsParser.T__19 = 20;
TransformsParser.T__20 = 21;
TransformsParser.T__21 = 22;
TransformsParser.T__22 = 23;
TransformsParser.K_ALL = 24;
TransformsParser.K_AND = 25;
TransformsParser.K_ARRAY = 26;
TransformsParser.K_AS = 27;
TransformsParser.K_ASC = 28;
TransformsParser.K_BETWEEN = 29;
TransformsParser.K_BY = 30;
TransformsParser.K_CASE = 31;
TransformsParser.K_CHECKPOINT = 32;
TransformsParser.K_CONVERT_ARRAY = 33;
TransformsParser.K_CONVERT_STRUCT = 34;
TransformsParser.K_CROSS = 35;
TransformsParser.K_CURRENT = 36;
TransformsParser.K_DESC = 37;
TransformsParser.K_DISAMBIGUATE = 38;
TransformsParser.K_DROP = 39;
TransformsParser.K_ELSE = 40;
TransformsParser.K_EMPTY = 41;
TransformsParser.K_END = 42;
TransformsParser.K_ENFORCE = 43;
TransformsParser.K_EXPLODE = 44;
TransformsParser.K_FALSE = 45;
TransformsParser.K_FILTER = 46;
TransformsParser.K_FIRST = 47;
TransformsParser.K_FOLLOWING = 48;
TransformsParser.K_FROM = 49;
TransformsParser.K_FULL = 50;
TransformsParser.K_GROUP = 51;
TransformsParser.K_HINT = 52;
TransformsParser.K_INNER = 53;
TransformsParser.K_IS = 54;
TransformsParser.K_JOIN = 55;
TransformsParser.K_KEY = 56;
TransformsParser.K_LAMBDA = 57;
TransformsParser.K_LAST = 58;
TransformsParser.K_LOOKUP = 59;
TransformsParser.K_LEFT = 60;
TransformsParser.K_MAP = 61;
TransformsParser.K_MERGE = 62;
TransformsParser.K_NOT = 63;
TransformsParser.K_NULL = 64;
TransformsParser.K_NULLS = 65;
TransformsParser.K_ON = 66;
TransformsParser.K_OR = 67;
TransformsParser.K_ORDER = 68;
TransformsParser.K_OUTER = 69;
TransformsParser.K_PIVOT = 70;
TransformsParser.K_PRECEDING = 71;
TransformsParser.K_PRIMARY = 72;
TransformsParser.K_RANGE = 73;
TransformsParser.K_REDUCE = 74;
TransformsParser.K_REPARTITION = 75;
TransformsParser.K_RIGHT = 76;
TransformsParser.K_ROW = 77;
TransformsParser.K_ROWS = 78;
TransformsParser.K_SELECT = 79;
TransformsParser.K_THEN = 80;
TransformsParser.K_TRUE = 81;
TransformsParser.K_UNBOUNDED = 82;
TransformsParser.K_UNION = 83;
TransformsParser.K_UNPIVOT = 84;
TransformsParser.K_USE = 85;
TransformsParser.K_WINDOW = 86;
TransformsParser.K_WITH = 87;
TransformsParser.K_WHEN = 88;
TransformsParser.K_SAMPLE = 89;
TransformsParser.K_SEED = 90;
TransformsParser.STRING_LITERAL = 91;
TransformsParser.LONG_LITERAL = 92;
TransformsParser.INTEGER_LITERAL = 93;
TransformsParser.NUMERIC_LITERAL = 94;
TransformsParser.IDENTIFIER = 95;
TransformsParser.SPACES = 96;
TransformsParser.SINGLE_LINE_COMMENT_SQL = 97;
TransformsParser.SINGLE_LINE_COMMENT_C = 98;
TransformsParser.MULTILINE_COMMENT = 99;
TransformsParser.UNCLOSED_MULTILINE_COMMENT = 100;

TransformsParser.RULE_parseSemanticOp = 0;
TransformsParser.RULE_semantic_op = 1;
TransformsParser.RULE_semantic_unpivot_clause = 2;
TransformsParser.RULE_semantic_multi_formula_clause = 3;
TransformsParser.RULE_dep_value = 4;
TransformsParser.RULE_ops = 5;
TransformsParser.RULE_script = 6;
TransformsParser.RULE_op = 7;
TransformsParser.RULE_selectOp = 8;
TransformsParser.RULE_groupByOp = 9;
TransformsParser.RULE_mergeOp = 10;
TransformsParser.RULE_windowOp = 11;
TransformsParser.RULE_pivotOp = 12;
TransformsParser.RULE_unpivotOp = 13;
TransformsParser.RULE_rowsOp = 14;
TransformsParser.RULE_lookupOp = 15;
TransformsParser.RULE_explodeOp = 16;
TransformsParser.RULE_filterOp = 17;
TransformsParser.RULE_joinOp = 18;
TransformsParser.RULE_sortOp = 19;
TransformsParser.RULE_unionOp = 20;
TransformsParser.RULE_dropOp = 21;
TransformsParser.RULE_repartitionOp = 22;
TransformsParser.RULE_checkpointOp = 23;
TransformsParser.RULE_useHintOp = 24;
TransformsParser.RULE_hintOp = 25;
TransformsParser.RULE_sampleOp = 26;
TransformsParser.RULE_useOp = 27;
TransformsParser.RULE_labelOp = 28;
TransformsParser.RULE_blockOp = 29;
TransformsParser.RULE_enforcePKOp = 30;
TransformsParser.RULE_selector_pre = 31;
TransformsParser.RULE_selector_post = 32;
TransformsParser.RULE_pivot_when_clause = 33;
TransformsParser.RULE_pivot_else_clause = 34;
TransformsParser.RULE_row_clause = 35;
TransformsParser.RULE_named_exprs = 36;
TransformsParser.RULE_exprs = 37;
TransformsParser.RULE_join_type = 38;
TransformsParser.RULE_named_expr = 39;
TransformsParser.RULE_rename_expr = 40;
TransformsParser.RULE_rename_from = 41;
TransformsParser.RULE_rename_to = 42;
TransformsParser.RULE_sort_clause = 43;
TransformsParser.RULE_window_frame = 44;
TransformsParser.RULE_window_frame_interval = 45;
TransformsParser.RULE_window_frame_boundary = 46;
TransformsParser.RULE_parseExpr = 47;
TransformsParser.RULE_expr = 48;
TransformsParser.RULE_unpack_expr = 49;
TransformsParser.RULE_literalRecord = 50;
TransformsParser.RULE_record_fields = 51;
TransformsParser.RULE_record_field = 52;
TransformsParser.RULE_literalInteger = 53;
TransformsParser.RULE_literalLong = 54;
TransformsParser.RULE_literalNumber = 55;
TransformsParser.RULE_literalString = 56;
TransformsParser.RULE_literalNull = 57;
TransformsParser.RULE_literalTrue = 58;
TransformsParser.RULE_literalFalse = 59;
TransformsParser.RULE_case_when_clause = 60;
TransformsParser.RULE_case_else_clause = 61;
TransformsParser.RULE_function_reference = 62;
TransformsParser.RULE_lambda = 63;
TransformsParser.RULE_function_name = 64;
TransformsParser.RULE_dataset = 65;
TransformsParser.RULE_dataset_name = 66;
TransformsParser.RULE_dataset_expr = 67;
TransformsParser.RULE_hint = 68;
TransformsParser.RULE_dataset_list = 69;
TransformsParser.RULE_hint_list = 70;
TransformsParser.RULE_identifier_list = 71;
TransformsParser.RULE_id = 72;
TransformsParser.RULE_id_fragment = 73;
TransformsParser.RULE_comments = 74;
TransformsParser.RULE_comment = 75;

function ParseSemanticOpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_parseSemanticOp;
    return this;
}

ParseSemanticOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ParseSemanticOpContext.prototype.constructor = ParseSemanticOpContext;

ParseSemanticOpContext.prototype.semantic_op = function() {
    return this.getTypedRuleContext(Semantic_opContext,0);
};

ParseSemanticOpContext.prototype.EOF = function() {
    return this.getToken(TransformsParser.EOF, 0);
};

ParseSemanticOpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterParseSemanticOp(this);
	}
};

ParseSemanticOpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitParseSemanticOp(this);
	}
};

ParseSemanticOpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitParseSemanticOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.ParseSemanticOpContext = ParseSemanticOpContext;

TransformsParser.prototype.parseSemanticOp = function() {

    var localctx = new ParseSemanticOpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 0, TransformsParser.RULE_parseSemanticOp);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 152;
        this.semantic_op();
        this.state = 153;
        this.match(TransformsParser.EOF);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Semantic_opContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_semantic_op;
    return this;
}

Semantic_opContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Semantic_opContext.prototype.constructor = Semantic_opContext;


 
Semantic_opContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function SemanticFillContext(parser, ctx) {
	Semantic_opContext.call(this, parser);
    Semantic_opContext.prototype.copyFrom.call(this, ctx);
    return this;
}

SemanticFillContext.prototype = Object.create(Semantic_opContext.prototype);
SemanticFillContext.prototype.constructor = SemanticFillContext;

TransformsParser.SemanticFillContext = SemanticFillContext;

SemanticFillContext.prototype.K_SELECT = function() {
    return this.getToken(TransformsParser.K_SELECT, 0);
};

SemanticFillContext.prototype.STRING_LITERAL = function() {
    return this.getToken(TransformsParser.STRING_LITERAL, 0);
};

SemanticFillContext.prototype.K_AS = function() {
    return this.getToken(TransformsParser.K_AS, 0);
};

SemanticFillContext.prototype.id = function() {
    return this.getTypedRuleContext(IdContext,0);
};
SemanticFillContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterSemanticFill(this);
	}
};

SemanticFillContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitSemanticFill(this);
	}
};

SemanticFillContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitSemanticFill(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function SemanticUnpivotContext(parser, ctx) {
	Semantic_opContext.call(this, parser);
    Semantic_opContext.prototype.copyFrom.call(this, ctx);
    return this;
}

SemanticUnpivotContext.prototype = Object.create(Semantic_opContext.prototype);
SemanticUnpivotContext.prototype.constructor = SemanticUnpivotContext;

TransformsParser.SemanticUnpivotContext = SemanticUnpivotContext;

SemanticUnpivotContext.prototype.K_UNPIVOT = function() {
    return this.getToken(TransformsParser.K_UNPIVOT, 0);
};

SemanticUnpivotContext.prototype.semantic_unpivot_clause = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Semantic_unpivot_clauseContext);
    } else {
        return this.getTypedRuleContext(Semantic_unpivot_clauseContext,i);
    }
};
SemanticUnpivotContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterSemanticUnpivot(this);
	}
};

SemanticUnpivotContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitSemanticUnpivot(this);
	}
};

SemanticUnpivotContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitSemanticUnpivot(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function SemanticScriptContext(parser, ctx) {
	Semantic_opContext.call(this, parser);
    Semantic_opContext.prototype.copyFrom.call(this, ctx);
    return this;
}

SemanticScriptContext.prototype = Object.create(Semantic_opContext.prototype);
SemanticScriptContext.prototype.constructor = SemanticScriptContext;

TransformsParser.SemanticScriptContext = SemanticScriptContext;

SemanticScriptContext.prototype.script = function() {
    return this.getTypedRuleContext(ScriptContext,0);
};
SemanticScriptContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterSemanticScript(this);
	}
};

SemanticScriptContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitSemanticScript(this);
	}
};

SemanticScriptContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitSemanticScript(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function SemanticFormulaContext(parser, ctx) {
	Semantic_opContext.call(this, parser);
    Semantic_opContext.prototype.copyFrom.call(this, ctx);
    return this;
}

SemanticFormulaContext.prototype = Object.create(Semantic_opContext.prototype);
SemanticFormulaContext.prototype.constructor = SemanticFormulaContext;

TransformsParser.SemanticFormulaContext = SemanticFormulaContext;

SemanticFormulaContext.prototype.K_SELECT = function() {
    return this.getToken(TransformsParser.K_SELECT, 0);
};

SemanticFormulaContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};

SemanticFormulaContext.prototype.K_AS = function() {
    return this.getToken(TransformsParser.K_AS, 0);
};

SemanticFormulaContext.prototype.id = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(IdContext);
    } else {
        return this.getTypedRuleContext(IdContext,i);
    }
};
SemanticFormulaContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterSemanticFormula(this);
	}
};

SemanticFormulaContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitSemanticFormula(this);
	}
};

SemanticFormulaContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitSemanticFormula(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function SemanticFillCoalesceContext(parser, ctx) {
	Semantic_opContext.call(this, parser);
    Semantic_opContext.prototype.copyFrom.call(this, ctx);
    return this;
}

SemanticFillCoalesceContext.prototype = Object.create(Semantic_opContext.prototype);
SemanticFillCoalesceContext.prototype.constructor = SemanticFillCoalesceContext;

TransformsParser.SemanticFillCoalesceContext = SemanticFillCoalesceContext;

SemanticFillCoalesceContext.prototype.K_SELECT = function() {
    return this.getToken(TransformsParser.K_SELECT, 0);
};

SemanticFillCoalesceContext.prototype.K_CASE = function() {
    return this.getToken(TransformsParser.K_CASE, 0);
};

SemanticFillCoalesceContext.prototype.K_WHEN = function() {
    return this.getToken(TransformsParser.K_WHEN, 0);
};

SemanticFillCoalesceContext.prototype.id = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(IdContext);
    } else {
        return this.getTypedRuleContext(IdContext,i);
    }
};

SemanticFillCoalesceContext.prototype.K_IS = function() {
    return this.getToken(TransformsParser.K_IS, 0);
};

SemanticFillCoalesceContext.prototype.K_NOT = function() {
    return this.getToken(TransformsParser.K_NOT, 0);
};

SemanticFillCoalesceContext.prototype.K_EMPTY = function() {
    return this.getToken(TransformsParser.K_EMPTY, 0);
};

SemanticFillCoalesceContext.prototype.K_THEN = function() {
    return this.getToken(TransformsParser.K_THEN, 0);
};

SemanticFillCoalesceContext.prototype.K_ELSE = function() {
    return this.getToken(TransformsParser.K_ELSE, 0);
};

SemanticFillCoalesceContext.prototype.K_ARRAY = function() {
    return this.getToken(TransformsParser.K_ARRAY, 0);
};

SemanticFillCoalesceContext.prototype.STRING_LITERAL = function() {
    return this.getToken(TransformsParser.STRING_LITERAL, 0);
};

SemanticFillCoalesceContext.prototype.K_END = function() {
    return this.getToken(TransformsParser.K_END, 0);
};

SemanticFillCoalesceContext.prototype.K_AS = function() {
    return this.getToken(TransformsParser.K_AS, 0);
};
SemanticFillCoalesceContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterSemanticFillCoalesce(this);
	}
};

SemanticFillCoalesceContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitSemanticFillCoalesce(this);
	}
};

SemanticFillCoalesceContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitSemanticFillCoalesce(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function SemanticMultiFormulaContext(parser, ctx) {
	Semantic_opContext.call(this, parser);
    Semantic_opContext.prototype.copyFrom.call(this, ctx);
    return this;
}

SemanticMultiFormulaContext.prototype = Object.create(Semantic_opContext.prototype);
SemanticMultiFormulaContext.prototype.constructor = SemanticMultiFormulaContext;

TransformsParser.SemanticMultiFormulaContext = SemanticMultiFormulaContext;

SemanticMultiFormulaContext.prototype.K_SELECT = function() {
    return this.getToken(TransformsParser.K_SELECT, 0);
};

SemanticMultiFormulaContext.prototype.semantic_multi_formula_clause = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Semantic_multi_formula_clauseContext);
    } else {
        return this.getTypedRuleContext(Semantic_multi_formula_clauseContext,i);
    }
};
SemanticMultiFormulaContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterSemanticMultiFormula(this);
	}
};

SemanticMultiFormulaContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitSemanticMultiFormula(this);
	}
};

SemanticMultiFormulaContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitSemanticMultiFormula(this);
    } else {
        return visitor.visitChildren(this);
    }
};



TransformsParser.Semantic_opContext = Semantic_opContext;

TransformsParser.prototype.semantic_op = function() {

    var localctx = new Semantic_opContext(this, this._ctx, this.state);
    this.enterRule(localctx, 2, TransformsParser.RULE_semantic_op);
    var _la = 0; // Token type
    try {
        this.state = 214;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,3,this._ctx);
        switch(la_) {
        case 1:
            localctx = new SemanticFillContext(this, localctx);
            this.enterOuterAlt(localctx, 1);
            this.state = 155;
            this.match(TransformsParser.K_SELECT);
            this.state = 156;
            this.match(TransformsParser.T__0);
            this.state = 157;
            this.match(TransformsParser.T__1);
            this.state = 158;
            this.match(TransformsParser.STRING_LITERAL);
            this.state = 159;
            this.match(TransformsParser.K_AS);
            this.state = 160;
            this.id();
            break;

        case 2:
            localctx = new SemanticFillCoalesceContext(this, localctx);
            this.enterOuterAlt(localctx, 2);
            this.state = 161;
            this.match(TransformsParser.K_SELECT);
            this.state = 162;
            this.match(TransformsParser.T__0);
            this.state = 163;
            this.match(TransformsParser.T__1);
            this.state = 164;
            this.match(TransformsParser.K_CASE);
            this.state = 165;
            this.match(TransformsParser.K_WHEN);
            this.state = 166;
            this.id();
            this.state = 167;
            this.match(TransformsParser.K_IS);
            this.state = 168;
            this.match(TransformsParser.K_NOT);
            this.state = 169;
            this.match(TransformsParser.K_EMPTY);
            this.state = 170;
            this.match(TransformsParser.K_THEN);
            this.state = 171;
            this.id();
            this.state = 172;
            this.match(TransformsParser.K_ELSE);
            this.state = 173;
            this.match(TransformsParser.K_ARRAY);
            this.state = 174;
            this.match(TransformsParser.T__2);
            this.state = 175;
            this.match(TransformsParser.STRING_LITERAL);
            this.state = 176;
            this.match(TransformsParser.T__3);
            this.state = 177;
            this.match(TransformsParser.K_END);
            this.state = 178;
            this.match(TransformsParser.K_AS);
            this.state = 179;
            this.id();
            break;

        case 3:
            localctx = new SemanticMultiFormulaContext(this, localctx);
            this.enterOuterAlt(localctx, 3);
            this.state = 181;
            this.match(TransformsParser.K_SELECT);
            this.state = 182;
            this.match(TransformsParser.T__0);
            this.state = 183;
            this.match(TransformsParser.T__1);
            this.state = 184;
            this.semantic_multi_formula_clause();
            this.state = 187; 
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            do {
                this.state = 185;
                this.match(TransformsParser.T__1);
                this.state = 186;
                this.semantic_multi_formula_clause();
                this.state = 189; 
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            } while(_la===TransformsParser.T__1);
            break;

        case 4:
            localctx = new SemanticFormulaContext(this, localctx);
            this.enterOuterAlt(localctx, 4);
            this.state = 191;
            this.match(TransformsParser.K_SELECT);
            this.state = 192;
            this.match(TransformsParser.T__0);
            this.state = 193;
            this.match(TransformsParser.T__1);
            this.state = 194;
            this.expr(0);
            this.state = 195;
            this.match(TransformsParser.K_AS);
            this.state = 196;
            this.id();
            this.state = 201;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===TransformsParser.T__1) {
                this.state = 197;
                this.match(TransformsParser.T__1);
                this.state = 198;
                this.id();
                this.state = 203;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            break;

        case 5:
            localctx = new SemanticUnpivotContext(this, localctx);
            this.enterOuterAlt(localctx, 5);
            this.state = 204;
            this.match(TransformsParser.K_UNPIVOT);
            this.state = 205;
            this.semantic_unpivot_clause();
            this.state = 210;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===TransformsParser.T__1) {
                this.state = 206;
                this.match(TransformsParser.T__1);
                this.state = 207;
                this.semantic_unpivot_clause();
                this.state = 212;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            break;

        case 6:
            localctx = new SemanticScriptContext(this, localctx);
            this.enterOuterAlt(localctx, 6);
            this.state = 213;
            this.script();
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Semantic_unpivot_clauseContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_semantic_unpivot_clause;
    return this;
}

Semantic_unpivot_clauseContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Semantic_unpivot_clauseContext.prototype.constructor = Semantic_unpivot_clauseContext;

Semantic_unpivot_clauseContext.prototype.STRING_LITERAL = function() {
    return this.getToken(TransformsParser.STRING_LITERAL, 0);
};

Semantic_unpivot_clauseContext.prototype.K_AS = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(TransformsParser.K_AS);
    } else {
        return this.getToken(TransformsParser.K_AS, i);
    }
};


Semantic_unpivot_clauseContext.prototype.id = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(IdContext);
    } else {
        return this.getTypedRuleContext(IdContext,i);
    }
};

Semantic_unpivot_clauseContext.prototype.dep_value = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Dep_valueContext);
    } else {
        return this.getTypedRuleContext(Dep_valueContext,i);
    }
};

Semantic_unpivot_clauseContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterSemantic_unpivot_clause(this);
	}
};

Semantic_unpivot_clauseContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitSemantic_unpivot_clause(this);
	}
};

Semantic_unpivot_clauseContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitSemantic_unpivot_clause(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Semantic_unpivot_clauseContext = Semantic_unpivot_clauseContext;

TransformsParser.prototype.semantic_unpivot_clause = function() {

    var localctx = new Semantic_unpivot_clauseContext(this, this._ctx, this.state);
    this.enterRule(localctx, 4, TransformsParser.RULE_semantic_unpivot_clause);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 216;
        this.match(TransformsParser.T__2);
        this.state = 217;
        this.match(TransformsParser.STRING_LITERAL);
        this.state = 218;
        this.match(TransformsParser.K_AS);
        this.state = 219;
        this.id();
        this.state = 220;
        this.match(TransformsParser.T__1);
        this.state = 221;
        this.id();
        this.state = 222;
        this.match(TransformsParser.K_AS);
        this.state = 223;
        this.id();
        this.state = 231;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while(_la===TransformsParser.T__1) {
            this.state = 224;
            this.match(TransformsParser.T__1);
            this.state = 225;
            this.dep_value();
            this.state = 226;
            this.match(TransformsParser.K_AS);
            this.state = 227;
            this.id();
            this.state = 233;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
        this.state = 234;
        this.match(TransformsParser.T__3);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Semantic_multi_formula_clauseContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_semantic_multi_formula_clause;
    return this;
}

Semantic_multi_formula_clauseContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Semantic_multi_formula_clauseContext.prototype.constructor = Semantic_multi_formula_clauseContext;

Semantic_multi_formula_clauseContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};

Semantic_multi_formula_clauseContext.prototype.K_AS = function() {
    return this.getToken(TransformsParser.K_AS, 0);
};

Semantic_multi_formula_clauseContext.prototype.id = function() {
    return this.getTypedRuleContext(IdContext,0);
};

Semantic_multi_formula_clauseContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterSemantic_multi_formula_clause(this);
	}
};

Semantic_multi_formula_clauseContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitSemantic_multi_formula_clause(this);
	}
};

Semantic_multi_formula_clauseContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitSemantic_multi_formula_clause(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Semantic_multi_formula_clauseContext = Semantic_multi_formula_clauseContext;

TransformsParser.prototype.semantic_multi_formula_clause = function() {

    var localctx = new Semantic_multi_formula_clauseContext(this, this._ctx, this.state);
    this.enterRule(localctx, 6, TransformsParser.RULE_semantic_multi_formula_clause);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 236;
        this.expr(0);
        this.state = 237;
        this.match(TransformsParser.K_AS);
        this.state = 238;
        this.id();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Dep_valueContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_dep_value;
    return this;
}

Dep_valueContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Dep_valueContext.prototype.constructor = Dep_valueContext;

Dep_valueContext.prototype.id = function() {
    return this.getTypedRuleContext(IdContext,0);
};

Dep_valueContext.prototype.K_NULL = function() {
    return this.getToken(TransformsParser.K_NULL, 0);
};

Dep_valueContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterDep_value(this);
	}
};

Dep_valueContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitDep_value(this);
	}
};

Dep_valueContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitDep_value(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Dep_valueContext = Dep_valueContext;

TransformsParser.prototype.dep_value = function() {

    var localctx = new Dep_valueContext(this, this._ctx, this.state);
    this.enterRule(localctx, 8, TransformsParser.RULE_dep_value);
    try {
        this.state = 242;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case TransformsParser.K_ALL:
        case TransformsParser.K_ARRAY:
        case TransformsParser.K_BETWEEN:
        case TransformsParser.K_CHECKPOINT:
        case TransformsParser.K_CURRENT:
        case TransformsParser.K_DISAMBIGUATE:
        case TransformsParser.K_DROP:
        case TransformsParser.K_ENFORCE:
        case TransformsParser.K_FIRST:
        case TransformsParser.K_FOLLOWING:
        case TransformsParser.K_JOIN:
        case TransformsParser.K_KEY:
        case TransformsParser.K_LAST:
        case TransformsParser.K_LOOKUP:
        case TransformsParser.K_NULLS:
        case TransformsParser.K_PRECEDING:
        case TransformsParser.K_PRIMARY:
        case TransformsParser.K_RANGE:
        case TransformsParser.K_ROW:
        case TransformsParser.K_ROWS:
        case TransformsParser.K_UNBOUNDED:
        case TransformsParser.K_UNPIVOT:
        case TransformsParser.K_WINDOW:
        case TransformsParser.K_SAMPLE:
        case TransformsParser.K_SEED:
        case TransformsParser.IDENTIFIER:
            this.enterOuterAlt(localctx, 1);
            this.state = 240;
            this.id();
            break;
        case TransformsParser.K_NULL:
            this.enterOuterAlt(localctx, 2);
            this.state = 241;
            this.match(TransformsParser.K_NULL);
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function OpsContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_ops;
    return this;
}

OpsContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
OpsContext.prototype.constructor = OpsContext;

OpsContext.prototype.script = function() {
    return this.getTypedRuleContext(ScriptContext,0);
};

OpsContext.prototype.EOF = function() {
    return this.getToken(TransformsParser.EOF, 0);
};

OpsContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterOps(this);
	}
};

OpsContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitOps(this);
	}
};

OpsContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitOps(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.OpsContext = OpsContext;

TransformsParser.prototype.ops = function() {

    var localctx = new OpsContext(this, this._ctx, this.state);
    this.enterRule(localctx, 10, TransformsParser.RULE_ops);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 244;
        this.script();
        this.state = 245;
        this.match(TransformsParser.EOF);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ScriptContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_script;
    return this;
}

ScriptContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ScriptContext.prototype.constructor = ScriptContext;

ScriptContext.prototype.op = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(OpContext);
    } else {
        return this.getTypedRuleContext(OpContext,i);
    }
};

ScriptContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterScript(this);
	}
};

ScriptContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitScript(this);
	}
};

ScriptContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitScript(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.ScriptContext = ScriptContext;

TransformsParser.prototype.script = function() {

    var localctx = new ScriptContext(this, this._ctx, this.state);
    this.enterRule(localctx, 12, TransformsParser.RULE_script);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 248;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.T__5) | (1 << TransformsParser.T__6) | (1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CROSS - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_EXPLODE - 32)) | (1 << (TransformsParser.K_FILTER - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_FULL - 32)) | (1 << (TransformsParser.K_GROUP - 32)) | (1 << (TransformsParser.K_HINT - 32)) | (1 << (TransformsParser.K_INNER - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)) | (1 << (TransformsParser.K_LEFT - 32)) | (1 << (TransformsParser.K_MERGE - 32)))) !== 0) || ((((_la - 65)) & ~0x1f) == 0 && ((1 << (_la - 65)) & ((1 << (TransformsParser.K_NULLS - 65)) | (1 << (TransformsParser.K_ORDER - 65)) | (1 << (TransformsParser.K_OUTER - 65)) | (1 << (TransformsParser.K_PIVOT - 65)) | (1 << (TransformsParser.K_PRECEDING - 65)) | (1 << (TransformsParser.K_PRIMARY - 65)) | (1 << (TransformsParser.K_RANGE - 65)) | (1 << (TransformsParser.K_REPARTITION - 65)) | (1 << (TransformsParser.K_RIGHT - 65)) | (1 << (TransformsParser.K_ROW - 65)) | (1 << (TransformsParser.K_ROWS - 65)) | (1 << (TransformsParser.K_SELECT - 65)) | (1 << (TransformsParser.K_UNBOUNDED - 65)) | (1 << (TransformsParser.K_UNION - 65)) | (1 << (TransformsParser.K_UNPIVOT - 65)) | (1 << (TransformsParser.K_USE - 65)) | (1 << (TransformsParser.K_WINDOW - 65)) | (1 << (TransformsParser.K_SAMPLE - 65)) | (1 << (TransformsParser.K_SEED - 65)) | (1 << (TransformsParser.IDENTIFIER - 65)))) !== 0)) {
            this.state = 247;
            this.op();
        }

        this.state = 256;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while(_la===TransformsParser.T__4) {
            this.state = 250;
            this.match(TransformsParser.T__4);
            this.state = 252;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.T__5) | (1 << TransformsParser.T__6) | (1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CROSS - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_EXPLODE - 32)) | (1 << (TransformsParser.K_FILTER - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_FULL - 32)) | (1 << (TransformsParser.K_GROUP - 32)) | (1 << (TransformsParser.K_HINT - 32)) | (1 << (TransformsParser.K_INNER - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)) | (1 << (TransformsParser.K_LEFT - 32)) | (1 << (TransformsParser.K_MERGE - 32)))) !== 0) || ((((_la - 65)) & ~0x1f) == 0 && ((1 << (_la - 65)) & ((1 << (TransformsParser.K_NULLS - 65)) | (1 << (TransformsParser.K_ORDER - 65)) | (1 << (TransformsParser.K_OUTER - 65)) | (1 << (TransformsParser.K_PIVOT - 65)) | (1 << (TransformsParser.K_PRECEDING - 65)) | (1 << (TransformsParser.K_PRIMARY - 65)) | (1 << (TransformsParser.K_RANGE - 65)) | (1 << (TransformsParser.K_REPARTITION - 65)) | (1 << (TransformsParser.K_RIGHT - 65)) | (1 << (TransformsParser.K_ROW - 65)) | (1 << (TransformsParser.K_ROWS - 65)) | (1 << (TransformsParser.K_SELECT - 65)) | (1 << (TransformsParser.K_UNBOUNDED - 65)) | (1 << (TransformsParser.K_UNION - 65)) | (1 << (TransformsParser.K_UNPIVOT - 65)) | (1 << (TransformsParser.K_USE - 65)) | (1 << (TransformsParser.K_WINDOW - 65)) | (1 << (TransformsParser.K_SAMPLE - 65)) | (1 << (TransformsParser.K_SEED - 65)) | (1 << (TransformsParser.IDENTIFIER - 65)))) !== 0)) {
                this.state = 251;
                this.op();
            }

            this.state = 258;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function OpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_op;
    return this;
}

OpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
OpContext.prototype.constructor = OpContext;

OpContext.prototype.selectOp = function() {
    return this.getTypedRuleContext(SelectOpContext,0);
};

OpContext.prototype.groupByOp = function() {
    return this.getTypedRuleContext(GroupByOpContext,0);
};

OpContext.prototype.mergeOp = function() {
    return this.getTypedRuleContext(MergeOpContext,0);
};

OpContext.prototype.windowOp = function() {
    return this.getTypedRuleContext(WindowOpContext,0);
};

OpContext.prototype.pivotOp = function() {
    return this.getTypedRuleContext(PivotOpContext,0);
};

OpContext.prototype.unpivotOp = function() {
    return this.getTypedRuleContext(UnpivotOpContext,0);
};

OpContext.prototype.explodeOp = function() {
    return this.getTypedRuleContext(ExplodeOpContext,0);
};

OpContext.prototype.filterOp = function() {
    return this.getTypedRuleContext(FilterOpContext,0);
};

OpContext.prototype.joinOp = function() {
    return this.getTypedRuleContext(JoinOpContext,0);
};

OpContext.prototype.sortOp = function() {
    return this.getTypedRuleContext(SortOpContext,0);
};

OpContext.prototype.unionOp = function() {
    return this.getTypedRuleContext(UnionOpContext,0);
};

OpContext.prototype.dropOp = function() {
    return this.getTypedRuleContext(DropOpContext,0);
};

OpContext.prototype.repartitionOp = function() {
    return this.getTypedRuleContext(RepartitionOpContext,0);
};

OpContext.prototype.checkpointOp = function() {
    return this.getTypedRuleContext(CheckpointOpContext,0);
};

OpContext.prototype.useHintOp = function() {
    return this.getTypedRuleContext(UseHintOpContext,0);
};

OpContext.prototype.hintOp = function() {
    return this.getTypedRuleContext(HintOpContext,0);
};

OpContext.prototype.sampleOp = function() {
    return this.getTypedRuleContext(SampleOpContext,0);
};

OpContext.prototype.useOp = function() {
    return this.getTypedRuleContext(UseOpContext,0);
};

OpContext.prototype.labelOp = function() {
    return this.getTypedRuleContext(LabelOpContext,0);
};

OpContext.prototype.lookupOp = function() {
    return this.getTypedRuleContext(LookupOpContext,0);
};

OpContext.prototype.blockOp = function() {
    return this.getTypedRuleContext(BlockOpContext,0);
};

OpContext.prototype.rowsOp = function() {
    return this.getTypedRuleContext(RowsOpContext,0);
};

OpContext.prototype.enforcePKOp = function() {
    return this.getTypedRuleContext(EnforcePKOpContext,0);
};

OpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterOp(this);
	}
};

OpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitOp(this);
	}
};

OpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.OpContext = OpContext;

TransformsParser.prototype.op = function() {

    var localctx = new OpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 14, TransformsParser.RULE_op);
    try {
        this.state = 282;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,9,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 259;
            this.selectOp();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 260;
            this.groupByOp();
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 261;
            this.mergeOp();
            break;

        case 4:
            this.enterOuterAlt(localctx, 4);
            this.state = 262;
            this.windowOp();
            break;

        case 5:
            this.enterOuterAlt(localctx, 5);
            this.state = 263;
            this.pivotOp();
            break;

        case 6:
            this.enterOuterAlt(localctx, 6);
            this.state = 264;
            this.unpivotOp();
            break;

        case 7:
            this.enterOuterAlt(localctx, 7);
            this.state = 265;
            this.explodeOp();
            break;

        case 8:
            this.enterOuterAlt(localctx, 8);
            this.state = 266;
            this.filterOp();
            break;

        case 9:
            this.enterOuterAlt(localctx, 9);
            this.state = 267;
            this.joinOp();
            break;

        case 10:
            this.enterOuterAlt(localctx, 10);
            this.state = 268;
            this.sortOp();
            break;

        case 11:
            this.enterOuterAlt(localctx, 11);
            this.state = 269;
            this.unionOp();
            break;

        case 12:
            this.enterOuterAlt(localctx, 12);
            this.state = 270;
            this.dropOp();
            break;

        case 13:
            this.enterOuterAlt(localctx, 13);
            this.state = 271;
            this.repartitionOp();
            break;

        case 14:
            this.enterOuterAlt(localctx, 14);
            this.state = 272;
            this.checkpointOp();
            break;

        case 15:
            this.enterOuterAlt(localctx, 15);
            this.state = 273;
            this.useHintOp();
            break;

        case 16:
            this.enterOuterAlt(localctx, 16);
            this.state = 274;
            this.hintOp();
            break;

        case 17:
            this.enterOuterAlt(localctx, 17);
            this.state = 275;
            this.sampleOp();
            break;

        case 18:
            this.enterOuterAlt(localctx, 18);
            this.state = 276;
            this.useOp();
            break;

        case 19:
            this.enterOuterAlt(localctx, 19);
            this.state = 277;
            this.labelOp();
            break;

        case 20:
            this.enterOuterAlt(localctx, 20);
            this.state = 278;
            this.lookupOp();
            break;

        case 21:
            this.enterOuterAlt(localctx, 21);
            this.state = 279;
            this.blockOp();
            break;

        case 22:
            this.enterOuterAlt(localctx, 22);
            this.state = 280;
            this.rowsOp();
            break;

        case 23:
            this.enterOuterAlt(localctx, 23);
            this.state = 281;
            this.enforcePKOp();
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function SelectOpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_selectOp;
    return this;
}

SelectOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SelectOpContext.prototype.constructor = SelectOpContext;

SelectOpContext.prototype.K_SELECT = function() {
    return this.getToken(TransformsParser.K_SELECT, 0);
};

SelectOpContext.prototype.selector_pre = function() {
    return this.getTypedRuleContext(Selector_preContext,0);
};

SelectOpContext.prototype.selector_post = function() {
    return this.getTypedRuleContext(Selector_postContext,0);
};

SelectOpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterSelectOp(this);
	}
};

SelectOpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitSelectOp(this);
	}
};

SelectOpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitSelectOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.SelectOpContext = SelectOpContext;

TransformsParser.prototype.selectOp = function() {

    var localctx = new SelectOpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 16, TransformsParser.RULE_selectOp);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 284;
        this.match(TransformsParser.K_SELECT);
        this.state = 287;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,10,this._ctx);
        if(la_===1) {
            this.state = 285;
            this.selector_pre();

        } else if(la_===2) {
            this.state = 286;
            this.selector_post();

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function GroupByOpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_groupByOp;
    return this;
}

GroupByOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
GroupByOpContext.prototype.constructor = GroupByOpContext;

GroupByOpContext.prototype.K_GROUP = function() {
    return this.getToken(TransformsParser.K_GROUP, 0);
};

GroupByOpContext.prototype.K_BY = function() {
    return this.getToken(TransformsParser.K_BY, 0);
};

GroupByOpContext.prototype.identifier_list = function() {
    return this.getTypedRuleContext(Identifier_listContext,0);
};

GroupByOpContext.prototype.named_exprs = function() {
    return this.getTypedRuleContext(Named_exprsContext,0);
};

GroupByOpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterGroupByOp(this);
	}
};

GroupByOpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitGroupByOp(this);
	}
};

GroupByOpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitGroupByOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.GroupByOpContext = GroupByOpContext;

TransformsParser.prototype.groupByOp = function() {

    var localctx = new GroupByOpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 18, TransformsParser.RULE_groupByOp);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 289;
        this.match(TransformsParser.K_GROUP);
        this.state = 291;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.T__2) | (1 << TransformsParser.T__6) | (1 << TransformsParser.T__9) | (1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN) | (1 << TransformsParser.K_CASE))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CONVERT_ARRAY - 32)) | (1 << (TransformsParser.K_CONVERT_STRUCT - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_FALSE - 32)) | (1 << (TransformsParser.K_FILTER - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)) | (1 << (TransformsParser.K_MAP - 32)) | (1 << (TransformsParser.K_NOT - 32)))) !== 0) || ((((_la - 64)) & ~0x1f) == 0 && ((1 << (_la - 64)) & ((1 << (TransformsParser.K_NULL - 64)) | (1 << (TransformsParser.K_NULLS - 64)) | (1 << (TransformsParser.K_PRECEDING - 64)) | (1 << (TransformsParser.K_PRIMARY - 64)) | (1 << (TransformsParser.K_RANGE - 64)) | (1 << (TransformsParser.K_REDUCE - 64)) | (1 << (TransformsParser.K_ROW - 64)) | (1 << (TransformsParser.K_ROWS - 64)) | (1 << (TransformsParser.K_TRUE - 64)) | (1 << (TransformsParser.K_UNBOUNDED - 64)) | (1 << (TransformsParser.K_UNPIVOT - 64)) | (1 << (TransformsParser.K_WINDOW - 64)) | (1 << (TransformsParser.K_SAMPLE - 64)) | (1 << (TransformsParser.K_SEED - 64)) | (1 << (TransformsParser.STRING_LITERAL - 64)) | (1 << (TransformsParser.LONG_LITERAL - 64)) | (1 << (TransformsParser.INTEGER_LITERAL - 64)) | (1 << (TransformsParser.NUMERIC_LITERAL - 64)) | (1 << (TransformsParser.IDENTIFIER - 64)))) !== 0)) {
            this.state = 290;
            this.named_exprs();
        }

        this.state = 293;
        this.match(TransformsParser.K_BY);
        this.state = 294;
        this.identifier_list();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function MergeOpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_mergeOp;
    return this;
}

MergeOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
MergeOpContext.prototype.constructor = MergeOpContext;

MergeOpContext.prototype.K_MERGE = function() {
    return this.getToken(TransformsParser.K_MERGE, 0);
};

MergeOpContext.prototype.K_BY = function() {
    return this.getToken(TransformsParser.K_BY, 0);
};

MergeOpContext.prototype.identifier_list = function() {
    return this.getTypedRuleContext(Identifier_listContext,0);
};

MergeOpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterMergeOp(this);
	}
};

MergeOpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitMergeOp(this);
	}
};

MergeOpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitMergeOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.MergeOpContext = MergeOpContext;

TransformsParser.prototype.mergeOp = function() {

    var localctx = new MergeOpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 20, TransformsParser.RULE_mergeOp);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 296;
        this.match(TransformsParser.K_MERGE);
        this.state = 297;
        this.match(TransformsParser.K_BY);
        this.state = 298;
        this.identifier_list();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function WindowOpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_windowOp;
    return this;
}

WindowOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
WindowOpContext.prototype.constructor = WindowOpContext;

WindowOpContext.prototype.K_WINDOW = function() {
    return this.getToken(TransformsParser.K_WINDOW, 0);
};

WindowOpContext.prototype.named_exprs = function() {
    return this.getTypedRuleContext(Named_exprsContext,0);
};

WindowOpContext.prototype.K_BY = function() {
    return this.getToken(TransformsParser.K_BY, 0);
};

WindowOpContext.prototype.identifier_list = function() {
    return this.getTypedRuleContext(Identifier_listContext,0);
};

WindowOpContext.prototype.sortOp = function() {
    return this.getTypedRuleContext(SortOpContext,0);
};

WindowOpContext.prototype.window_frame = function() {
    return this.getTypedRuleContext(Window_frameContext,0);
};

WindowOpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterWindowOp(this);
	}
};

WindowOpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitWindowOp(this);
	}
};

WindowOpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitWindowOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.WindowOpContext = WindowOpContext;

TransformsParser.prototype.windowOp = function() {

    var localctx = new WindowOpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 22, TransformsParser.RULE_windowOp);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 300;
        this.match(TransformsParser.K_WINDOW);
        this.state = 302;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.T__2) | (1 << TransformsParser.T__6) | (1 << TransformsParser.T__9) | (1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN) | (1 << TransformsParser.K_CASE))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CONVERT_ARRAY - 32)) | (1 << (TransformsParser.K_CONVERT_STRUCT - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_FALSE - 32)) | (1 << (TransformsParser.K_FILTER - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)) | (1 << (TransformsParser.K_MAP - 32)) | (1 << (TransformsParser.K_NOT - 32)))) !== 0) || ((((_la - 64)) & ~0x1f) == 0 && ((1 << (_la - 64)) & ((1 << (TransformsParser.K_NULL - 64)) | (1 << (TransformsParser.K_NULLS - 64)) | (1 << (TransformsParser.K_PRECEDING - 64)) | (1 << (TransformsParser.K_PRIMARY - 64)) | (1 << (TransformsParser.K_RANGE - 64)) | (1 << (TransformsParser.K_REDUCE - 64)) | (1 << (TransformsParser.K_ROW - 64)) | (1 << (TransformsParser.K_ROWS - 64)) | (1 << (TransformsParser.K_TRUE - 64)) | (1 << (TransformsParser.K_UNBOUNDED - 64)) | (1 << (TransformsParser.K_UNPIVOT - 64)) | (1 << (TransformsParser.K_WINDOW - 64)) | (1 << (TransformsParser.K_SAMPLE - 64)) | (1 << (TransformsParser.K_SEED - 64)) | (1 << (TransformsParser.STRING_LITERAL - 64)) | (1 << (TransformsParser.LONG_LITERAL - 64)) | (1 << (TransformsParser.INTEGER_LITERAL - 64)) | (1 << (TransformsParser.NUMERIC_LITERAL - 64)) | (1 << (TransformsParser.IDENTIFIER - 64)))) !== 0)) {
            this.state = 301;
            this.named_exprs();
        }

        this.state = 312;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(_la===TransformsParser.K_BY) {
            this.state = 304;
            this.match(TransformsParser.K_BY);
            this.state = 305;
            this.identifier_list();
            this.state = 307;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if(_la===TransformsParser.K_ORDER) {
                this.state = 306;
                this.sortOp();
            }

            this.state = 310;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if(_la===TransformsParser.K_RANGE || _la===TransformsParser.K_ROWS) {
                this.state = 309;
                this.window_frame();
            }

        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function PivotOpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_pivotOp;
    return this;
}

PivotOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
PivotOpContext.prototype.constructor = PivotOpContext;

PivotOpContext.prototype.K_PIVOT = function() {
    return this.getToken(TransformsParser.K_PIVOT, 0);
};

PivotOpContext.prototype.groupByOp = function() {
    return this.getTypedRuleContext(GroupByOpContext,0);
};

PivotOpContext.prototype.mergeOp = function() {
    return this.getTypedRuleContext(MergeOpContext,0);
};

PivotOpContext.prototype.exprs = function() {
    return this.getTypedRuleContext(ExprsContext,0);
};

PivotOpContext.prototype.pivot_when_clause = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Pivot_when_clauseContext);
    } else {
        return this.getTypedRuleContext(Pivot_when_clauseContext,i);
    }
};

PivotOpContext.prototype.pivot_else_clause = function() {
    return this.getTypedRuleContext(Pivot_else_clauseContext,0);
};

PivotOpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterPivotOp(this);
	}
};

PivotOpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitPivotOp(this);
	}
};

PivotOpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitPivotOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.PivotOpContext = PivotOpContext;

TransformsParser.prototype.pivotOp = function() {

    var localctx = new PivotOpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 24, TransformsParser.RULE_pivotOp);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 314;
        this.match(TransformsParser.K_PIVOT);
        this.state = 316;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.T__2) | (1 << TransformsParser.T__6) | (1 << TransformsParser.T__9) | (1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN) | (1 << TransformsParser.K_CASE))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CONVERT_ARRAY - 32)) | (1 << (TransformsParser.K_CONVERT_STRUCT - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_FALSE - 32)) | (1 << (TransformsParser.K_FILTER - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)) | (1 << (TransformsParser.K_MAP - 32)) | (1 << (TransformsParser.K_NOT - 32)))) !== 0) || ((((_la - 64)) & ~0x1f) == 0 && ((1 << (_la - 64)) & ((1 << (TransformsParser.K_NULL - 64)) | (1 << (TransformsParser.K_NULLS - 64)) | (1 << (TransformsParser.K_PRECEDING - 64)) | (1 << (TransformsParser.K_PRIMARY - 64)) | (1 << (TransformsParser.K_RANGE - 64)) | (1 << (TransformsParser.K_REDUCE - 64)) | (1 << (TransformsParser.K_ROW - 64)) | (1 << (TransformsParser.K_ROWS - 64)) | (1 << (TransformsParser.K_TRUE - 64)) | (1 << (TransformsParser.K_UNBOUNDED - 64)) | (1 << (TransformsParser.K_UNPIVOT - 64)) | (1 << (TransformsParser.K_WINDOW - 64)) | (1 << (TransformsParser.K_SAMPLE - 64)) | (1 << (TransformsParser.K_SEED - 64)) | (1 << (TransformsParser.STRING_LITERAL - 64)) | (1 << (TransformsParser.LONG_LITERAL - 64)) | (1 << (TransformsParser.INTEGER_LITERAL - 64)) | (1 << (TransformsParser.NUMERIC_LITERAL - 64)) | (1 << (TransformsParser.IDENTIFIER - 64)))) !== 0)) {
            this.state = 315;
            this.exprs();
        }

        this.state = 321;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while(_la===TransformsParser.K_WHEN) {
            this.state = 318;
            this.pivot_when_clause();
            this.state = 323;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
        this.state = 325;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(_la===TransformsParser.K_ELSE) {
            this.state = 324;
            this.pivot_else_clause();
        }

        this.state = 329;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case TransformsParser.K_GROUP:
            this.state = 327;
            this.groupByOp();
            break;
        case TransformsParser.K_MERGE:
            this.state = 328;
            this.mergeOp();
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function UnpivotOpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_unpivotOp;
    return this;
}

UnpivotOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
UnpivotOpContext.prototype.constructor = UnpivotOpContext;

UnpivotOpContext.prototype.K_UNPIVOT = function() {
    return this.getToken(TransformsParser.K_UNPIVOT, 0);
};

UnpivotOpContext.prototype.row_clause = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Row_clauseContext);
    } else {
        return this.getTypedRuleContext(Row_clauseContext,i);
    }
};

UnpivotOpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterUnpivotOp(this);
	}
};

UnpivotOpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitUnpivotOp(this);
	}
};

UnpivotOpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitUnpivotOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.UnpivotOpContext = UnpivotOpContext;

TransformsParser.prototype.unpivotOp = function() {

    var localctx = new UnpivotOpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 26, TransformsParser.RULE_unpivotOp);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 331;
        this.match(TransformsParser.K_UNPIVOT);
        this.state = 340;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(_la===TransformsParser.T__2) {
            this.state = 332;
            this.row_clause();
            this.state = 337;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===TransformsParser.T__1) {
                this.state = 333;
                this.match(TransformsParser.T__1);
                this.state = 334;
                this.row_clause();
                this.state = 339;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function RowsOpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_rowsOp;
    return this;
}

RowsOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
RowsOpContext.prototype.constructor = RowsOpContext;

RowsOpContext.prototype.K_ROWS = function() {
    return this.getToken(TransformsParser.K_ROWS, 0);
};

RowsOpContext.prototype.row_clause = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Row_clauseContext);
    } else {
        return this.getTypedRuleContext(Row_clauseContext,i);
    }
};

RowsOpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterRowsOp(this);
	}
};

RowsOpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitRowsOp(this);
	}
};

RowsOpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitRowsOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.RowsOpContext = RowsOpContext;

TransformsParser.prototype.rowsOp = function() {

    var localctx = new RowsOpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 28, TransformsParser.RULE_rowsOp);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 342;
        this.match(TransformsParser.K_ROWS);
        this.state = 351;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(_la===TransformsParser.T__2) {
            this.state = 343;
            this.row_clause();
            this.state = 348;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===TransformsParser.T__1) {
                this.state = 344;
                this.match(TransformsParser.T__1);
                this.state = 345;
                this.row_clause();
                this.state = 350;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function LookupOpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_lookupOp;
    return this;
}

LookupOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
LookupOpContext.prototype.constructor = LookupOpContext;

LookupOpContext.prototype.K_LOOKUP = function() {
    return this.getToken(TransformsParser.K_LOOKUP, 0);
};

LookupOpContext.prototype.named_exprs = function() {
    return this.getTypedRuleContext(Named_exprsContext,0);
};

LookupOpContext.prototype.K_FROM = function() {
    return this.getToken(TransformsParser.K_FROM, 0);
};

LookupOpContext.prototype.dataset = function() {
    return this.getTypedRuleContext(DatasetContext,0);
};

LookupOpContext.prototype.K_ON = function() {
    return this.getToken(TransformsParser.K_ON, 0);
};

LookupOpContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};

LookupOpContext.prototype.K_AS = function() {
    return this.getToken(TransformsParser.K_AS, 0);
};

LookupOpContext.prototype.dataset_name = function() {
    return this.getTypedRuleContext(Dataset_nameContext,0);
};

LookupOpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterLookupOp(this);
	}
};

LookupOpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitLookupOp(this);
	}
};

LookupOpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitLookupOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.LookupOpContext = LookupOpContext;

TransformsParser.prototype.lookupOp = function() {

    var localctx = new LookupOpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 30, TransformsParser.RULE_lookupOp);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 353;
        this.match(TransformsParser.K_LOOKUP);
        this.state = 364;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.T__2) | (1 << TransformsParser.T__6) | (1 << TransformsParser.T__9) | (1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN) | (1 << TransformsParser.K_CASE))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CONVERT_ARRAY - 32)) | (1 << (TransformsParser.K_CONVERT_STRUCT - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_FALSE - 32)) | (1 << (TransformsParser.K_FILTER - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)) | (1 << (TransformsParser.K_MAP - 32)) | (1 << (TransformsParser.K_NOT - 32)))) !== 0) || ((((_la - 64)) & ~0x1f) == 0 && ((1 << (_la - 64)) & ((1 << (TransformsParser.K_NULL - 64)) | (1 << (TransformsParser.K_NULLS - 64)) | (1 << (TransformsParser.K_PRECEDING - 64)) | (1 << (TransformsParser.K_PRIMARY - 64)) | (1 << (TransformsParser.K_RANGE - 64)) | (1 << (TransformsParser.K_REDUCE - 64)) | (1 << (TransformsParser.K_ROW - 64)) | (1 << (TransformsParser.K_ROWS - 64)) | (1 << (TransformsParser.K_TRUE - 64)) | (1 << (TransformsParser.K_UNBOUNDED - 64)) | (1 << (TransformsParser.K_UNPIVOT - 64)) | (1 << (TransformsParser.K_WINDOW - 64)) | (1 << (TransformsParser.K_SAMPLE - 64)) | (1 << (TransformsParser.K_SEED - 64)) | (1 << (TransformsParser.STRING_LITERAL - 64)) | (1 << (TransformsParser.LONG_LITERAL - 64)) | (1 << (TransformsParser.INTEGER_LITERAL - 64)) | (1 << (TransformsParser.NUMERIC_LITERAL - 64)) | (1 << (TransformsParser.IDENTIFIER - 64)))) !== 0)) {
            this.state = 354;
            this.named_exprs();
            this.state = 355;
            this.match(TransformsParser.K_FROM);
            this.state = 356;
            this.dataset();
            this.state = 359;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if(_la===TransformsParser.K_AS) {
                this.state = 357;
                this.match(TransformsParser.K_AS);
                this.state = 358;
                this.dataset_name();
            }

            this.state = 361;
            this.match(TransformsParser.K_ON);
            this.state = 362;
            this.expr(0);
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ExplodeOpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_explodeOp;
    return this;
}

ExplodeOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ExplodeOpContext.prototype.constructor = ExplodeOpContext;

ExplodeOpContext.prototype.K_EXPLODE = function() {
    return this.getToken(TransformsParser.K_EXPLODE, 0);
};

ExplodeOpContext.prototype.named_exprs = function() {
    return this.getTypedRuleContext(Named_exprsContext,0);
};

ExplodeOpContext.prototype.K_INNER = function() {
    return this.getToken(TransformsParser.K_INNER, 0);
};

ExplodeOpContext.prototype.K_OUTER = function() {
    return this.getToken(TransformsParser.K_OUTER, 0);
};

ExplodeOpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterExplodeOp(this);
	}
};

ExplodeOpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitExplodeOp(this);
	}
};

ExplodeOpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitExplodeOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.ExplodeOpContext = ExplodeOpContext;

TransformsParser.prototype.explodeOp = function() {

    var localctx = new ExplodeOpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 32, TransformsParser.RULE_explodeOp);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 366;
        this.match(TransformsParser.K_EXPLODE);
        this.state = 368;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(_la===TransformsParser.K_INNER || _la===TransformsParser.K_OUTER) {
            this.state = 367;
            _la = this._input.LA(1);
            if(!(_la===TransformsParser.K_INNER || _la===TransformsParser.K_OUTER)) {
            this._errHandler.recoverInline(this);
            }
            else {
            	this._errHandler.reportMatch(this);
                this.consume();
            }
        }

        this.state = 371;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.T__2) | (1 << TransformsParser.T__6) | (1 << TransformsParser.T__9) | (1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN) | (1 << TransformsParser.K_CASE))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CONVERT_ARRAY - 32)) | (1 << (TransformsParser.K_CONVERT_STRUCT - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_FALSE - 32)) | (1 << (TransformsParser.K_FILTER - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)) | (1 << (TransformsParser.K_MAP - 32)) | (1 << (TransformsParser.K_NOT - 32)))) !== 0) || ((((_la - 64)) & ~0x1f) == 0 && ((1 << (_la - 64)) & ((1 << (TransformsParser.K_NULL - 64)) | (1 << (TransformsParser.K_NULLS - 64)) | (1 << (TransformsParser.K_PRECEDING - 64)) | (1 << (TransformsParser.K_PRIMARY - 64)) | (1 << (TransformsParser.K_RANGE - 64)) | (1 << (TransformsParser.K_REDUCE - 64)) | (1 << (TransformsParser.K_ROW - 64)) | (1 << (TransformsParser.K_ROWS - 64)) | (1 << (TransformsParser.K_TRUE - 64)) | (1 << (TransformsParser.K_UNBOUNDED - 64)) | (1 << (TransformsParser.K_UNPIVOT - 64)) | (1 << (TransformsParser.K_WINDOW - 64)) | (1 << (TransformsParser.K_SAMPLE - 64)) | (1 << (TransformsParser.K_SEED - 64)) | (1 << (TransformsParser.STRING_LITERAL - 64)) | (1 << (TransformsParser.LONG_LITERAL - 64)) | (1 << (TransformsParser.INTEGER_LITERAL - 64)) | (1 << (TransformsParser.NUMERIC_LITERAL - 64)) | (1 << (TransformsParser.IDENTIFIER - 64)))) !== 0)) {
            this.state = 370;
            this.named_exprs();
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function FilterOpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_filterOp;
    return this;
}

FilterOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
FilterOpContext.prototype.constructor = FilterOpContext;

FilterOpContext.prototype.K_FILTER = function() {
    return this.getToken(TransformsParser.K_FILTER, 0);
};

FilterOpContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};

FilterOpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterFilterOp(this);
	}
};

FilterOpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitFilterOp(this);
	}
};

FilterOpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitFilterOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.FilterOpContext = FilterOpContext;

TransformsParser.prototype.filterOp = function() {

    var localctx = new FilterOpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 34, TransformsParser.RULE_filterOp);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 373;
        this.match(TransformsParser.K_FILTER);
        this.state = 374;
        this.expr(0);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function JoinOpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_joinOp;
    return this;
}

JoinOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
JoinOpContext.prototype.constructor = JoinOpContext;

JoinOpContext.prototype.K_JOIN = function() {
    return this.getToken(TransformsParser.K_JOIN, 0);
};

JoinOpContext.prototype.join_type = function() {
    return this.getTypedRuleContext(Join_typeContext,0);
};

JoinOpContext.prototype.dataset = function() {
    return this.getTypedRuleContext(DatasetContext,0);
};

JoinOpContext.prototype.K_ON = function() {
    return this.getToken(TransformsParser.K_ON, 0);
};

JoinOpContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};

JoinOpContext.prototype.K_WITH = function() {
    return this.getToken(TransformsParser.K_WITH, 0);
};

JoinOpContext.prototype.K_AS = function() {
    return this.getToken(TransformsParser.K_AS, 0);
};

JoinOpContext.prototype.dataset_name = function() {
    return this.getTypedRuleContext(Dataset_nameContext,0);
};

JoinOpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterJoinOp(this);
	}
};

JoinOpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitJoinOp(this);
	}
};

JoinOpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitJoinOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.JoinOpContext = JoinOpContext;

TransformsParser.prototype.joinOp = function() {

    var localctx = new JoinOpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 36, TransformsParser.RULE_joinOp);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 377;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(((((_la - 35)) & ~0x1f) == 0 && ((1 << (_la - 35)) & ((1 << (TransformsParser.K_CROSS - 35)) | (1 << (TransformsParser.K_FULL - 35)) | (1 << (TransformsParser.K_INNER - 35)) | (1 << (TransformsParser.K_LEFT - 35)))) !== 0) || _la===TransformsParser.K_OUTER || _la===TransformsParser.K_RIGHT) {
            this.state = 376;
            this.join_type();
        }

        this.state = 379;
        this.match(TransformsParser.K_JOIN);
        this.state = 391;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)))) !== 0) || ((((_la - 65)) & ~0x1f) == 0 && ((1 << (_la - 65)) & ((1 << (TransformsParser.K_NULLS - 65)) | (1 << (TransformsParser.K_PRECEDING - 65)) | (1 << (TransformsParser.K_PRIMARY - 65)) | (1 << (TransformsParser.K_RANGE - 65)) | (1 << (TransformsParser.K_ROW - 65)) | (1 << (TransformsParser.K_ROWS - 65)) | (1 << (TransformsParser.K_UNBOUNDED - 65)) | (1 << (TransformsParser.K_UNPIVOT - 65)) | (1 << (TransformsParser.K_WINDOW - 65)) | (1 << (TransformsParser.K_WITH - 65)) | (1 << (TransformsParser.K_SAMPLE - 65)) | (1 << (TransformsParser.K_SEED - 65)) | (1 << (TransformsParser.IDENTIFIER - 65)))) !== 0)) {
            this.state = 381;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if(_la===TransformsParser.K_WITH) {
                this.state = 380;
                this.match(TransformsParser.K_WITH);
            }

            this.state = 383;
            this.dataset();
            this.state = 386;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if(_la===TransformsParser.K_AS) {
                this.state = 384;
                this.match(TransformsParser.K_AS);
                this.state = 385;
                this.dataset_name();
            }

            this.state = 388;
            this.match(TransformsParser.K_ON);
            this.state = 389;
            this.expr(0);
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function SortOpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_sortOp;
    return this;
}

SortOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SortOpContext.prototype.constructor = SortOpContext;

SortOpContext.prototype.K_ORDER = function() {
    return this.getToken(TransformsParser.K_ORDER, 0);
};

SortOpContext.prototype.K_BY = function() {
    return this.getToken(TransformsParser.K_BY, 0);
};

SortOpContext.prototype.sort_clause = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Sort_clauseContext);
    } else {
        return this.getTypedRuleContext(Sort_clauseContext,i);
    }
};

SortOpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterSortOp(this);
	}
};

SortOpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitSortOp(this);
	}
};

SortOpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitSortOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.SortOpContext = SortOpContext;

TransformsParser.prototype.sortOp = function() {

    var localctx = new SortOpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 38, TransformsParser.RULE_sortOp);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 393;
        this.match(TransformsParser.K_ORDER);
        this.state = 394;
        this.match(TransformsParser.K_BY);
        this.state = 403;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,33,this._ctx);
        if(la_===1) {
            this.state = 395;
            this.sort_clause();
            this.state = 400;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===TransformsParser.T__1) {
                this.state = 396;
                this.match(TransformsParser.T__1);
                this.state = 397;
                this.sort_clause();
                this.state = 402;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function UnionOpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_unionOp;
    return this;
}

UnionOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
UnionOpContext.prototype.constructor = UnionOpContext;

UnionOpContext.prototype.K_UNION = function() {
    return this.getToken(TransformsParser.K_UNION, 0);
};

UnionOpContext.prototype.K_ALL = function() {
    return this.getToken(TransformsParser.K_ALL, 0);
};

UnionOpContext.prototype.K_WITH = function() {
    return this.getToken(TransformsParser.K_WITH, 0);
};

UnionOpContext.prototype.dataset_list = function() {
    return this.getTypedRuleContext(Dataset_listContext,0);
};

UnionOpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterUnionOp(this);
	}
};

UnionOpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitUnionOp(this);
	}
};

UnionOpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitUnionOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.UnionOpContext = UnionOpContext;

TransformsParser.prototype.unionOp = function() {

    var localctx = new UnionOpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 40, TransformsParser.RULE_unionOp);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 405;
        this.match(TransformsParser.K_UNION);
        this.state = 406;
        this.match(TransformsParser.K_ALL);
        this.state = 408;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(_la===TransformsParser.K_WITH) {
            this.state = 407;
            this.match(TransformsParser.K_WITH);
        }

        this.state = 411;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)))) !== 0) || ((((_la - 65)) & ~0x1f) == 0 && ((1 << (_la - 65)) & ((1 << (TransformsParser.K_NULLS - 65)) | (1 << (TransformsParser.K_PRECEDING - 65)) | (1 << (TransformsParser.K_PRIMARY - 65)) | (1 << (TransformsParser.K_RANGE - 65)) | (1 << (TransformsParser.K_ROW - 65)) | (1 << (TransformsParser.K_ROWS - 65)) | (1 << (TransformsParser.K_UNBOUNDED - 65)) | (1 << (TransformsParser.K_UNPIVOT - 65)) | (1 << (TransformsParser.K_WINDOW - 65)) | (1 << (TransformsParser.K_SAMPLE - 65)) | (1 << (TransformsParser.K_SEED - 65)) | (1 << (TransformsParser.IDENTIFIER - 65)))) !== 0)) {
            this.state = 410;
            this.dataset_list();
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function DropOpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_dropOp;
    return this;
}

DropOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
DropOpContext.prototype.constructor = DropOpContext;

DropOpContext.prototype.K_DROP = function() {
    return this.getToken(TransformsParser.K_DROP, 0);
};

DropOpContext.prototype.identifier_list = function() {
    return this.getTypedRuleContext(Identifier_listContext,0);
};

DropOpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterDropOp(this);
	}
};

DropOpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitDropOp(this);
	}
};

DropOpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitDropOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.DropOpContext = DropOpContext;

TransformsParser.prototype.dropOp = function() {

    var localctx = new DropOpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 42, TransformsParser.RULE_dropOp);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 413;
        this.match(TransformsParser.K_DROP);
        this.state = 415;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)))) !== 0) || ((((_la - 65)) & ~0x1f) == 0 && ((1 << (_la - 65)) & ((1 << (TransformsParser.K_NULLS - 65)) | (1 << (TransformsParser.K_PRECEDING - 65)) | (1 << (TransformsParser.K_PRIMARY - 65)) | (1 << (TransformsParser.K_RANGE - 65)) | (1 << (TransformsParser.K_ROW - 65)) | (1 << (TransformsParser.K_ROWS - 65)) | (1 << (TransformsParser.K_UNBOUNDED - 65)) | (1 << (TransformsParser.K_UNPIVOT - 65)) | (1 << (TransformsParser.K_WINDOW - 65)) | (1 << (TransformsParser.K_SAMPLE - 65)) | (1 << (TransformsParser.K_SEED - 65)) | (1 << (TransformsParser.IDENTIFIER - 65)))) !== 0)) {
            this.state = 414;
            this.identifier_list();
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function RepartitionOpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_repartitionOp;
    return this;
}

RepartitionOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
RepartitionOpContext.prototype.constructor = RepartitionOpContext;

RepartitionOpContext.prototype.K_REPARTITION = function() {
    return this.getToken(TransformsParser.K_REPARTITION, 0);
};

RepartitionOpContext.prototype.literalInteger = function() {
    return this.getTypedRuleContext(LiteralIntegerContext,0);
};

RepartitionOpContext.prototype.K_BY = function() {
    return this.getToken(TransformsParser.K_BY, 0);
};

RepartitionOpContext.prototype.exprs = function() {
    return this.getTypedRuleContext(ExprsContext,0);
};

RepartitionOpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterRepartitionOp(this);
	}
};

RepartitionOpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitRepartitionOp(this);
	}
};

RepartitionOpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitRepartitionOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.RepartitionOpContext = RepartitionOpContext;

TransformsParser.prototype.repartitionOp = function() {

    var localctx = new RepartitionOpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 44, TransformsParser.RULE_repartitionOp);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 417;
        this.match(TransformsParser.K_REPARTITION);
        this.state = 419;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(_la===TransformsParser.INTEGER_LITERAL) {
            this.state = 418;
            this.literalInteger();
        }

        this.state = 423;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(_la===TransformsParser.K_BY) {
            this.state = 421;
            this.match(TransformsParser.K_BY);
            this.state = 422;
            this.exprs();
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function CheckpointOpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_checkpointOp;
    return this;
}

CheckpointOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
CheckpointOpContext.prototype.constructor = CheckpointOpContext;

CheckpointOpContext.prototype.K_CHECKPOINT = function() {
    return this.getToken(TransformsParser.K_CHECKPOINT, 0);
};

CheckpointOpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterCheckpointOp(this);
	}
};

CheckpointOpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitCheckpointOp(this);
	}
};

CheckpointOpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitCheckpointOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.CheckpointOpContext = CheckpointOpContext;

TransformsParser.prototype.checkpointOp = function() {

    var localctx = new CheckpointOpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 46, TransformsParser.RULE_checkpointOp);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 425;
        this.match(TransformsParser.K_CHECKPOINT);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function UseHintOpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_useHintOp;
    return this;
}

UseHintOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
UseHintOpContext.prototype.constructor = UseHintOpContext;

UseHintOpContext.prototype.K_USE = function() {
    return this.getToken(TransformsParser.K_USE, 0);
};

UseHintOpContext.prototype.K_HINT = function() {
    return this.getToken(TransformsParser.K_HINT, 0);
};

UseHintOpContext.prototype.hint_list = function() {
    return this.getTypedRuleContext(Hint_listContext,0);
};

UseHintOpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterUseHintOp(this);
	}
};

UseHintOpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitUseHintOp(this);
	}
};

UseHintOpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitUseHintOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.UseHintOpContext = UseHintOpContext;

TransformsParser.prototype.useHintOp = function() {

    var localctx = new UseHintOpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 48, TransformsParser.RULE_useHintOp);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 427;
        this.match(TransformsParser.K_USE);
        this.state = 428;
        this.match(TransformsParser.K_HINT);
        this.state = 429;
        this.match(TransformsParser.T__2);
        this.state = 431;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)))) !== 0) || ((((_la - 65)) & ~0x1f) == 0 && ((1 << (_la - 65)) & ((1 << (TransformsParser.K_NULLS - 65)) | (1 << (TransformsParser.K_PRECEDING - 65)) | (1 << (TransformsParser.K_PRIMARY - 65)) | (1 << (TransformsParser.K_RANGE - 65)) | (1 << (TransformsParser.K_ROW - 65)) | (1 << (TransformsParser.K_ROWS - 65)) | (1 << (TransformsParser.K_UNBOUNDED - 65)) | (1 << (TransformsParser.K_UNPIVOT - 65)) | (1 << (TransformsParser.K_WINDOW - 65)) | (1 << (TransformsParser.K_SAMPLE - 65)) | (1 << (TransformsParser.K_SEED - 65)) | (1 << (TransformsParser.IDENTIFIER - 65)))) !== 0)) {
            this.state = 430;
            this.hint_list();
        }

        this.state = 433;
        this.match(TransformsParser.T__3);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function HintOpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_hintOp;
    return this;
}

HintOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
HintOpContext.prototype.constructor = HintOpContext;

HintOpContext.prototype.K_HINT = function() {
    return this.getToken(TransformsParser.K_HINT, 0);
};

HintOpContext.prototype.op = function() {
    return this.getTypedRuleContext(OpContext,0);
};

HintOpContext.prototype.hint_list = function() {
    return this.getTypedRuleContext(Hint_listContext,0);
};

HintOpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterHintOp(this);
	}
};

HintOpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitHintOp(this);
	}
};

HintOpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitHintOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.HintOpContext = HintOpContext;

TransformsParser.prototype.hintOp = function() {

    var localctx = new HintOpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 50, TransformsParser.RULE_hintOp);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 435;
        this.match(TransformsParser.K_HINT);
        this.state = 436;
        this.match(TransformsParser.T__2);
        this.state = 438;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)))) !== 0) || ((((_la - 65)) & ~0x1f) == 0 && ((1 << (_la - 65)) & ((1 << (TransformsParser.K_NULLS - 65)) | (1 << (TransformsParser.K_PRECEDING - 65)) | (1 << (TransformsParser.K_PRIMARY - 65)) | (1 << (TransformsParser.K_RANGE - 65)) | (1 << (TransformsParser.K_ROW - 65)) | (1 << (TransformsParser.K_ROWS - 65)) | (1 << (TransformsParser.K_UNBOUNDED - 65)) | (1 << (TransformsParser.K_UNPIVOT - 65)) | (1 << (TransformsParser.K_WINDOW - 65)) | (1 << (TransformsParser.K_SAMPLE - 65)) | (1 << (TransformsParser.K_SEED - 65)) | (1 << (TransformsParser.IDENTIFIER - 65)))) !== 0)) {
            this.state = 437;
            this.hint_list();
        }

        this.state = 440;
        this.match(TransformsParser.T__3);
        this.state = 441;
        this.op();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function SampleOpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_sampleOp;
    return this;
}

SampleOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SampleOpContext.prototype.constructor = SampleOpContext;

SampleOpContext.prototype.K_SAMPLE = function() {
    return this.getToken(TransformsParser.K_SAMPLE, 0);
};

SampleOpContext.prototype.literalInteger = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(LiteralIntegerContext);
    } else {
        return this.getTypedRuleContext(LiteralIntegerContext,i);
    }
};

SampleOpContext.prototype.K_SEED = function() {
    return this.getToken(TransformsParser.K_SEED, 0);
};

SampleOpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterSampleOp(this);
	}
};

SampleOpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitSampleOp(this);
	}
};

SampleOpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitSampleOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.SampleOpContext = SampleOpContext;

TransformsParser.prototype.sampleOp = function() {

    var localctx = new SampleOpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 52, TransformsParser.RULE_sampleOp);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 443;
        this.match(TransformsParser.K_SAMPLE);
        this.state = 445;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(_la===TransformsParser.INTEGER_LITERAL) {
            this.state = 444;
            this.literalInteger();
        }

        this.state = 449;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(_la===TransformsParser.K_SEED) {
            this.state = 447;
            this.match(TransformsParser.K_SEED);
            this.state = 448;
            this.literalInteger();
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function UseOpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_useOp;
    return this;
}

UseOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
UseOpContext.prototype.constructor = UseOpContext;

UseOpContext.prototype.K_USE = function() {
    return this.getToken(TransformsParser.K_USE, 0);
};

UseOpContext.prototype.dataset = function() {
    return this.getTypedRuleContext(DatasetContext,0);
};

UseOpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterUseOp(this);
	}
};

UseOpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitUseOp(this);
	}
};

UseOpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitUseOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.UseOpContext = UseOpContext;

TransformsParser.prototype.useOp = function() {

    var localctx = new UseOpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 54, TransformsParser.RULE_useOp);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 451;
        this.match(TransformsParser.K_USE);
        this.state = 453;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)))) !== 0) || ((((_la - 65)) & ~0x1f) == 0 && ((1 << (_la - 65)) & ((1 << (TransformsParser.K_NULLS - 65)) | (1 << (TransformsParser.K_PRECEDING - 65)) | (1 << (TransformsParser.K_PRIMARY - 65)) | (1 << (TransformsParser.K_RANGE - 65)) | (1 << (TransformsParser.K_ROW - 65)) | (1 << (TransformsParser.K_ROWS - 65)) | (1 << (TransformsParser.K_UNBOUNDED - 65)) | (1 << (TransformsParser.K_UNPIVOT - 65)) | (1 << (TransformsParser.K_WINDOW - 65)) | (1 << (TransformsParser.K_SAMPLE - 65)) | (1 << (TransformsParser.K_SEED - 65)) | (1 << (TransformsParser.IDENTIFIER - 65)))) !== 0)) {
            this.state = 452;
            this.dataset();
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function LabelOpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_labelOp;
    return this;
}

LabelOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
LabelOpContext.prototype.constructor = LabelOpContext;

LabelOpContext.prototype.dataset_name = function() {
    return this.getTypedRuleContext(Dataset_nameContext,0);
};

LabelOpContext.prototype.op = function() {
    return this.getTypedRuleContext(OpContext,0);
};

LabelOpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterLabelOp(this);
	}
};

LabelOpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitLabelOp(this);
	}
};

LabelOpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitLabelOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.LabelOpContext = LabelOpContext;

TransformsParser.prototype.labelOp = function() {

    var localctx = new LabelOpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 56, TransformsParser.RULE_labelOp);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 456;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)))) !== 0) || ((((_la - 65)) & ~0x1f) == 0 && ((1 << (_la - 65)) & ((1 << (TransformsParser.K_NULLS - 65)) | (1 << (TransformsParser.K_PRECEDING - 65)) | (1 << (TransformsParser.K_PRIMARY - 65)) | (1 << (TransformsParser.K_RANGE - 65)) | (1 << (TransformsParser.K_ROW - 65)) | (1 << (TransformsParser.K_ROWS - 65)) | (1 << (TransformsParser.K_UNBOUNDED - 65)) | (1 << (TransformsParser.K_UNPIVOT - 65)) | (1 << (TransformsParser.K_WINDOW - 65)) | (1 << (TransformsParser.K_SAMPLE - 65)) | (1 << (TransformsParser.K_SEED - 65)) | (1 << (TransformsParser.IDENTIFIER - 65)))) !== 0)) {
            this.state = 455;
            this.dataset_name();
        }

        this.state = 458;
        this.match(TransformsParser.T__5);
        this.state = 460;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.T__5) | (1 << TransformsParser.T__6) | (1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CROSS - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_EXPLODE - 32)) | (1 << (TransformsParser.K_FILTER - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_FULL - 32)) | (1 << (TransformsParser.K_GROUP - 32)) | (1 << (TransformsParser.K_HINT - 32)) | (1 << (TransformsParser.K_INNER - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)) | (1 << (TransformsParser.K_LEFT - 32)) | (1 << (TransformsParser.K_MERGE - 32)))) !== 0) || ((((_la - 65)) & ~0x1f) == 0 && ((1 << (_la - 65)) & ((1 << (TransformsParser.K_NULLS - 65)) | (1 << (TransformsParser.K_ORDER - 65)) | (1 << (TransformsParser.K_OUTER - 65)) | (1 << (TransformsParser.K_PIVOT - 65)) | (1 << (TransformsParser.K_PRECEDING - 65)) | (1 << (TransformsParser.K_PRIMARY - 65)) | (1 << (TransformsParser.K_RANGE - 65)) | (1 << (TransformsParser.K_REPARTITION - 65)) | (1 << (TransformsParser.K_RIGHT - 65)) | (1 << (TransformsParser.K_ROW - 65)) | (1 << (TransformsParser.K_ROWS - 65)) | (1 << (TransformsParser.K_SELECT - 65)) | (1 << (TransformsParser.K_UNBOUNDED - 65)) | (1 << (TransformsParser.K_UNION - 65)) | (1 << (TransformsParser.K_UNPIVOT - 65)) | (1 << (TransformsParser.K_USE - 65)) | (1 << (TransformsParser.K_WINDOW - 65)) | (1 << (TransformsParser.K_SAMPLE - 65)) | (1 << (TransformsParser.K_SEED - 65)) | (1 << (TransformsParser.IDENTIFIER - 65)))) !== 0)) {
            this.state = 459;
            this.op();
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function BlockOpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_blockOp;
    return this;
}

BlockOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
BlockOpContext.prototype.constructor = BlockOpContext;

BlockOpContext.prototype.script = function() {
    return this.getTypedRuleContext(ScriptContext,0);
};

BlockOpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterBlockOp(this);
	}
};

BlockOpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitBlockOp(this);
	}
};

BlockOpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitBlockOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.BlockOpContext = BlockOpContext;

TransformsParser.prototype.blockOp = function() {

    var localctx = new BlockOpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 58, TransformsParser.RULE_blockOp);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 462;
        this.match(TransformsParser.T__6);
        this.state = 463;
        this.script();
        this.state = 464;
        this.match(TransformsParser.T__7);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function EnforcePKOpContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_enforcePKOp;
    return this;
}

EnforcePKOpContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
EnforcePKOpContext.prototype.constructor = EnforcePKOpContext;

EnforcePKOpContext.prototype.K_ENFORCE = function() {
    return this.getToken(TransformsParser.K_ENFORCE, 0);
};

EnforcePKOpContext.prototype.K_PRIMARY = function() {
    return this.getToken(TransformsParser.K_PRIMARY, 0);
};

EnforcePKOpContext.prototype.K_KEY = function() {
    return this.getToken(TransformsParser.K_KEY, 0);
};

EnforcePKOpContext.prototype.named_exprs = function() {
    return this.getTypedRuleContext(Named_exprsContext,0);
};

EnforcePKOpContext.prototype.K_DISAMBIGUATE = function() {
    return this.getToken(TransformsParser.K_DISAMBIGUATE, 0);
};

EnforcePKOpContext.prototype.K_AS = function() {
    return this.getToken(TransformsParser.K_AS, 0);
};

EnforcePKOpContext.prototype.id = function() {
    return this.getTypedRuleContext(IdContext,0);
};

EnforcePKOpContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterEnforcePKOp(this);
	}
};

EnforcePKOpContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitEnforcePKOp(this);
	}
};

EnforcePKOpContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitEnforcePKOp(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.EnforcePKOpContext = EnforcePKOpContext;

TransformsParser.prototype.enforcePKOp = function() {

    var localctx = new EnforcePKOpContext(this, this._ctx, this.state);
    this.enterRule(localctx, 60, TransformsParser.RULE_enforcePKOp);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 466;
        this.match(TransformsParser.K_ENFORCE);
        this.state = 467;
        this.match(TransformsParser.K_PRIMARY);
        this.state = 468;
        this.match(TransformsParser.K_KEY);
        this.state = 470;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,46,this._ctx);
        if(la_===1) {
            this.state = 469;
            this.named_exprs();

        }
        this.state = 477;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(_la===TransformsParser.K_DISAMBIGUATE) {
            this.state = 472;
            this.match(TransformsParser.K_DISAMBIGUATE);
            this.state = 473;
            this.match(TransformsParser.K_AS);
            this.state = 475;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)))) !== 0) || ((((_la - 65)) & ~0x1f) == 0 && ((1 << (_la - 65)) & ((1 << (TransformsParser.K_NULLS - 65)) | (1 << (TransformsParser.K_PRECEDING - 65)) | (1 << (TransformsParser.K_PRIMARY - 65)) | (1 << (TransformsParser.K_RANGE - 65)) | (1 << (TransformsParser.K_ROW - 65)) | (1 << (TransformsParser.K_ROWS - 65)) | (1 << (TransformsParser.K_UNBOUNDED - 65)) | (1 << (TransformsParser.K_UNPIVOT - 65)) | (1 << (TransformsParser.K_WINDOW - 65)) | (1 << (TransformsParser.K_SAMPLE - 65)) | (1 << (TransformsParser.K_SEED - 65)) | (1 << (TransformsParser.IDENTIFIER - 65)))) !== 0)) {
                this.state = 474;
                this.id();
            }

        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Selector_preContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_selector_pre;
    return this;
}

Selector_preContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Selector_preContext.prototype.constructor = Selector_preContext;

Selector_preContext.prototype.named_exprs = function() {
    return this.getTypedRuleContext(Named_exprsContext,0);
};

Selector_preContext.prototype.selector_post = function() {
    return this.getTypedRuleContext(Selector_postContext,0);
};

Selector_preContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterSelector_pre(this);
	}
};

Selector_preContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitSelector_pre(this);
	}
};

Selector_preContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitSelector_pre(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Selector_preContext = Selector_preContext;

TransformsParser.prototype.selector_pre = function() {

    var localctx = new Selector_preContext(this, this._ctx, this.state);
    this.enterRule(localctx, 62, TransformsParser.RULE_selector_pre);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 479;
        this.named_exprs();
        this.state = 482;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(_la===TransformsParser.T__1) {
            this.state = 480;
            this.match(TransformsParser.T__1);
            this.state = 481;
            this.selector_post();
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Selector_postContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_selector_post;
    return this;
}

Selector_postContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Selector_postContext.prototype.constructor = Selector_postContext;

Selector_postContext.prototype.rename_expr = function() {
    return this.getTypedRuleContext(Rename_exprContext,0);
};

Selector_postContext.prototype.named_exprs = function() {
    return this.getTypedRuleContext(Named_exprsContext,0);
};

Selector_postContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterSelector_post(this);
	}
};

Selector_postContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitSelector_post(this);
	}
};

Selector_postContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitSelector_post(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Selector_postContext = Selector_postContext;

TransformsParser.prototype.selector_post = function() {

    var localctx = new Selector_postContext(this, this._ctx, this.state);
    this.enterRule(localctx, 64, TransformsParser.RULE_selector_post);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 484;
        this.rename_expr();
        this.state = 487;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(_la===TransformsParser.T__1) {
            this.state = 485;
            this.match(TransformsParser.T__1);
            this.state = 486;
            this.named_exprs();
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Pivot_when_clauseContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_pivot_when_clause;
    return this;
}

Pivot_when_clauseContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Pivot_when_clauseContext.prototype.constructor = Pivot_when_clauseContext;

Pivot_when_clauseContext.prototype.K_WHEN = function() {
    return this.getToken(TransformsParser.K_WHEN, 0);
};

Pivot_when_clauseContext.prototype.K_SELECT = function() {
    return this.getToken(TransformsParser.K_SELECT, 0);
};

Pivot_when_clauseContext.prototype.exprs = function() {
    return this.getTypedRuleContext(ExprsContext,0);
};

Pivot_when_clauseContext.prototype.named_exprs = function() {
    return this.getTypedRuleContext(Named_exprsContext,0);
};

Pivot_when_clauseContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterPivot_when_clause(this);
	}
};

Pivot_when_clauseContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitPivot_when_clause(this);
	}
};

Pivot_when_clauseContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitPivot_when_clause(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Pivot_when_clauseContext = Pivot_when_clauseContext;

TransformsParser.prototype.pivot_when_clause = function() {

    var localctx = new Pivot_when_clauseContext(this, this._ctx, this.state);
    this.enterRule(localctx, 66, TransformsParser.RULE_pivot_when_clause);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 489;
        this.match(TransformsParser.K_WHEN);
        this.state = 491;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.T__2) | (1 << TransformsParser.T__6) | (1 << TransformsParser.T__9) | (1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN) | (1 << TransformsParser.K_CASE))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CONVERT_ARRAY - 32)) | (1 << (TransformsParser.K_CONVERT_STRUCT - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_FALSE - 32)) | (1 << (TransformsParser.K_FILTER - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)) | (1 << (TransformsParser.K_MAP - 32)) | (1 << (TransformsParser.K_NOT - 32)))) !== 0) || ((((_la - 64)) & ~0x1f) == 0 && ((1 << (_la - 64)) & ((1 << (TransformsParser.K_NULL - 64)) | (1 << (TransformsParser.K_NULLS - 64)) | (1 << (TransformsParser.K_PRECEDING - 64)) | (1 << (TransformsParser.K_PRIMARY - 64)) | (1 << (TransformsParser.K_RANGE - 64)) | (1 << (TransformsParser.K_REDUCE - 64)) | (1 << (TransformsParser.K_ROW - 64)) | (1 << (TransformsParser.K_ROWS - 64)) | (1 << (TransformsParser.K_TRUE - 64)) | (1 << (TransformsParser.K_UNBOUNDED - 64)) | (1 << (TransformsParser.K_UNPIVOT - 64)) | (1 << (TransformsParser.K_WINDOW - 64)) | (1 << (TransformsParser.K_SAMPLE - 64)) | (1 << (TransformsParser.K_SEED - 64)) | (1 << (TransformsParser.STRING_LITERAL - 64)) | (1 << (TransformsParser.LONG_LITERAL - 64)) | (1 << (TransformsParser.INTEGER_LITERAL - 64)) | (1 << (TransformsParser.NUMERIC_LITERAL - 64)) | (1 << (TransformsParser.IDENTIFIER - 64)))) !== 0)) {
            this.state = 490;
            this.exprs();
        }

        this.state = 493;
        this.match(TransformsParser.K_SELECT);
        this.state = 495;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.T__2) | (1 << TransformsParser.T__6) | (1 << TransformsParser.T__9) | (1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN) | (1 << TransformsParser.K_CASE))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CONVERT_ARRAY - 32)) | (1 << (TransformsParser.K_CONVERT_STRUCT - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_FALSE - 32)) | (1 << (TransformsParser.K_FILTER - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)) | (1 << (TransformsParser.K_MAP - 32)) | (1 << (TransformsParser.K_NOT - 32)))) !== 0) || ((((_la - 64)) & ~0x1f) == 0 && ((1 << (_la - 64)) & ((1 << (TransformsParser.K_NULL - 64)) | (1 << (TransformsParser.K_NULLS - 64)) | (1 << (TransformsParser.K_PRECEDING - 64)) | (1 << (TransformsParser.K_PRIMARY - 64)) | (1 << (TransformsParser.K_RANGE - 64)) | (1 << (TransformsParser.K_REDUCE - 64)) | (1 << (TransformsParser.K_ROW - 64)) | (1 << (TransformsParser.K_ROWS - 64)) | (1 << (TransformsParser.K_TRUE - 64)) | (1 << (TransformsParser.K_UNBOUNDED - 64)) | (1 << (TransformsParser.K_UNPIVOT - 64)) | (1 << (TransformsParser.K_WINDOW - 64)) | (1 << (TransformsParser.K_SAMPLE - 64)) | (1 << (TransformsParser.K_SEED - 64)) | (1 << (TransformsParser.STRING_LITERAL - 64)) | (1 << (TransformsParser.LONG_LITERAL - 64)) | (1 << (TransformsParser.INTEGER_LITERAL - 64)) | (1 << (TransformsParser.NUMERIC_LITERAL - 64)) | (1 << (TransformsParser.IDENTIFIER - 64)))) !== 0)) {
            this.state = 494;
            this.named_exprs();
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Pivot_else_clauseContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_pivot_else_clause;
    return this;
}

Pivot_else_clauseContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Pivot_else_clauseContext.prototype.constructor = Pivot_else_clauseContext;

Pivot_else_clauseContext.prototype.K_ELSE = function() {
    return this.getToken(TransformsParser.K_ELSE, 0);
};

Pivot_else_clauseContext.prototype.K_SELECT = function() {
    return this.getToken(TransformsParser.K_SELECT, 0);
};

Pivot_else_clauseContext.prototype.named_exprs = function() {
    return this.getTypedRuleContext(Named_exprsContext,0);
};

Pivot_else_clauseContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterPivot_else_clause(this);
	}
};

Pivot_else_clauseContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitPivot_else_clause(this);
	}
};

Pivot_else_clauseContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitPivot_else_clause(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Pivot_else_clauseContext = Pivot_else_clauseContext;

TransformsParser.prototype.pivot_else_clause = function() {

    var localctx = new Pivot_else_clauseContext(this, this._ctx, this.state);
    this.enterRule(localctx, 68, TransformsParser.RULE_pivot_else_clause);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 497;
        this.match(TransformsParser.K_ELSE);
        this.state = 498;
        this.match(TransformsParser.K_SELECT);
        this.state = 499;
        this.named_exprs();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Row_clauseContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_row_clause;
    return this;
}

Row_clauseContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Row_clauseContext.prototype.constructor = Row_clauseContext;

Row_clauseContext.prototype.named_exprs = function() {
    return this.getTypedRuleContext(Named_exprsContext,0);
};

Row_clauseContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterRow_clause(this);
	}
};

Row_clauseContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitRow_clause(this);
	}
};

Row_clauseContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitRow_clause(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Row_clauseContext = Row_clauseContext;

TransformsParser.prototype.row_clause = function() {

    var localctx = new Row_clauseContext(this, this._ctx, this.state);
    this.enterRule(localctx, 70, TransformsParser.RULE_row_clause);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 501;
        this.match(TransformsParser.T__2);
        this.state = 503;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.T__2) | (1 << TransformsParser.T__6) | (1 << TransformsParser.T__9) | (1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN) | (1 << TransformsParser.K_CASE))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CONVERT_ARRAY - 32)) | (1 << (TransformsParser.K_CONVERT_STRUCT - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_FALSE - 32)) | (1 << (TransformsParser.K_FILTER - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)) | (1 << (TransformsParser.K_MAP - 32)) | (1 << (TransformsParser.K_NOT - 32)))) !== 0) || ((((_la - 64)) & ~0x1f) == 0 && ((1 << (_la - 64)) & ((1 << (TransformsParser.K_NULL - 64)) | (1 << (TransformsParser.K_NULLS - 64)) | (1 << (TransformsParser.K_PRECEDING - 64)) | (1 << (TransformsParser.K_PRIMARY - 64)) | (1 << (TransformsParser.K_RANGE - 64)) | (1 << (TransformsParser.K_REDUCE - 64)) | (1 << (TransformsParser.K_ROW - 64)) | (1 << (TransformsParser.K_ROWS - 64)) | (1 << (TransformsParser.K_TRUE - 64)) | (1 << (TransformsParser.K_UNBOUNDED - 64)) | (1 << (TransformsParser.K_UNPIVOT - 64)) | (1 << (TransformsParser.K_WINDOW - 64)) | (1 << (TransformsParser.K_SAMPLE - 64)) | (1 << (TransformsParser.K_SEED - 64)) | (1 << (TransformsParser.STRING_LITERAL - 64)) | (1 << (TransformsParser.LONG_LITERAL - 64)) | (1 << (TransformsParser.INTEGER_LITERAL - 64)) | (1 << (TransformsParser.NUMERIC_LITERAL - 64)) | (1 << (TransformsParser.IDENTIFIER - 64)))) !== 0)) {
            this.state = 502;
            this.named_exprs();
        }

        this.state = 505;
        this.match(TransformsParser.T__3);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Named_exprsContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_named_exprs;
    return this;
}

Named_exprsContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Named_exprsContext.prototype.constructor = Named_exprsContext;

Named_exprsContext.prototype.named_expr = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Named_exprContext);
    } else {
        return this.getTypedRuleContext(Named_exprContext,i);
    }
};

Named_exprsContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterNamed_exprs(this);
	}
};

Named_exprsContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitNamed_exprs(this);
	}
};

Named_exprsContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitNamed_exprs(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Named_exprsContext = Named_exprsContext;

TransformsParser.prototype.named_exprs = function() {

    var localctx = new Named_exprsContext(this, this._ctx, this.state);
    this.enterRule(localctx, 72, TransformsParser.RULE_named_exprs);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 507;
        this.named_expr();
        this.state = 512;
        this._errHandler.sync(this);
        var _alt = this._interp.adaptivePredict(this._input,54,this._ctx)
        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
            if(_alt===1) {
                this.state = 508;
                this.match(TransformsParser.T__1);
                this.state = 509;
                this.named_expr(); 
            }
            this.state = 514;
            this._errHandler.sync(this);
            _alt = this._interp.adaptivePredict(this._input,54,this._ctx);
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ExprsContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_exprs;
    return this;
}

ExprsContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ExprsContext.prototype.constructor = ExprsContext;

ExprsContext.prototype.expr = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExprContext);
    } else {
        return this.getTypedRuleContext(ExprContext,i);
    }
};

ExprsContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterExprs(this);
	}
};

ExprsContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitExprs(this);
	}
};

ExprsContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitExprs(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.ExprsContext = ExprsContext;

TransformsParser.prototype.exprs = function() {

    var localctx = new ExprsContext(this, this._ctx, this.state);
    this.enterRule(localctx, 74, TransformsParser.RULE_exprs);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 515;
        this.expr(0);
        this.state = 520;
        this._errHandler.sync(this);
        var _alt = this._interp.adaptivePredict(this._input,55,this._ctx)
        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
            if(_alt===1) {
                this.state = 516;
                this.match(TransformsParser.T__1);
                this.state = 517;
                this.expr(0); 
            }
            this.state = 522;
            this._errHandler.sync(this);
            _alt = this._interp.adaptivePredict(this._input,55,this._ctx);
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Join_typeContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_join_type;
    return this;
}

Join_typeContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Join_typeContext.prototype.constructor = Join_typeContext;

Join_typeContext.prototype.K_INNER = function() {
    return this.getToken(TransformsParser.K_INNER, 0);
};

Join_typeContext.prototype.K_CROSS = function() {
    return this.getToken(TransformsParser.K_CROSS, 0);
};

Join_typeContext.prototype.K_OUTER = function() {
    return this.getToken(TransformsParser.K_OUTER, 0);
};

Join_typeContext.prototype.K_FULL = function() {
    return this.getToken(TransformsParser.K_FULL, 0);
};

Join_typeContext.prototype.K_LEFT = function() {
    return this.getToken(TransformsParser.K_LEFT, 0);
};

Join_typeContext.prototype.K_RIGHT = function() {
    return this.getToken(TransformsParser.K_RIGHT, 0);
};

Join_typeContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterJoin_type(this);
	}
};

Join_typeContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitJoin_type(this);
	}
};

Join_typeContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitJoin_type(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Join_typeContext = Join_typeContext;

TransformsParser.prototype.join_type = function() {

    var localctx = new Join_typeContext(this, this._ctx, this.state);
    this.enterRule(localctx, 76, TransformsParser.RULE_join_type);
    var _la = 0; // Token type
    try {
        this.state = 538;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case TransformsParser.K_INNER:
            this.enterOuterAlt(localctx, 1);
            this.state = 523;
            this.match(TransformsParser.K_INNER);
            break;
        case TransformsParser.K_CROSS:
            this.enterOuterAlt(localctx, 2);
            this.state = 524;
            this.match(TransformsParser.K_CROSS);
            break;
        case TransformsParser.K_OUTER:
            this.enterOuterAlt(localctx, 3);
            this.state = 525;
            this.match(TransformsParser.K_OUTER);
            break;
        case TransformsParser.K_FULL:
            this.enterOuterAlt(localctx, 4);
            this.state = 526;
            this.match(TransformsParser.K_FULL);
            this.state = 528;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if(_la===TransformsParser.K_OUTER) {
                this.state = 527;
                this.match(TransformsParser.K_OUTER);
            }

            break;
        case TransformsParser.K_LEFT:
            this.enterOuterAlt(localctx, 5);
            this.state = 530;
            this.match(TransformsParser.K_LEFT);
            this.state = 532;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if(_la===TransformsParser.K_OUTER) {
                this.state = 531;
                this.match(TransformsParser.K_OUTER);
            }

            break;
        case TransformsParser.K_RIGHT:
            this.enterOuterAlt(localctx, 6);
            this.state = 534;
            this.match(TransformsParser.K_RIGHT);
            this.state = 536;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if(_la===TransformsParser.K_OUTER) {
                this.state = 535;
                this.match(TransformsParser.K_OUTER);
            }

            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Named_exprContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_named_expr;
    return this;
}

Named_exprContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Named_exprContext.prototype.constructor = Named_exprContext;

Named_exprContext.prototype.id = function() {
    return this.getTypedRuleContext(IdContext,0);
};

Named_exprContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};

Named_exprContext.prototype.K_AS = function() {
    return this.getToken(TransformsParser.K_AS, 0);
};

Named_exprContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterNamed_expr(this);
	}
};

Named_exprContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitNamed_expr(this);
	}
};

Named_exprContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitNamed_expr(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Named_exprContext = Named_exprContext;

TransformsParser.prototype.named_expr = function() {

    var localctx = new Named_exprContext(this, this._ctx, this.state);
    this.enterRule(localctx, 78, TransformsParser.RULE_named_expr);
    try {
        this.state = 545;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,60,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 540;
            this.id();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 541;
            this.expr(0);
            this.state = 542;
            this.match(TransformsParser.K_AS);
            this.state = 543;
            this.id();
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Rename_exprContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_rename_expr;
    return this;
}

Rename_exprContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Rename_exprContext.prototype.constructor = Rename_exprContext;

Rename_exprContext.prototype.rename_from = function() {
    return this.getTypedRuleContext(Rename_fromContext,0);
};

Rename_exprContext.prototype.K_AS = function() {
    return this.getToken(TransformsParser.K_AS, 0);
};

Rename_exprContext.prototype.rename_to = function() {
    return this.getTypedRuleContext(Rename_toContext,0);
};

Rename_exprContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterRename_expr(this);
	}
};

Rename_exprContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitRename_expr(this);
	}
};

Rename_exprContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitRename_expr(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Rename_exprContext = Rename_exprContext;

TransformsParser.prototype.rename_expr = function() {

    var localctx = new Rename_exprContext(this, this._ctx, this.state);
    this.enterRule(localctx, 80, TransformsParser.RULE_rename_expr);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 547;
        this.rename_from();
        this.state = 550;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(_la===TransformsParser.K_AS) {
            this.state = 548;
            this.match(TransformsParser.K_AS);
            this.state = 549;
            this.rename_to();
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Rename_fromContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_rename_from;
    return this;
}

Rename_fromContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Rename_fromContext.prototype.constructor = Rename_fromContext;

Rename_fromContext.prototype.id = function() {
    return this.getTypedRuleContext(IdContext,0);
};

Rename_fromContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterRename_from(this);
	}
};

Rename_fromContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitRename_from(this);
	}
};

Rename_fromContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitRename_from(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Rename_fromContext = Rename_fromContext;

TransformsParser.prototype.rename_from = function() {

    var localctx = new Rename_fromContext(this, this._ctx, this.state);
    this.enterRule(localctx, 82, TransformsParser.RULE_rename_from);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 553;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)))) !== 0) || ((((_la - 65)) & ~0x1f) == 0 && ((1 << (_la - 65)) & ((1 << (TransformsParser.K_NULLS - 65)) | (1 << (TransformsParser.K_PRECEDING - 65)) | (1 << (TransformsParser.K_PRIMARY - 65)) | (1 << (TransformsParser.K_RANGE - 65)) | (1 << (TransformsParser.K_ROW - 65)) | (1 << (TransformsParser.K_ROWS - 65)) | (1 << (TransformsParser.K_UNBOUNDED - 65)) | (1 << (TransformsParser.K_UNPIVOT - 65)) | (1 << (TransformsParser.K_WINDOW - 65)) | (1 << (TransformsParser.K_SAMPLE - 65)) | (1 << (TransformsParser.K_SEED - 65)) | (1 << (TransformsParser.IDENTIFIER - 65)))) !== 0)) {
            this.state = 552;
            this.id();
        }

        this.state = 555;
        this.match(TransformsParser.T__0);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Rename_toContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_rename_to;
    return this;
}

Rename_toContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Rename_toContext.prototype.constructor = Rename_toContext;

Rename_toContext.prototype.id = function() {
    return this.getTypedRuleContext(IdContext,0);
};

Rename_toContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterRename_to(this);
	}
};

Rename_toContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitRename_to(this);
	}
};

Rename_toContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitRename_to(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Rename_toContext = Rename_toContext;

TransformsParser.prototype.rename_to = function() {

    var localctx = new Rename_toContext(this, this._ctx, this.state);
    this.enterRule(localctx, 84, TransformsParser.RULE_rename_to);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 558;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)))) !== 0) || ((((_la - 65)) & ~0x1f) == 0 && ((1 << (_la - 65)) & ((1 << (TransformsParser.K_NULLS - 65)) | (1 << (TransformsParser.K_PRECEDING - 65)) | (1 << (TransformsParser.K_PRIMARY - 65)) | (1 << (TransformsParser.K_RANGE - 65)) | (1 << (TransformsParser.K_ROW - 65)) | (1 << (TransformsParser.K_ROWS - 65)) | (1 << (TransformsParser.K_UNBOUNDED - 65)) | (1 << (TransformsParser.K_UNPIVOT - 65)) | (1 << (TransformsParser.K_WINDOW - 65)) | (1 << (TransformsParser.K_SAMPLE - 65)) | (1 << (TransformsParser.K_SEED - 65)) | (1 << (TransformsParser.IDENTIFIER - 65)))) !== 0)) {
            this.state = 557;
            this.id();
        }

        this.state = 560;
        this.match(TransformsParser.T__0);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Sort_clauseContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_sort_clause;
    return this;
}

Sort_clauseContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Sort_clauseContext.prototype.constructor = Sort_clauseContext;

Sort_clauseContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};

Sort_clauseContext.prototype.K_NULLS = function() {
    return this.getToken(TransformsParser.K_NULLS, 0);
};

Sort_clauseContext.prototype.K_ASC = function() {
    return this.getToken(TransformsParser.K_ASC, 0);
};

Sort_clauseContext.prototype.K_DESC = function() {
    return this.getToken(TransformsParser.K_DESC, 0);
};

Sort_clauseContext.prototype.K_FIRST = function() {
    return this.getToken(TransformsParser.K_FIRST, 0);
};

Sort_clauseContext.prototype.K_LAST = function() {
    return this.getToken(TransformsParser.K_LAST, 0);
};

Sort_clauseContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterSort_clause(this);
	}
};

Sort_clauseContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitSort_clause(this);
	}
};

Sort_clauseContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitSort_clause(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Sort_clauseContext = Sort_clauseContext;

TransformsParser.prototype.sort_clause = function() {

    var localctx = new Sort_clauseContext(this, this._ctx, this.state);
    this.enterRule(localctx, 86, TransformsParser.RULE_sort_clause);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 562;
        this.expr(0);
        this.state = 564;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(_la===TransformsParser.K_ASC || _la===TransformsParser.K_DESC) {
            this.state = 563;
            _la = this._input.LA(1);
            if(!(_la===TransformsParser.K_ASC || _la===TransformsParser.K_DESC)) {
            this._errHandler.recoverInline(this);
            }
            else {
            	this._errHandler.reportMatch(this);
                this.consume();
            }
        }

        this.state = 568;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(_la===TransformsParser.K_NULLS) {
            this.state = 566;
            this.match(TransformsParser.K_NULLS);
            this.state = 567;
            _la = this._input.LA(1);
            if(!(_la===TransformsParser.K_FIRST || _la===TransformsParser.K_LAST)) {
            this._errHandler.recoverInline(this);
            }
            else {
            	this._errHandler.reportMatch(this);
                this.consume();
            }
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Window_frameContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_window_frame;
    return this;
}

Window_frameContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Window_frameContext.prototype.constructor = Window_frameContext;

Window_frameContext.prototype.K_RANGE = function() {
    return this.getToken(TransformsParser.K_RANGE, 0);
};

Window_frameContext.prototype.K_ROWS = function() {
    return this.getToken(TransformsParser.K_ROWS, 0);
};

Window_frameContext.prototype.window_frame_boundary = function() {
    return this.getTypedRuleContext(Window_frame_boundaryContext,0);
};

Window_frameContext.prototype.window_frame_interval = function() {
    return this.getTypedRuleContext(Window_frame_intervalContext,0);
};

Window_frameContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterWindow_frame(this);
	}
};

Window_frameContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitWindow_frame(this);
	}
};

Window_frameContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitWindow_frame(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Window_frameContext = Window_frameContext;

TransformsParser.prototype.window_frame = function() {

    var localctx = new Window_frameContext(this, this._ctx, this.state);
    this.enterRule(localctx, 88, TransformsParser.RULE_window_frame);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 570;
        _la = this._input.LA(1);
        if(!(_la===TransformsParser.K_RANGE || _la===TransformsParser.K_ROWS)) {
        this._errHandler.recoverInline(this);
        }
        else {
        	this._errHandler.reportMatch(this);
            this.consume();
        }
        this.state = 573;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case TransformsParser.K_CURRENT:
        case TransformsParser.K_UNBOUNDED:
        case TransformsParser.INTEGER_LITERAL:
            this.state = 571;
            this.window_frame_boundary();
            break;
        case TransformsParser.K_BETWEEN:
            this.state = 572;
            this.window_frame_interval();
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Window_frame_intervalContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_window_frame_interval;
    return this;
}

Window_frame_intervalContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Window_frame_intervalContext.prototype.constructor = Window_frame_intervalContext;

Window_frame_intervalContext.prototype.K_BETWEEN = function() {
    return this.getToken(TransformsParser.K_BETWEEN, 0);
};

Window_frame_intervalContext.prototype.window_frame_boundary = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Window_frame_boundaryContext);
    } else {
        return this.getTypedRuleContext(Window_frame_boundaryContext,i);
    }
};

Window_frame_intervalContext.prototype.K_AND = function() {
    return this.getToken(TransformsParser.K_AND, 0);
};

Window_frame_intervalContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterWindow_frame_interval(this);
	}
};

Window_frame_intervalContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitWindow_frame_interval(this);
	}
};

Window_frame_intervalContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitWindow_frame_interval(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Window_frame_intervalContext = Window_frame_intervalContext;

TransformsParser.prototype.window_frame_interval = function() {

    var localctx = new Window_frame_intervalContext(this, this._ctx, this.state);
    this.enterRule(localctx, 90, TransformsParser.RULE_window_frame_interval);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 575;
        this.match(TransformsParser.K_BETWEEN);
        this.state = 576;
        this.window_frame_boundary();
        this.state = 577;
        this.match(TransformsParser.K_AND);
        this.state = 578;
        this.window_frame_boundary();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Window_frame_boundaryContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_window_frame_boundary;
    return this;
}

Window_frame_boundaryContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Window_frame_boundaryContext.prototype.constructor = Window_frame_boundaryContext;

Window_frame_boundaryContext.prototype.K_UNBOUNDED = function() {
    return this.getToken(TransformsParser.K_UNBOUNDED, 0);
};

Window_frame_boundaryContext.prototype.K_PRECEDING = function() {
    return this.getToken(TransformsParser.K_PRECEDING, 0);
};

Window_frame_boundaryContext.prototype.literalInteger = function() {
    return this.getTypedRuleContext(LiteralIntegerContext,0);
};

Window_frame_boundaryContext.prototype.K_CURRENT = function() {
    return this.getToken(TransformsParser.K_CURRENT, 0);
};

Window_frame_boundaryContext.prototype.K_ROW = function() {
    return this.getToken(TransformsParser.K_ROW, 0);
};

Window_frame_boundaryContext.prototype.K_FOLLOWING = function() {
    return this.getToken(TransformsParser.K_FOLLOWING, 0);
};

Window_frame_boundaryContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterWindow_frame_boundary(this);
	}
};

Window_frame_boundaryContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitWindow_frame_boundary(this);
	}
};

Window_frame_boundaryContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitWindow_frame_boundary(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Window_frame_boundaryContext = Window_frame_boundaryContext;

TransformsParser.prototype.window_frame_boundary = function() {

    var localctx = new Window_frame_boundaryContext(this, this._ctx, this.state);
    this.enterRule(localctx, 92, TransformsParser.RULE_window_frame_boundary);
    try {
        this.state = 592;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,67,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 580;
            this.match(TransformsParser.K_UNBOUNDED);
            this.state = 581;
            this.match(TransformsParser.K_PRECEDING);
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 582;
            this.literalInteger();
            this.state = 583;
            this.match(TransformsParser.K_PRECEDING);
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 585;
            this.match(TransformsParser.K_CURRENT);
            this.state = 586;
            this.match(TransformsParser.K_ROW);
            break;

        case 4:
            this.enterOuterAlt(localctx, 4);
            this.state = 587;
            this.literalInteger();
            this.state = 588;
            this.match(TransformsParser.K_FOLLOWING);
            break;

        case 5:
            this.enterOuterAlt(localctx, 5);
            this.state = 590;
            this.match(TransformsParser.K_UNBOUNDED);
            this.state = 591;
            this.match(TransformsParser.K_FOLLOWING);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ParseExprContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_parseExpr;
    return this;
}

ParseExprContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ParseExprContext.prototype.constructor = ParseExprContext;

ParseExprContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};

ParseExprContext.prototype.EOF = function() {
    return this.getToken(TransformsParser.EOF, 0);
};

ParseExprContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterParseExpr(this);
	}
};

ParseExprContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitParseExpr(this);
	}
};

ParseExprContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitParseExpr(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.ParseExprContext = ParseExprContext;

TransformsParser.prototype.parseExpr = function() {

    var localctx = new ParseExprContext(this, this._ctx, this.state);
    this.enterRule(localctx, 94, TransformsParser.RULE_parseExpr);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 594;
        this.expr(0);
        this.state = 595;
        this.match(TransformsParser.EOF);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function ExprContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_expr;
    return this;
}

ExprContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ExprContext.prototype.constructor = ExprContext;


 
ExprContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};

function IsEmptyContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

IsEmptyContext.prototype = Object.create(ExprContext.prototype);
IsEmptyContext.prototype.constructor = IsEmptyContext;

TransformsParser.IsEmptyContext = IsEmptyContext;

IsEmptyContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};

IsEmptyContext.prototype.K_IS = function() {
    return this.getToken(TransformsParser.K_IS, 0);
};

IsEmptyContext.prototype.K_EMPTY = function() {
    return this.getToken(TransformsParser.K_EMPTY, 0);
};
IsEmptyContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterIsEmpty(this);
	}
};

IsEmptyContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitIsEmpty(this);
	}
};

IsEmptyContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitIsEmpty(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function MultiplicationContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

MultiplicationContext.prototype = Object.create(ExprContext.prototype);
MultiplicationContext.prototype.constructor = MultiplicationContext;

TransformsParser.MultiplicationContext = MultiplicationContext;

MultiplicationContext.prototype.expr = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExprContext);
    } else {
        return this.getTypedRuleContext(ExprContext,i);
    }
};
MultiplicationContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterMultiplication(this);
	}
};

MultiplicationContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitMultiplication(this);
	}
};

MultiplicationContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitMultiplication(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function OrContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

OrContext.prototype = Object.create(ExprContext.prototype);
OrContext.prototype.constructor = OrContext;

TransformsParser.OrContext = OrContext;

OrContext.prototype.expr = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExprContext);
    } else {
        return this.getTypedRuleContext(ExprContext,i);
    }
};

OrContext.prototype.K_OR = function() {
    return this.getToken(TransformsParser.K_OR, 0);
};
OrContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterOr(this);
	}
};

OrContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitOr(this);
	}
};

OrContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitOr(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function NegationContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

NegationContext.prototype = Object.create(ExprContext.prototype);
NegationContext.prototype.constructor = NegationContext;

TransformsParser.NegationContext = NegationContext;

NegationContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};
NegationContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterNegation(this);
	}
};

NegationContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitNegation(this);
	}
};

NegationContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitNegation(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function LTContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

LTContext.prototype = Object.create(ExprContext.prototype);
LTContext.prototype.constructor = LTContext;

TransformsParser.LTContext = LTContext;

LTContext.prototype.expr = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExprContext);
    } else {
        return this.getTypedRuleContext(ExprContext,i);
    }
};
LTContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterLT(this);
	}
};

LTContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitLT(this);
	}
};

LTContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitLT(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function ConvertStructContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ConvertStructContext.prototype = Object.create(ExprContext.prototype);
ConvertStructContext.prototype.constructor = ConvertStructContext;

TransformsParser.ConvertStructContext = ConvertStructContext;

ConvertStructContext.prototype.K_CONVERT_STRUCT = function() {
    return this.getToken(TransformsParser.K_CONVERT_STRUCT, 0);
};

ConvertStructContext.prototype.function_reference = function() {
    return this.getTypedRuleContext(Function_referenceContext,0);
};

ConvertStructContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};
ConvertStructContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterConvertStruct(this);
	}
};

ConvertStructContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitConvertStruct(this);
	}
};

ConvertStructContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitConvertStruct(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function NotNullContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

NotNullContext.prototype = Object.create(ExprContext.prototype);
NotNullContext.prototype.constructor = NotNullContext;

TransformsParser.NotNullContext = NotNullContext;

NotNullContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};

NotNullContext.prototype.K_IS = function() {
    return this.getToken(TransformsParser.K_IS, 0);
};

NotNullContext.prototype.K_NOT = function() {
    return this.getToken(TransformsParser.K_NOT, 0);
};

NotNullContext.prototype.K_NULL = function() {
    return this.getToken(TransformsParser.K_NULL, 0);
};
NotNullContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterNotNull(this);
	}
};

NotNullContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitNotNull(this);
	}
};

NotNullContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitNotNull(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function CaseContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

CaseContext.prototype = Object.create(ExprContext.prototype);
CaseContext.prototype.constructor = CaseContext;

TransformsParser.CaseContext = CaseContext;

CaseContext.prototype.K_CASE = function() {
    return this.getToken(TransformsParser.K_CASE, 0);
};

CaseContext.prototype.K_END = function() {
    return this.getToken(TransformsParser.K_END, 0);
};

CaseContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};

CaseContext.prototype.case_when_clause = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Case_when_clauseContext);
    } else {
        return this.getTypedRuleContext(Case_when_clauseContext,i);
    }
};

CaseContext.prototype.case_else_clause = function() {
    return this.getTypedRuleContext(Case_else_clauseContext,0);
};
CaseContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterCase(this);
	}
};

CaseContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitCase(this);
	}
};

CaseContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitCase(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function ConcatContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ConcatContext.prototype = Object.create(ExprContext.prototype);
ConcatContext.prototype.constructor = ConcatContext;

TransformsParser.ConcatContext = ConcatContext;

ConcatContext.prototype.expr = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExprContext);
    } else {
        return this.getTypedRuleContext(ExprContext,i);
    }
};
ConcatContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterConcat(this);
	}
};

ConcatContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitConcat(this);
	}
};

ConcatContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitConcat(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function IdentifierContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

IdentifierContext.prototype = Object.create(ExprContext.prototype);
IdentifierContext.prototype.constructor = IdentifierContext;

TransformsParser.IdentifierContext = IdentifierContext;

IdentifierContext.prototype.id = function() {
    return this.getTypedRuleContext(IdContext,0);
};
IdentifierContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterIdentifier(this);
	}
};

IdentifierContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitIdentifier(this);
	}
};

IdentifierContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitIdentifier(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function LiteralContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

LiteralContext.prototype = Object.create(ExprContext.prototype);
LiteralContext.prototype.constructor = LiteralContext;

TransformsParser.LiteralContext = LiteralContext;

LiteralContext.prototype.literalRecord = function() {
    return this.getTypedRuleContext(LiteralRecordContext,0);
};

LiteralContext.prototype.literalInteger = function() {
    return this.getTypedRuleContext(LiteralIntegerContext,0);
};

LiteralContext.prototype.literalLong = function() {
    return this.getTypedRuleContext(LiteralLongContext,0);
};

LiteralContext.prototype.literalNumber = function() {
    return this.getTypedRuleContext(LiteralNumberContext,0);
};

LiteralContext.prototype.literalString = function() {
    return this.getTypedRuleContext(LiteralStringContext,0);
};

LiteralContext.prototype.literalNull = function() {
    return this.getTypedRuleContext(LiteralNullContext,0);
};

LiteralContext.prototype.literalTrue = function() {
    return this.getTypedRuleContext(LiteralTrueContext,0);
};

LiteralContext.prototype.literalFalse = function() {
    return this.getTypedRuleContext(LiteralFalseContext,0);
};
LiteralContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterLiteral(this);
	}
};

LiteralContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitLiteral(this);
	}
};

LiteralContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitLiteral(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function DivisionContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

DivisionContext.prototype = Object.create(ExprContext.prototype);
DivisionContext.prototype.constructor = DivisionContext;

TransformsParser.DivisionContext = DivisionContext;

DivisionContext.prototype.expr = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExprContext);
    } else {
        return this.getTypedRuleContext(ExprContext,i);
    }
};
DivisionContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterDivision(this);
	}
};

DivisionContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitDivision(this);
	}
};

DivisionContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitDivision(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function ConvertArrayContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ConvertArrayContext.prototype = Object.create(ExprContext.prototype);
ConvertArrayContext.prototype.constructor = ConvertArrayContext;

TransformsParser.ConvertArrayContext = ConvertArrayContext;

ConvertArrayContext.prototype.K_CONVERT_ARRAY = function() {
    return this.getToken(TransformsParser.K_CONVERT_ARRAY, 0);
};

ConvertArrayContext.prototype.function_reference = function() {
    return this.getTypedRuleContext(Function_referenceContext,0);
};

ConvertArrayContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};
ConvertArrayContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterConvertArray(this);
	}
};

ConvertArrayContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitConvertArray(this);
	}
};

ConvertArrayContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitConvertArray(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function CallContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

CallContext.prototype = Object.create(ExprContext.prototype);
CallContext.prototype.constructor = CallContext;

TransformsParser.CallContext = CallContext;

CallContext.prototype.function_name = function() {
    return this.getTypedRuleContext(Function_nameContext,0);
};

CallContext.prototype.exprs = function() {
    return this.getTypedRuleContext(ExprsContext,0);
};

CallContext.prototype.unpack_expr = function() {
    return this.getTypedRuleContext(Unpack_exprContext,0);
};
CallContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterCall(this);
	}
};

CallContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitCall(this);
	}
};

CallContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitCall(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function AdditionContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

AdditionContext.prototype = Object.create(ExprContext.prototype);
AdditionContext.prototype.constructor = AdditionContext;

TransformsParser.AdditionContext = AdditionContext;

AdditionContext.prototype.expr = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExprContext);
    } else {
        return this.getTypedRuleContext(ExprContext,i);
    }
};
AdditionContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterAddition(this);
	}
};

AdditionContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitAddition(this);
	}
};

AdditionContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitAddition(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function GetFieldContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

GetFieldContext.prototype = Object.create(ExprContext.prototype);
GetFieldContext.prototype.constructor = GetFieldContext;

TransformsParser.GetFieldContext = GetFieldContext;

GetFieldContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};

GetFieldContext.prototype.id = function() {
    return this.getTypedRuleContext(IdContext,0);
};
GetFieldContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterGetField(this);
	}
};

GetFieldContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitGetField(this);
	}
};

GetFieldContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitGetField(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function ModuloContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ModuloContext.prototype = Object.create(ExprContext.prototype);
ModuloContext.prototype.constructor = ModuloContext;

TransformsParser.ModuloContext = ModuloContext;

ModuloContext.prototype.expr = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExprContext);
    } else {
        return this.getTypedRuleContext(ExprContext,i);
    }
};
ModuloContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterModulo(this);
	}
};

ModuloContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitModulo(this);
	}
};

ModuloContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitModulo(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function ReduceContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ReduceContext.prototype = Object.create(ExprContext.prototype);
ReduceContext.prototype.constructor = ReduceContext;

TransformsParser.ReduceContext = ReduceContext;

ReduceContext.prototype.K_REDUCE = function() {
    return this.getToken(TransformsParser.K_REDUCE, 0);
};

ReduceContext.prototype.function_reference = function() {
    return this.getTypedRuleContext(Function_referenceContext,0);
};

ReduceContext.prototype.expr = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExprContext);
    } else {
        return this.getTypedRuleContext(ExprContext,i);
    }
};
ReduceContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterReduce(this);
	}
};

ReduceContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitReduce(this);
	}
};

ReduceContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitReduce(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function GTContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

GTContext.prototype = Object.create(ExprContext.prototype);
GTContext.prototype.constructor = GTContext;

TransformsParser.GTContext = GTContext;

GTContext.prototype.expr = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExprContext);
    } else {
        return this.getTypedRuleContext(ExprContext,i);
    }
};
GTContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterGT(this);
	}
};

GTContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitGT(this);
	}
};

GTContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitGT(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function NotEqualsContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

NotEqualsContext.prototype = Object.create(ExprContext.prototype);
NotEqualsContext.prototype.constructor = NotEqualsContext;

TransformsParser.NotEqualsContext = NotEqualsContext;

NotEqualsContext.prototype.expr = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExprContext);
    } else {
        return this.getTypedRuleContext(ExprContext,i);
    }
};
NotEqualsContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterNotEquals(this);
	}
};

NotEqualsContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitNotEquals(this);
	}
};

NotEqualsContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitNotEquals(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function NotContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

NotContext.prototype = Object.create(ExprContext.prototype);
NotContext.prototype.constructor = NotContext;

TransformsParser.NotContext = NotContext;

NotContext.prototype.K_NOT = function() {
    return this.getToken(TransformsParser.K_NOT, 0);
};

NotContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};
NotContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterNot(this);
	}
};

NotContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitNot(this);
	}
};

NotContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitNot(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function EqualsContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

EqualsContext.prototype = Object.create(ExprContext.prototype);
EqualsContext.prototype.constructor = EqualsContext;

TransformsParser.EqualsContext = EqualsContext;

EqualsContext.prototype.expr = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExprContext);
    } else {
        return this.getTypedRuleContext(ExprContext,i);
    }
};
EqualsContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterEquals(this);
	}
};

EqualsContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitEquals(this);
	}
};

EqualsContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitEquals(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function SubtractionContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

SubtractionContext.prototype = Object.create(ExprContext.prototype);
SubtractionContext.prototype.constructor = SubtractionContext;

TransformsParser.SubtractionContext = SubtractionContext;

SubtractionContext.prototype.expr = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExprContext);
    } else {
        return this.getTypedRuleContext(ExprContext,i);
    }
};
SubtractionContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterSubtraction(this);
	}
};

SubtractionContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitSubtraction(this);
	}
};

SubtractionContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitSubtraction(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function FilterContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

FilterContext.prototype = Object.create(ExprContext.prototype);
FilterContext.prototype.constructor = FilterContext;

TransformsParser.FilterContext = FilterContext;

FilterContext.prototype.K_FILTER = function() {
    return this.getToken(TransformsParser.K_FILTER, 0);
};

FilterContext.prototype.function_reference = function() {
    return this.getTypedRuleContext(Function_referenceContext,0);
};

FilterContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};
FilterContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterFilter(this);
	}
};

FilterContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitFilter(this);
	}
};

FilterContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitFilter(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function AndContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

AndContext.prototype = Object.create(ExprContext.prototype);
AndContext.prototype.constructor = AndContext;

TransformsParser.AndContext = AndContext;

AndContext.prototype.expr = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExprContext);
    } else {
        return this.getTypedRuleContext(ExprContext,i);
    }
};

AndContext.prototype.K_AND = function() {
    return this.getToken(TransformsParser.K_AND, 0);
};
AndContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterAnd(this);
	}
};

AndContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitAnd(this);
	}
};

AndContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitAnd(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function GTEContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

GTEContext.prototype = Object.create(ExprContext.prototype);
GTEContext.prototype.constructor = GTEContext;

TransformsParser.GTEContext = GTEContext;

GTEContext.prototype.expr = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExprContext);
    } else {
        return this.getTypedRuleContext(ExprContext,i);
    }
};
GTEContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterGTE(this);
	}
};

GTEContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitGTE(this);
	}
};

GTEContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitGTE(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function IsNullContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

IsNullContext.prototype = Object.create(ExprContext.prototype);
IsNullContext.prototype.constructor = IsNullContext;

TransformsParser.IsNullContext = IsNullContext;

IsNullContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};

IsNullContext.prototype.K_IS = function() {
    return this.getToken(TransformsParser.K_IS, 0);
};

IsNullContext.prototype.K_NULL = function() {
    return this.getToken(TransformsParser.K_NULL, 0);
};
IsNullContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterIsNull(this);
	}
};

IsNullContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitIsNull(this);
	}
};

IsNullContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitIsNull(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function NotEmptyContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

NotEmptyContext.prototype = Object.create(ExprContext.prototype);
NotEmptyContext.prototype.constructor = NotEmptyContext;

TransformsParser.NotEmptyContext = NotEmptyContext;

NotEmptyContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};

NotEmptyContext.prototype.K_IS = function() {
    return this.getToken(TransformsParser.K_IS, 0);
};

NotEmptyContext.prototype.K_NOT = function() {
    return this.getToken(TransformsParser.K_NOT, 0);
};

NotEmptyContext.prototype.K_EMPTY = function() {
    return this.getToken(TransformsParser.K_EMPTY, 0);
};
NotEmptyContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterNotEmpty(this);
	}
};

NotEmptyContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitNotEmpty(this);
	}
};

NotEmptyContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitNotEmpty(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function LTEContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

LTEContext.prototype = Object.create(ExprContext.prototype);
LTEContext.prototype.constructor = LTEContext;

TransformsParser.LTEContext = LTEContext;

LTEContext.prototype.expr = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExprContext);
    } else {
        return this.getTypedRuleContext(ExprContext,i);
    }
};
LTEContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterLTE(this);
	}
};

LTEContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitLTE(this);
	}
};

LTEContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitLTE(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function MapContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

MapContext.prototype = Object.create(ExprContext.prototype);
MapContext.prototype.constructor = MapContext;

TransformsParser.MapContext = MapContext;

MapContext.prototype.K_MAP = function() {
    return this.getToken(TransformsParser.K_MAP, 0);
};

MapContext.prototype.function_reference = function() {
    return this.getTypedRuleContext(Function_referenceContext,0);
};

MapContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};
MapContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterMap(this);
	}
};

MapContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitMap(this);
	}
};

MapContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitMap(this);
    } else {
        return visitor.visitChildren(this);
    }
};


function ParenContext(parser, ctx) {
	ExprContext.call(this, parser);
    ExprContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ParenContext.prototype = Object.create(ExprContext.prototype);
ParenContext.prototype.constructor = ParenContext;

TransformsParser.ParenContext = ParenContext;

ParenContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};
ParenContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterParen(this);
	}
};

ParenContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitParen(this);
	}
};

ParenContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitParen(this);
    } else {
        return visitor.visitChildren(this);
    }
};



TransformsParser.prototype.expr = function(_p) {
	if(_p===undefined) {
	    _p = 0;
	}
    var _parentctx = this._ctx;
    var _parentState = this.state;
    var localctx = new ExprContext(this, this._ctx, _parentState);
    var _prevctx = localctx;
    var _startState = 96;
    this.enterRecursionRule(localctx, 96, TransformsParser.RULE_expr, _p);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 680;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,74,this._ctx);
        switch(la_) {
        case 1:
            localctx = new LiteralContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;

            this.state = 606;
            this._errHandler.sync(this);
            switch(this._input.LA(1)) {
            case TransformsParser.T__6:
                this.state = 598;
                this.literalRecord();
                break;
            case TransformsParser.INTEGER_LITERAL:
                this.state = 599;
                this.literalInteger();
                break;
            case TransformsParser.LONG_LITERAL:
                this.state = 600;
                this.literalLong();
                break;
            case TransformsParser.NUMERIC_LITERAL:
                this.state = 601;
                this.literalNumber();
                break;
            case TransformsParser.STRING_LITERAL:
                this.state = 602;
                this.literalString();
                break;
            case TransformsParser.K_NULL:
                this.state = 603;
                this.literalNull();
                break;
            case TransformsParser.K_TRUE:
                this.state = 604;
                this.literalTrue();
                break;
            case TransformsParser.K_FALSE:
                this.state = 605;
                this.literalFalse();
                break;
            default:
                throw new antlr4.error.NoViableAltException(this);
            }
            break;

        case 2:
            localctx = new IdentifierContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 608;
            this.id();
            break;

        case 3:
            localctx = new NegationContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 609;
            this.match(TransformsParser.T__9);
            this.state = 610;
            this.expr(28);
            break;

        case 4:
            localctx = new ParenContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 611;
            this.match(TransformsParser.T__2);
            this.state = 612;
            this.expr(0);
            this.state = 613;
            this.match(TransformsParser.T__3);
            break;

        case 5:
            localctx = new NotContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 615;
            this.match(TransformsParser.K_NOT);
            this.state = 616;
            this.expr(11);
            break;

        case 6:
            localctx = new CaseContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 617;
            this.match(TransformsParser.K_CASE);
            this.state = 619;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.T__2) | (1 << TransformsParser.T__6) | (1 << TransformsParser.T__9) | (1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN) | (1 << TransformsParser.K_CASE))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CONVERT_ARRAY - 32)) | (1 << (TransformsParser.K_CONVERT_STRUCT - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_FALSE - 32)) | (1 << (TransformsParser.K_FILTER - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)) | (1 << (TransformsParser.K_MAP - 32)) | (1 << (TransformsParser.K_NOT - 32)))) !== 0) || ((((_la - 64)) & ~0x1f) == 0 && ((1 << (_la - 64)) & ((1 << (TransformsParser.K_NULL - 64)) | (1 << (TransformsParser.K_NULLS - 64)) | (1 << (TransformsParser.K_PRECEDING - 64)) | (1 << (TransformsParser.K_PRIMARY - 64)) | (1 << (TransformsParser.K_RANGE - 64)) | (1 << (TransformsParser.K_REDUCE - 64)) | (1 << (TransformsParser.K_ROW - 64)) | (1 << (TransformsParser.K_ROWS - 64)) | (1 << (TransformsParser.K_TRUE - 64)) | (1 << (TransformsParser.K_UNBOUNDED - 64)) | (1 << (TransformsParser.K_UNPIVOT - 64)) | (1 << (TransformsParser.K_WINDOW - 64)) | (1 << (TransformsParser.K_SAMPLE - 64)) | (1 << (TransformsParser.K_SEED - 64)) | (1 << (TransformsParser.STRING_LITERAL - 64)) | (1 << (TransformsParser.LONG_LITERAL - 64)) | (1 << (TransformsParser.INTEGER_LITERAL - 64)) | (1 << (TransformsParser.NUMERIC_LITERAL - 64)) | (1 << (TransformsParser.IDENTIFIER - 64)))) !== 0)) {
                this.state = 618;
                this.expr(0);
            }

            this.state = 624;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===TransformsParser.K_WHEN) {
                this.state = 621;
                this.case_when_clause();
                this.state = 626;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 628;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if(_la===TransformsParser.K_ELSE) {
                this.state = 627;
                this.case_else_clause();
            }

            this.state = 630;
            this.match(TransformsParser.K_END);
            break;

        case 7:
            localctx = new MapContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 631;
            this.match(TransformsParser.K_MAP);
            this.state = 632;
            this.match(TransformsParser.T__2);
            this.state = 633;
            this.function_reference();
            this.state = 634;
            this.match(TransformsParser.T__1);
            this.state = 635;
            this.expr(0);
            this.state = 636;
            this.match(TransformsParser.T__3);
            break;

        case 8:
            localctx = new FilterContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 638;
            this.match(TransformsParser.K_FILTER);
            this.state = 639;
            this.match(TransformsParser.T__2);
            this.state = 640;
            this.function_reference();
            this.state = 641;
            this.match(TransformsParser.T__1);
            this.state = 642;
            this.expr(0);
            this.state = 643;
            this.match(TransformsParser.T__3);
            break;

        case 9:
            localctx = new ReduceContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 645;
            this.match(TransformsParser.K_REDUCE);
            this.state = 646;
            this.match(TransformsParser.T__2);
            this.state = 647;
            this.function_reference();
            this.state = 648;
            this.match(TransformsParser.T__1);
            this.state = 649;
            this.expr(0);
            this.state = 650;
            this.match(TransformsParser.T__1);
            this.state = 651;
            this.expr(0);
            this.state = 652;
            this.match(TransformsParser.T__3);
            break;

        case 10:
            localctx = new ConvertArrayContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 654;
            this.match(TransformsParser.K_CONVERT_ARRAY);
            this.state = 655;
            this.match(TransformsParser.T__2);
            this.state = 656;
            this.function_reference();
            this.state = 657;
            this.match(TransformsParser.T__1);
            this.state = 658;
            this.expr(0);
            this.state = 659;
            this.match(TransformsParser.T__3);
            break;

        case 11:
            localctx = new ConvertStructContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 661;
            this.match(TransformsParser.K_CONVERT_STRUCT);
            this.state = 662;
            this.match(TransformsParser.T__2);
            this.state = 663;
            this.function_reference();
            this.state = 664;
            this.match(TransformsParser.T__1);
            this.state = 665;
            this.expr(0);
            this.state = 666;
            this.match(TransformsParser.T__3);
            break;

        case 12:
            localctx = new CallContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 668;
            this.function_name();
            this.state = 669;
            this.match(TransformsParser.T__2);
            this.state = 676;
            this._errHandler.sync(this);
            switch (this._input.LA(1)) {
            case TransformsParser.T__2:
            case TransformsParser.T__6:
            case TransformsParser.T__9:
            case TransformsParser.K_ALL:
            case TransformsParser.K_ARRAY:
            case TransformsParser.K_BETWEEN:
            case TransformsParser.K_CASE:
            case TransformsParser.K_CHECKPOINT:
            case TransformsParser.K_CONVERT_ARRAY:
            case TransformsParser.K_CONVERT_STRUCT:
            case TransformsParser.K_CURRENT:
            case TransformsParser.K_DISAMBIGUATE:
            case TransformsParser.K_DROP:
            case TransformsParser.K_ENFORCE:
            case TransformsParser.K_FALSE:
            case TransformsParser.K_FILTER:
            case TransformsParser.K_FIRST:
            case TransformsParser.K_FOLLOWING:
            case TransformsParser.K_JOIN:
            case TransformsParser.K_KEY:
            case TransformsParser.K_LAST:
            case TransformsParser.K_LOOKUP:
            case TransformsParser.K_MAP:
            case TransformsParser.K_NOT:
            case TransformsParser.K_NULL:
            case TransformsParser.K_NULLS:
            case TransformsParser.K_PRECEDING:
            case TransformsParser.K_PRIMARY:
            case TransformsParser.K_RANGE:
            case TransformsParser.K_REDUCE:
            case TransformsParser.K_ROW:
            case TransformsParser.K_ROWS:
            case TransformsParser.K_TRUE:
            case TransformsParser.K_UNBOUNDED:
            case TransformsParser.K_UNPIVOT:
            case TransformsParser.K_WINDOW:
            case TransformsParser.K_SAMPLE:
            case TransformsParser.K_SEED:
            case TransformsParser.STRING_LITERAL:
            case TransformsParser.LONG_LITERAL:
            case TransformsParser.INTEGER_LITERAL:
            case TransformsParser.NUMERIC_LITERAL:
            case TransformsParser.IDENTIFIER:
            	this.state = 670;
            	this.exprs();
            	this.state = 673;
            	this._errHandler.sync(this);
            	_la = this._input.LA(1);
            	if(_la===TransformsParser.T__1) {
            	    this.state = 671;
            	    this.match(TransformsParser.T__1);
            	    this.state = 672;
            	    this.unpack_expr();
            	}

            	break;
            case TransformsParser.T__22:
            	this.state = 675;
            	this.unpack_expr();
            	break;
            case TransformsParser.T__3:
            	break;
            default:
            	break;
            }
            this.state = 678;
            this.match(TransformsParser.T__3);
            break;

        }
        this._ctx.stop = this._input.LT(-1);
        this.state = 743;
        this._errHandler.sync(this);
        var _alt = this._interp.adaptivePredict(this._input,76,this._ctx)
        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
            if(_alt===1) {
                if(this._parseListeners!==null) {
                    this.triggerExitRuleEvent();
                }
                _prevctx = localctx;
                this.state = 741;
                this._errHandler.sync(this);
                var la_ = this._interp.adaptivePredict(this._input,75,this._ctx);
                switch(la_) {
                case 1:
                    localctx = new EqualsContext(this, new ExprContext(this, _parentctx, _parentState));
                    this.pushNewRecursionContext(localctx, _startState, TransformsParser.RULE_expr);
                    this.state = 682;
                    if (!( this.precpred(this._ctx, 23))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 23)");
                    }
                    this.state = 683;
                    _la = this._input.LA(1);
                    if(!(_la===TransformsParser.T__10 || _la===TransformsParser.T__11)) {
                    this._errHandler.recoverInline(this);
                    }
                    else {
                    	this._errHandler.reportMatch(this);
                        this.consume();
                    }
                    this.state = 684;
                    this.expr(24);
                    break;

                case 2:
                    localctx = new NotEqualsContext(this, new ExprContext(this, _parentctx, _parentState));
                    this.pushNewRecursionContext(localctx, _startState, TransformsParser.RULE_expr);
                    this.state = 685;
                    if (!( this.precpred(this._ctx, 22))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 22)");
                    }
                    this.state = 686;
                    _la = this._input.LA(1);
                    if(!(_la===TransformsParser.T__12 || _la===TransformsParser.T__13)) {
                    this._errHandler.recoverInline(this);
                    }
                    else {
                    	this._errHandler.reportMatch(this);
                        this.consume();
                    }
                    this.state = 687;
                    this.expr(23);
                    break;

                case 3:
                    localctx = new GTContext(this, new ExprContext(this, _parentctx, _parentState));
                    this.pushNewRecursionContext(localctx, _startState, TransformsParser.RULE_expr);
                    this.state = 688;
                    if (!( this.precpred(this._ctx, 21))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 21)");
                    }
                    this.state = 689;
                    this.match(TransformsParser.T__14);
                    this.state = 690;
                    this.expr(22);
                    break;

                case 4:
                    localctx = new GTEContext(this, new ExprContext(this, _parentctx, _parentState));
                    this.pushNewRecursionContext(localctx, _startState, TransformsParser.RULE_expr);
                    this.state = 691;
                    if (!( this.precpred(this._ctx, 20))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 20)");
                    }
                    this.state = 692;
                    this.match(TransformsParser.T__15);
                    this.state = 693;
                    this.expr(21);
                    break;

                case 5:
                    localctx = new LTContext(this, new ExprContext(this, _parentctx, _parentState));
                    this.pushNewRecursionContext(localctx, _startState, TransformsParser.RULE_expr);
                    this.state = 694;
                    if (!( this.precpred(this._ctx, 19))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 19)");
                    }
                    this.state = 695;
                    this.match(TransformsParser.T__16);
                    this.state = 696;
                    this.expr(20);
                    break;

                case 6:
                    localctx = new LTEContext(this, new ExprContext(this, _parentctx, _parentState));
                    this.pushNewRecursionContext(localctx, _startState, TransformsParser.RULE_expr);
                    this.state = 697;
                    if (!( this.precpred(this._ctx, 18))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 18)");
                    }
                    this.state = 698;
                    this.match(TransformsParser.T__17);
                    this.state = 699;
                    this.expr(19);
                    break;

                case 7:
                    localctx = new MultiplicationContext(this, new ExprContext(this, _parentctx, _parentState));
                    this.pushNewRecursionContext(localctx, _startState, TransformsParser.RULE_expr);
                    this.state = 700;
                    if (!( this.precpred(this._ctx, 17))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 17)");
                    }
                    this.state = 701;
                    this.match(TransformsParser.T__0);
                    this.state = 702;
                    this.expr(18);
                    break;

                case 8:
                    localctx = new DivisionContext(this, new ExprContext(this, _parentctx, _parentState));
                    this.pushNewRecursionContext(localctx, _startState, TransformsParser.RULE_expr);
                    this.state = 703;
                    if (!( this.precpred(this._ctx, 16))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 16)");
                    }
                    this.state = 704;
                    this.match(TransformsParser.T__18);
                    this.state = 705;
                    this.expr(17);
                    break;

                case 9:
                    localctx = new ModuloContext(this, new ExprContext(this, _parentctx, _parentState));
                    this.pushNewRecursionContext(localctx, _startState, TransformsParser.RULE_expr);
                    this.state = 706;
                    if (!( this.precpred(this._ctx, 15))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 15)");
                    }
                    this.state = 707;
                    this.match(TransformsParser.T__19);
                    this.state = 708;
                    this.expr(16);
                    break;

                case 10:
                    localctx = new AdditionContext(this, new ExprContext(this, _parentctx, _parentState));
                    this.pushNewRecursionContext(localctx, _startState, TransformsParser.RULE_expr);
                    this.state = 709;
                    if (!( this.precpred(this._ctx, 14))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 14)");
                    }
                    this.state = 710;
                    this.match(TransformsParser.T__20);
                    this.state = 711;
                    this.expr(15);
                    break;

                case 11:
                    localctx = new SubtractionContext(this, new ExprContext(this, _parentctx, _parentState));
                    this.pushNewRecursionContext(localctx, _startState, TransformsParser.RULE_expr);
                    this.state = 712;
                    if (!( this.precpred(this._ctx, 13))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 13)");
                    }
                    this.state = 713;
                    this.match(TransformsParser.T__9);
                    this.state = 714;
                    this.expr(14);
                    break;

                case 12:
                    localctx = new AndContext(this, new ExprContext(this, _parentctx, _parentState));
                    this.pushNewRecursionContext(localctx, _startState, TransformsParser.RULE_expr);
                    this.state = 715;
                    if (!( this.precpred(this._ctx, 10))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 10)");
                    }
                    this.state = 716;
                    this.match(TransformsParser.K_AND);
                    this.state = 717;
                    this.expr(11);
                    break;

                case 13:
                    localctx = new OrContext(this, new ExprContext(this, _parentctx, _parentState));
                    this.pushNewRecursionContext(localctx, _startState, TransformsParser.RULE_expr);
                    this.state = 718;
                    if (!( this.precpred(this._ctx, 9))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 9)");
                    }
                    this.state = 719;
                    this.match(TransformsParser.K_OR);
                    this.state = 720;
                    this.expr(10);
                    break;

                case 14:
                    localctx = new ConcatContext(this, new ExprContext(this, _parentctx, _parentState));
                    this.pushNewRecursionContext(localctx, _startState, TransformsParser.RULE_expr);
                    this.state = 721;
                    if (!( this.precpred(this._ctx, 7))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 7)");
                    }
                    this.state = 722;
                    this.match(TransformsParser.T__21);
                    this.state = 723;
                    this.expr(8);
                    break;

                case 15:
                    localctx = new GetFieldContext(this, new ExprContext(this, _parentctx, _parentState));
                    this.pushNewRecursionContext(localctx, _startState, TransformsParser.RULE_expr);
                    this.state = 724;
                    if (!( this.precpred(this._ctx, 29))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 29)");
                    }
                    this.state = 725;
                    this.match(TransformsParser.T__8);
                    this.state = 726;
                    this.id();
                    break;

                case 16:
                    localctx = new IsNullContext(this, new ExprContext(this, _parentctx, _parentState));
                    this.pushNewRecursionContext(localctx, _startState, TransformsParser.RULE_expr);
                    this.state = 727;
                    if (!( this.precpred(this._ctx, 27))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 27)");
                    }
                    this.state = 728;
                    this.match(TransformsParser.K_IS);
                    this.state = 729;
                    this.match(TransformsParser.K_NULL);
                    break;

                case 17:
                    localctx = new NotNullContext(this, new ExprContext(this, _parentctx, _parentState));
                    this.pushNewRecursionContext(localctx, _startState, TransformsParser.RULE_expr);
                    this.state = 730;
                    if (!( this.precpred(this._ctx, 26))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 26)");
                    }
                    this.state = 731;
                    this.match(TransformsParser.K_IS);
                    this.state = 732;
                    this.match(TransformsParser.K_NOT);
                    this.state = 733;
                    this.match(TransformsParser.K_NULL);
                    break;

                case 18:
                    localctx = new IsEmptyContext(this, new ExprContext(this, _parentctx, _parentState));
                    this.pushNewRecursionContext(localctx, _startState, TransformsParser.RULE_expr);
                    this.state = 734;
                    if (!( this.precpred(this._ctx, 25))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 25)");
                    }
                    this.state = 735;
                    this.match(TransformsParser.K_IS);
                    this.state = 736;
                    this.match(TransformsParser.K_EMPTY);
                    break;

                case 19:
                    localctx = new NotEmptyContext(this, new ExprContext(this, _parentctx, _parentState));
                    this.pushNewRecursionContext(localctx, _startState, TransformsParser.RULE_expr);
                    this.state = 737;
                    if (!( this.precpred(this._ctx, 24))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 24)");
                    }
                    this.state = 738;
                    this.match(TransformsParser.K_IS);
                    this.state = 739;
                    this.match(TransformsParser.K_NOT);
                    this.state = 740;
                    this.match(TransformsParser.K_EMPTY);
                    break;

                } 
            }
            this.state = 745;
            this._errHandler.sync(this);
            _alt = this._interp.adaptivePredict(this._input,76,this._ctx);
        }

    } catch( error) {
        if(error instanceof antlr4.error.RecognitionException) {
	        localctx.exception = error;
	        this._errHandler.reportError(this, error);
	        this._errHandler.recover(this, error);
	    } else {
	    	throw error;
	    }
    } finally {
        this.unrollRecursionContexts(_parentctx)
    }
    return localctx;
};

function Unpack_exprContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_unpack_expr;
    return this;
}

Unpack_exprContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Unpack_exprContext.prototype.constructor = Unpack_exprContext;

Unpack_exprContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};

Unpack_exprContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterUnpack_expr(this);
	}
};

Unpack_exprContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitUnpack_expr(this);
	}
};

Unpack_exprContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitUnpack_expr(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Unpack_exprContext = Unpack_exprContext;

TransformsParser.prototype.unpack_expr = function() {

    var localctx = new Unpack_exprContext(this, this._ctx, this.state);
    this.enterRule(localctx, 98, TransformsParser.RULE_unpack_expr);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 746;
        this.match(TransformsParser.T__22);
        this.state = 747;
        this.match(TransformsParser.T__22);
        this.state = 748;
        this.match(TransformsParser.T__22);
        this.state = 749;
        this.expr(0);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function LiteralRecordContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_literalRecord;
    return this;
}

LiteralRecordContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
LiteralRecordContext.prototype.constructor = LiteralRecordContext;

LiteralRecordContext.prototype.record_fields = function() {
    return this.getTypedRuleContext(Record_fieldsContext,0);
};

LiteralRecordContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterLiteralRecord(this);
	}
};

LiteralRecordContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitLiteralRecord(this);
	}
};

LiteralRecordContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitLiteralRecord(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.LiteralRecordContext = LiteralRecordContext;

TransformsParser.prototype.literalRecord = function() {

    var localctx = new LiteralRecordContext(this, this._ctx, this.state);
    this.enterRule(localctx, 100, TransformsParser.RULE_literalRecord);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 751;
        this.match(TransformsParser.T__6);
        this.state = 753;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)))) !== 0) || ((((_la - 65)) & ~0x1f) == 0 && ((1 << (_la - 65)) & ((1 << (TransformsParser.K_NULLS - 65)) | (1 << (TransformsParser.K_PRECEDING - 65)) | (1 << (TransformsParser.K_PRIMARY - 65)) | (1 << (TransformsParser.K_RANGE - 65)) | (1 << (TransformsParser.K_ROW - 65)) | (1 << (TransformsParser.K_ROWS - 65)) | (1 << (TransformsParser.K_UNBOUNDED - 65)) | (1 << (TransformsParser.K_UNPIVOT - 65)) | (1 << (TransformsParser.K_WINDOW - 65)) | (1 << (TransformsParser.K_SAMPLE - 65)) | (1 << (TransformsParser.K_SEED - 65)) | (1 << (TransformsParser.IDENTIFIER - 65)))) !== 0)) {
            this.state = 752;
            this.record_fields();
        }

        this.state = 755;
        this.match(TransformsParser.T__7);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Record_fieldsContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_record_fields;
    return this;
}

Record_fieldsContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Record_fieldsContext.prototype.constructor = Record_fieldsContext;

Record_fieldsContext.prototype.record_field = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Record_fieldContext);
    } else {
        return this.getTypedRuleContext(Record_fieldContext,i);
    }
};

Record_fieldsContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterRecord_fields(this);
	}
};

Record_fieldsContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitRecord_fields(this);
	}
};

Record_fieldsContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitRecord_fields(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Record_fieldsContext = Record_fieldsContext;

TransformsParser.prototype.record_fields = function() {

    var localctx = new Record_fieldsContext(this, this._ctx, this.state);
    this.enterRule(localctx, 102, TransformsParser.RULE_record_fields);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 757;
        this.record_field();
        this.state = 762;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while(_la===TransformsParser.T__1) {
            this.state = 758;
            this.match(TransformsParser.T__1);
            this.state = 759;
            this.record_field();
            this.state = 764;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Record_fieldContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_record_field;
    return this;
}

Record_fieldContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Record_fieldContext.prototype.constructor = Record_fieldContext;

Record_fieldContext.prototype.id = function() {
    return this.getTypedRuleContext(IdContext,0);
};

Record_fieldContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};

Record_fieldContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterRecord_field(this);
	}
};

Record_fieldContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitRecord_field(this);
	}
};

Record_fieldContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitRecord_field(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Record_fieldContext = Record_fieldContext;

TransformsParser.prototype.record_field = function() {

    var localctx = new Record_fieldContext(this, this._ctx, this.state);
    this.enterRule(localctx, 104, TransformsParser.RULE_record_field);
    try {
        this.state = 770;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,79,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 765;
            this.id();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 766;
            this.id();
            this.state = 767;
            this.match(TransformsParser.T__5);
            this.state = 768;
            this.expr(0);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function LiteralIntegerContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_literalInteger;
    return this;
}

LiteralIntegerContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
LiteralIntegerContext.prototype.constructor = LiteralIntegerContext;

LiteralIntegerContext.prototype.INTEGER_LITERAL = function() {
    return this.getToken(TransformsParser.INTEGER_LITERAL, 0);
};

LiteralIntegerContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterLiteralInteger(this);
	}
};

LiteralIntegerContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitLiteralInteger(this);
	}
};

LiteralIntegerContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitLiteralInteger(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.LiteralIntegerContext = LiteralIntegerContext;

TransformsParser.prototype.literalInteger = function() {

    var localctx = new LiteralIntegerContext(this, this._ctx, this.state);
    this.enterRule(localctx, 106, TransformsParser.RULE_literalInteger);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 772;
        this.match(TransformsParser.INTEGER_LITERAL);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function LiteralLongContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_literalLong;
    return this;
}

LiteralLongContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
LiteralLongContext.prototype.constructor = LiteralLongContext;

LiteralLongContext.prototype.LONG_LITERAL = function() {
    return this.getToken(TransformsParser.LONG_LITERAL, 0);
};

LiteralLongContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterLiteralLong(this);
	}
};

LiteralLongContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitLiteralLong(this);
	}
};

LiteralLongContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitLiteralLong(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.LiteralLongContext = LiteralLongContext;

TransformsParser.prototype.literalLong = function() {

    var localctx = new LiteralLongContext(this, this._ctx, this.state);
    this.enterRule(localctx, 108, TransformsParser.RULE_literalLong);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 774;
        this.match(TransformsParser.LONG_LITERAL);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function LiteralNumberContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_literalNumber;
    return this;
}

LiteralNumberContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
LiteralNumberContext.prototype.constructor = LiteralNumberContext;

LiteralNumberContext.prototype.NUMERIC_LITERAL = function() {
    return this.getToken(TransformsParser.NUMERIC_LITERAL, 0);
};

LiteralNumberContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterLiteralNumber(this);
	}
};

LiteralNumberContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitLiteralNumber(this);
	}
};

LiteralNumberContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitLiteralNumber(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.LiteralNumberContext = LiteralNumberContext;

TransformsParser.prototype.literalNumber = function() {

    var localctx = new LiteralNumberContext(this, this._ctx, this.state);
    this.enterRule(localctx, 110, TransformsParser.RULE_literalNumber);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 776;
        this.match(TransformsParser.NUMERIC_LITERAL);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function LiteralStringContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_literalString;
    return this;
}

LiteralStringContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
LiteralStringContext.prototype.constructor = LiteralStringContext;

LiteralStringContext.prototype.STRING_LITERAL = function() {
    return this.getToken(TransformsParser.STRING_LITERAL, 0);
};

LiteralStringContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterLiteralString(this);
	}
};

LiteralStringContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitLiteralString(this);
	}
};

LiteralStringContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitLiteralString(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.LiteralStringContext = LiteralStringContext;

TransformsParser.prototype.literalString = function() {

    var localctx = new LiteralStringContext(this, this._ctx, this.state);
    this.enterRule(localctx, 112, TransformsParser.RULE_literalString);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 778;
        this.match(TransformsParser.STRING_LITERAL);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function LiteralNullContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_literalNull;
    return this;
}

LiteralNullContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
LiteralNullContext.prototype.constructor = LiteralNullContext;

LiteralNullContext.prototype.K_NULL = function() {
    return this.getToken(TransformsParser.K_NULL, 0);
};

LiteralNullContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterLiteralNull(this);
	}
};

LiteralNullContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitLiteralNull(this);
	}
};

LiteralNullContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitLiteralNull(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.LiteralNullContext = LiteralNullContext;

TransformsParser.prototype.literalNull = function() {

    var localctx = new LiteralNullContext(this, this._ctx, this.state);
    this.enterRule(localctx, 114, TransformsParser.RULE_literalNull);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 780;
        this.match(TransformsParser.K_NULL);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function LiteralTrueContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_literalTrue;
    return this;
}

LiteralTrueContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
LiteralTrueContext.prototype.constructor = LiteralTrueContext;

LiteralTrueContext.prototype.K_TRUE = function() {
    return this.getToken(TransformsParser.K_TRUE, 0);
};

LiteralTrueContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterLiteralTrue(this);
	}
};

LiteralTrueContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitLiteralTrue(this);
	}
};

LiteralTrueContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitLiteralTrue(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.LiteralTrueContext = LiteralTrueContext;

TransformsParser.prototype.literalTrue = function() {

    var localctx = new LiteralTrueContext(this, this._ctx, this.state);
    this.enterRule(localctx, 116, TransformsParser.RULE_literalTrue);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 782;
        this.match(TransformsParser.K_TRUE);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function LiteralFalseContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_literalFalse;
    return this;
}

LiteralFalseContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
LiteralFalseContext.prototype.constructor = LiteralFalseContext;

LiteralFalseContext.prototype.K_FALSE = function() {
    return this.getToken(TransformsParser.K_FALSE, 0);
};

LiteralFalseContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterLiteralFalse(this);
	}
};

LiteralFalseContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitLiteralFalse(this);
	}
};

LiteralFalseContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitLiteralFalse(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.LiteralFalseContext = LiteralFalseContext;

TransformsParser.prototype.literalFalse = function() {

    var localctx = new LiteralFalseContext(this, this._ctx, this.state);
    this.enterRule(localctx, 118, TransformsParser.RULE_literalFalse);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 784;
        this.match(TransformsParser.K_FALSE);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Case_when_clauseContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_case_when_clause;
    return this;
}

Case_when_clauseContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Case_when_clauseContext.prototype.constructor = Case_when_clauseContext;

Case_when_clauseContext.prototype.K_WHEN = function() {
    return this.getToken(TransformsParser.K_WHEN, 0);
};

Case_when_clauseContext.prototype.expr = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExprContext);
    } else {
        return this.getTypedRuleContext(ExprContext,i);
    }
};

Case_when_clauseContext.prototype.K_THEN = function() {
    return this.getToken(TransformsParser.K_THEN, 0);
};

Case_when_clauseContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterCase_when_clause(this);
	}
};

Case_when_clauseContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitCase_when_clause(this);
	}
};

Case_when_clauseContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitCase_when_clause(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Case_when_clauseContext = Case_when_clauseContext;

TransformsParser.prototype.case_when_clause = function() {

    var localctx = new Case_when_clauseContext(this, this._ctx, this.state);
    this.enterRule(localctx, 120, TransformsParser.RULE_case_when_clause);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 786;
        this.match(TransformsParser.K_WHEN);
        this.state = 787;
        this.expr(0);
        this.state = 788;
        this.match(TransformsParser.K_THEN);
        this.state = 789;
        this.expr(0);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Case_else_clauseContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_case_else_clause;
    return this;
}

Case_else_clauseContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Case_else_clauseContext.prototype.constructor = Case_else_clauseContext;

Case_else_clauseContext.prototype.K_ELSE = function() {
    return this.getToken(TransformsParser.K_ELSE, 0);
};

Case_else_clauseContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};

Case_else_clauseContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterCase_else_clause(this);
	}
};

Case_else_clauseContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitCase_else_clause(this);
	}
};

Case_else_clauseContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitCase_else_clause(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Case_else_clauseContext = Case_else_clauseContext;

TransformsParser.prototype.case_else_clause = function() {

    var localctx = new Case_else_clauseContext(this, this._ctx, this.state);
    this.enterRule(localctx, 122, TransformsParser.RULE_case_else_clause);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 791;
        this.match(TransformsParser.K_ELSE);
        this.state = 792;
        this.expr(0);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Function_referenceContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_function_reference;
    return this;
}

Function_referenceContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Function_referenceContext.prototype.constructor = Function_referenceContext;

Function_referenceContext.prototype.function_name = function() {
    return this.getTypedRuleContext(Function_nameContext,0);
};

Function_referenceContext.prototype.lambda = function() {
    return this.getTypedRuleContext(LambdaContext,0);
};

Function_referenceContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterFunction_reference(this);
	}
};

Function_referenceContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitFunction_reference(this);
	}
};

Function_referenceContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitFunction_reference(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Function_referenceContext = Function_referenceContext;

TransformsParser.prototype.function_reference = function() {

    var localctx = new Function_referenceContext(this, this._ctx, this.state);
    this.enterRule(localctx, 124, TransformsParser.RULE_function_reference);
    try {
        this.state = 796;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case TransformsParser.K_ALL:
        case TransformsParser.K_ARRAY:
        case TransformsParser.K_BETWEEN:
        case TransformsParser.K_CHECKPOINT:
        case TransformsParser.K_CURRENT:
        case TransformsParser.K_DISAMBIGUATE:
        case TransformsParser.K_DROP:
        case TransformsParser.K_ENFORCE:
        case TransformsParser.K_FIRST:
        case TransformsParser.K_FOLLOWING:
        case TransformsParser.K_JOIN:
        case TransformsParser.K_KEY:
        case TransformsParser.K_LAST:
        case TransformsParser.K_LOOKUP:
        case TransformsParser.K_NULLS:
        case TransformsParser.K_PRECEDING:
        case TransformsParser.K_PRIMARY:
        case TransformsParser.K_RANGE:
        case TransformsParser.K_ROW:
        case TransformsParser.K_ROWS:
        case TransformsParser.K_UNBOUNDED:
        case TransformsParser.K_UNPIVOT:
        case TransformsParser.K_WINDOW:
        case TransformsParser.K_SAMPLE:
        case TransformsParser.K_SEED:
        case TransformsParser.IDENTIFIER:
            this.enterOuterAlt(localctx, 1);
            this.state = 794;
            this.function_name();
            break;
        case TransformsParser.K_LAMBDA:
            this.enterOuterAlt(localctx, 2);
            this.state = 795;
            this.lambda();
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function LambdaContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_lambda;
    return this;
}

LambdaContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
LambdaContext.prototype.constructor = LambdaContext;

LambdaContext.prototype.K_LAMBDA = function() {
    return this.getToken(TransformsParser.K_LAMBDA, 0);
};

LambdaContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};

LambdaContext.prototype.identifier_list = function() {
    return this.getTypedRuleContext(Identifier_listContext,0);
};

LambdaContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterLambda(this);
	}
};

LambdaContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitLambda(this);
	}
};

LambdaContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitLambda(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.LambdaContext = LambdaContext;

TransformsParser.prototype.lambda = function() {

    var localctx = new LambdaContext(this, this._ctx, this.state);
    this.enterRule(localctx, 126, TransformsParser.RULE_lambda);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 798;
        this.match(TransformsParser.K_LAMBDA);
        this.state = 800;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)))) !== 0) || ((((_la - 65)) & ~0x1f) == 0 && ((1 << (_la - 65)) & ((1 << (TransformsParser.K_NULLS - 65)) | (1 << (TransformsParser.K_PRECEDING - 65)) | (1 << (TransformsParser.K_PRIMARY - 65)) | (1 << (TransformsParser.K_RANGE - 65)) | (1 << (TransformsParser.K_ROW - 65)) | (1 << (TransformsParser.K_ROWS - 65)) | (1 << (TransformsParser.K_UNBOUNDED - 65)) | (1 << (TransformsParser.K_UNPIVOT - 65)) | (1 << (TransformsParser.K_WINDOW - 65)) | (1 << (TransformsParser.K_SAMPLE - 65)) | (1 << (TransformsParser.K_SEED - 65)) | (1 << (TransformsParser.IDENTIFIER - 65)))) !== 0)) {
            this.state = 799;
            this.identifier_list();
        }

        this.state = 802;
        this.match(TransformsParser.T__5);
        this.state = 803;
        this.expr(0);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Function_nameContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_function_name;
    return this;
}

Function_nameContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Function_nameContext.prototype.constructor = Function_nameContext;

Function_nameContext.prototype.id = function() {
    return this.getTypedRuleContext(IdContext,0);
};

Function_nameContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterFunction_name(this);
	}
};

Function_nameContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitFunction_name(this);
	}
};

Function_nameContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitFunction_name(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Function_nameContext = Function_nameContext;

TransformsParser.prototype.function_name = function() {

    var localctx = new Function_nameContext(this, this._ctx, this.state);
    this.enterRule(localctx, 128, TransformsParser.RULE_function_name);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 805;
        this.id();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function DatasetContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_dataset;
    return this;
}

DatasetContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
DatasetContext.prototype.constructor = DatasetContext;

DatasetContext.prototype.dataset_name = function() {
    return this.getTypedRuleContext(Dataset_nameContext,0);
};

DatasetContext.prototype.dataset_expr = function() {
    return this.getTypedRuleContext(Dataset_exprContext,0);
};

DatasetContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterDataset(this);
	}
};

DatasetContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitDataset(this);
	}
};

DatasetContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitDataset(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.DatasetContext = DatasetContext;

TransformsParser.prototype.dataset = function() {

    var localctx = new DatasetContext(this, this._ctx, this.state);
    this.enterRule(localctx, 130, TransformsParser.RULE_dataset);
    try {
        this.state = 809;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,82,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 807;
            this.dataset_name();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 808;
            this.dataset_expr();
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Dataset_nameContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_dataset_name;
    return this;
}

Dataset_nameContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Dataset_nameContext.prototype.constructor = Dataset_nameContext;

Dataset_nameContext.prototype.id = function() {
    return this.getTypedRuleContext(IdContext,0);
};

Dataset_nameContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterDataset_name(this);
	}
};

Dataset_nameContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitDataset_name(this);
	}
};

Dataset_nameContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitDataset_name(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Dataset_nameContext = Dataset_nameContext;

TransformsParser.prototype.dataset_name = function() {

    var localctx = new Dataset_nameContext(this, this._ctx, this.state);
    this.enterRule(localctx, 132, TransformsParser.RULE_dataset_name);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 811;
        this.id();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Dataset_exprContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_dataset_expr;
    return this;
}

Dataset_exprContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Dataset_exprContext.prototype.constructor = Dataset_exprContext;

Dataset_exprContext.prototype.function_name = function() {
    return this.getTypedRuleContext(Function_nameContext,0);
};

Dataset_exprContext.prototype.dataset_list = function() {
    return this.getTypedRuleContext(Dataset_listContext,0);
};

Dataset_exprContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterDataset_expr(this);
	}
};

Dataset_exprContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitDataset_expr(this);
	}
};

Dataset_exprContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitDataset_expr(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Dataset_exprContext = Dataset_exprContext;

TransformsParser.prototype.dataset_expr = function() {

    var localctx = new Dataset_exprContext(this, this._ctx, this.state);
    this.enterRule(localctx, 134, TransformsParser.RULE_dataset_expr);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 813;
        this.function_name();
        this.state = 814;
        this.match(TransformsParser.T__2);
        this.state = 816;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)))) !== 0) || ((((_la - 65)) & ~0x1f) == 0 && ((1 << (_la - 65)) & ((1 << (TransformsParser.K_NULLS - 65)) | (1 << (TransformsParser.K_PRECEDING - 65)) | (1 << (TransformsParser.K_PRIMARY - 65)) | (1 << (TransformsParser.K_RANGE - 65)) | (1 << (TransformsParser.K_ROW - 65)) | (1 << (TransformsParser.K_ROWS - 65)) | (1 << (TransformsParser.K_UNBOUNDED - 65)) | (1 << (TransformsParser.K_UNPIVOT - 65)) | (1 << (TransformsParser.K_WINDOW - 65)) | (1 << (TransformsParser.K_SAMPLE - 65)) | (1 << (TransformsParser.K_SEED - 65)) | (1 << (TransformsParser.IDENTIFIER - 65)))) !== 0)) {
            this.state = 815;
            this.dataset_list();
        }

        this.state = 818;
        this.match(TransformsParser.T__3);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function HintContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_hint;
    return this;
}

HintContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
HintContext.prototype.constructor = HintContext;

HintContext.prototype.id = function() {
    return this.getTypedRuleContext(IdContext,0);
};

HintContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterHint(this);
	}
};

HintContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitHint(this);
	}
};

HintContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitHint(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.HintContext = HintContext;

TransformsParser.prototype.hint = function() {

    var localctx = new HintContext(this, this._ctx, this.state);
    this.enterRule(localctx, 136, TransformsParser.RULE_hint);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 820;
        this.id();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Dataset_listContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_dataset_list;
    return this;
}

Dataset_listContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Dataset_listContext.prototype.constructor = Dataset_listContext;

Dataset_listContext.prototype.dataset = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(DatasetContext);
    } else {
        return this.getTypedRuleContext(DatasetContext,i);
    }
};

Dataset_listContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterDataset_list(this);
	}
};

Dataset_listContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitDataset_list(this);
	}
};

Dataset_listContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitDataset_list(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Dataset_listContext = Dataset_listContext;

TransformsParser.prototype.dataset_list = function() {

    var localctx = new Dataset_listContext(this, this._ctx, this.state);
    this.enterRule(localctx, 138, TransformsParser.RULE_dataset_list);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 822;
        this.dataset();
        this.state = 827;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while(_la===TransformsParser.T__1) {
            this.state = 823;
            this.match(TransformsParser.T__1);
            this.state = 824;
            this.dataset();
            this.state = 829;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Hint_listContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_hint_list;
    return this;
}

Hint_listContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Hint_listContext.prototype.constructor = Hint_listContext;

Hint_listContext.prototype.hint = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(HintContext);
    } else {
        return this.getTypedRuleContext(HintContext,i);
    }
};

Hint_listContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterHint_list(this);
	}
};

Hint_listContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitHint_list(this);
	}
};

Hint_listContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitHint_list(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Hint_listContext = Hint_listContext;

TransformsParser.prototype.hint_list = function() {

    var localctx = new Hint_listContext(this, this._ctx, this.state);
    this.enterRule(localctx, 140, TransformsParser.RULE_hint_list);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 830;
        this.hint();
        this.state = 835;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while(_la===TransformsParser.T__1) {
            this.state = 831;
            this.match(TransformsParser.T__1);
            this.state = 832;
            this.hint();
            this.state = 837;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Identifier_listContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_identifier_list;
    return this;
}

Identifier_listContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Identifier_listContext.prototype.constructor = Identifier_listContext;

Identifier_listContext.prototype.id = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(IdContext);
    } else {
        return this.getTypedRuleContext(IdContext,i);
    }
};

Identifier_listContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterIdentifier_list(this);
	}
};

Identifier_listContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitIdentifier_list(this);
	}
};

Identifier_listContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitIdentifier_list(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Identifier_listContext = Identifier_listContext;

TransformsParser.prototype.identifier_list = function() {

    var localctx = new Identifier_listContext(this, this._ctx, this.state);
    this.enterRule(localctx, 142, TransformsParser.RULE_identifier_list);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 838;
        this.id();
        this.state = 843;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while(_la===TransformsParser.T__1) {
            this.state = 839;
            this.match(TransformsParser.T__1);
            this.state = 840;
            this.id();
            this.state = 845;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function IdContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_id;
    return this;
}

IdContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
IdContext.prototype.constructor = IdContext;

IdContext.prototype.id_fragment = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Id_fragmentContext);
    } else {
        return this.getTypedRuleContext(Id_fragmentContext,i);
    }
};

IdContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterId(this);
	}
};

IdContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitId(this);
	}
};

IdContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitId(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.IdContext = IdContext;

TransformsParser.prototype.id = function() {

    var localctx = new IdContext(this, this._ctx, this.state);
    this.enterRule(localctx, 144, TransformsParser.RULE_id);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 846;
        this.id_fragment();
        this.state = 853;
        this._errHandler.sync(this);
        var _alt = this._interp.adaptivePredict(this._input,88,this._ctx)
        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
            if(_alt===1) {
                this.state = 847;
                this.match(TransformsParser.T__22);
                this.state = 849;
                this._errHandler.sync(this);
                var la_ = this._interp.adaptivePredict(this._input,87,this._ctx);
                if(la_===1) {
                    this.state = 848;
                    this.id_fragment();

                } 
            }
            this.state = 855;
            this._errHandler.sync(this);
            _alt = this._interp.adaptivePredict(this._input,88,this._ctx);
        }

    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function Id_fragmentContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_id_fragment;
    return this;
}

Id_fragmentContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Id_fragmentContext.prototype.constructor = Id_fragmentContext;

Id_fragmentContext.prototype.K_ALL = function() {
    return this.getToken(TransformsParser.K_ALL, 0);
};

Id_fragmentContext.prototype.K_ARRAY = function() {
    return this.getToken(TransformsParser.K_ARRAY, 0);
};

Id_fragmentContext.prototype.K_BETWEEN = function() {
    return this.getToken(TransformsParser.K_BETWEEN, 0);
};

Id_fragmentContext.prototype.K_CHECKPOINT = function() {
    return this.getToken(TransformsParser.K_CHECKPOINT, 0);
};

Id_fragmentContext.prototype.K_CURRENT = function() {
    return this.getToken(TransformsParser.K_CURRENT, 0);
};

Id_fragmentContext.prototype.K_DISAMBIGUATE = function() {
    return this.getToken(TransformsParser.K_DISAMBIGUATE, 0);
};

Id_fragmentContext.prototype.K_DROP = function() {
    return this.getToken(TransformsParser.K_DROP, 0);
};

Id_fragmentContext.prototype.K_ENFORCE = function() {
    return this.getToken(TransformsParser.K_ENFORCE, 0);
};

Id_fragmentContext.prototype.K_FIRST = function() {
    return this.getToken(TransformsParser.K_FIRST, 0);
};

Id_fragmentContext.prototype.K_FOLLOWING = function() {
    return this.getToken(TransformsParser.K_FOLLOWING, 0);
};

Id_fragmentContext.prototype.K_JOIN = function() {
    return this.getToken(TransformsParser.K_JOIN, 0);
};

Id_fragmentContext.prototype.K_KEY = function() {
    return this.getToken(TransformsParser.K_KEY, 0);
};

Id_fragmentContext.prototype.K_LAST = function() {
    return this.getToken(TransformsParser.K_LAST, 0);
};

Id_fragmentContext.prototype.K_LOOKUP = function() {
    return this.getToken(TransformsParser.K_LOOKUP, 0);
};

Id_fragmentContext.prototype.K_NULLS = function() {
    return this.getToken(TransformsParser.K_NULLS, 0);
};

Id_fragmentContext.prototype.K_PRECEDING = function() {
    return this.getToken(TransformsParser.K_PRECEDING, 0);
};

Id_fragmentContext.prototype.K_PRIMARY = function() {
    return this.getToken(TransformsParser.K_PRIMARY, 0);
};

Id_fragmentContext.prototype.K_RANGE = function() {
    return this.getToken(TransformsParser.K_RANGE, 0);
};

Id_fragmentContext.prototype.K_ROW = function() {
    return this.getToken(TransformsParser.K_ROW, 0);
};

Id_fragmentContext.prototype.K_ROWS = function() {
    return this.getToken(TransformsParser.K_ROWS, 0);
};

Id_fragmentContext.prototype.K_SAMPLE = function() {
    return this.getToken(TransformsParser.K_SAMPLE, 0);
};

Id_fragmentContext.prototype.K_SEED = function() {
    return this.getToken(TransformsParser.K_SEED, 0);
};

Id_fragmentContext.prototype.K_UNBOUNDED = function() {
    return this.getToken(TransformsParser.K_UNBOUNDED, 0);
};

Id_fragmentContext.prototype.K_UNPIVOT = function() {
    return this.getToken(TransformsParser.K_UNPIVOT, 0);
};

Id_fragmentContext.prototype.K_WINDOW = function() {
    return this.getToken(TransformsParser.K_WINDOW, 0);
};

Id_fragmentContext.prototype.IDENTIFIER = function() {
    return this.getToken(TransformsParser.IDENTIFIER, 0);
};

Id_fragmentContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterId_fragment(this);
	}
};

Id_fragmentContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitId_fragment(this);
	}
};

Id_fragmentContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitId_fragment(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.Id_fragmentContext = Id_fragmentContext;

TransformsParser.prototype.id_fragment = function() {

    var localctx = new Id_fragmentContext(this, this._ctx, this.state);
    this.enterRule(localctx, 146, TransformsParser.RULE_id_fragment);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 856;
        _la = this._input.LA(1);
        if(!((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << TransformsParser.K_ALL) | (1 << TransformsParser.K_ARRAY) | (1 << TransformsParser.K_BETWEEN))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (TransformsParser.K_CHECKPOINT - 32)) | (1 << (TransformsParser.K_CURRENT - 32)) | (1 << (TransformsParser.K_DISAMBIGUATE - 32)) | (1 << (TransformsParser.K_DROP - 32)) | (1 << (TransformsParser.K_ENFORCE - 32)) | (1 << (TransformsParser.K_FIRST - 32)) | (1 << (TransformsParser.K_FOLLOWING - 32)) | (1 << (TransformsParser.K_JOIN - 32)) | (1 << (TransformsParser.K_KEY - 32)) | (1 << (TransformsParser.K_LAST - 32)) | (1 << (TransformsParser.K_LOOKUP - 32)))) !== 0) || ((((_la - 65)) & ~0x1f) == 0 && ((1 << (_la - 65)) & ((1 << (TransformsParser.K_NULLS - 65)) | (1 << (TransformsParser.K_PRECEDING - 65)) | (1 << (TransformsParser.K_PRIMARY - 65)) | (1 << (TransformsParser.K_RANGE - 65)) | (1 << (TransformsParser.K_ROW - 65)) | (1 << (TransformsParser.K_ROWS - 65)) | (1 << (TransformsParser.K_UNBOUNDED - 65)) | (1 << (TransformsParser.K_UNPIVOT - 65)) | (1 << (TransformsParser.K_WINDOW - 65)) | (1 << (TransformsParser.K_SAMPLE - 65)) | (1 << (TransformsParser.K_SEED - 65)) | (1 << (TransformsParser.IDENTIFIER - 65)))) !== 0))) {
        this._errHandler.recoverInline(this);
        }
        else {
        	this._errHandler.reportMatch(this);
            this.consume();
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function CommentsContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_comments;
    return this;
}

CommentsContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
CommentsContext.prototype.constructor = CommentsContext;

CommentsContext.prototype.EOF = function() {
    return this.getToken(TransformsParser.EOF, 0);
};

CommentsContext.prototype.comment = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(CommentContext);
    } else {
        return this.getTypedRuleContext(CommentContext,i);
    }
};

CommentsContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterComments(this);
	}
};

CommentsContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitComments(this);
	}
};

CommentsContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitComments(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.CommentsContext = CommentsContext;

TransformsParser.prototype.comments = function() {

    var localctx = new CommentsContext(this, this._ctx, this.state);
    this.enterRule(localctx, 148, TransformsParser.RULE_comments);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 861;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while(((((_la - 97)) & ~0x1f) == 0 && ((1 << (_la - 97)) & ((1 << (TransformsParser.SINGLE_LINE_COMMENT_SQL - 97)) | (1 << (TransformsParser.SINGLE_LINE_COMMENT_C - 97)) | (1 << (TransformsParser.MULTILINE_COMMENT - 97)))) !== 0)) {
            this.state = 858;
            this.comment();
            this.state = 863;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
        this.state = 864;
        this.match(TransformsParser.EOF);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};

function CommentContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = TransformsParser.RULE_comment;
    return this;
}

CommentContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
CommentContext.prototype.constructor = CommentContext;

CommentContext.prototype.SINGLE_LINE_COMMENT_C = function() {
    return this.getToken(TransformsParser.SINGLE_LINE_COMMENT_C, 0);
};

CommentContext.prototype.SINGLE_LINE_COMMENT_SQL = function() {
    return this.getToken(TransformsParser.SINGLE_LINE_COMMENT_SQL, 0);
};

CommentContext.prototype.MULTILINE_COMMENT = function() {
    return this.getToken(TransformsParser.MULTILINE_COMMENT, 0);
};

CommentContext.prototype.enterRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.enterComment(this);
	}
};

CommentContext.prototype.exitRule = function(listener) {
    if(listener instanceof TransformsListener ) {
        listener.exitComment(this);
	}
};

CommentContext.prototype.accept = function(visitor) {
    if ( visitor instanceof TransformsVisitor ) {
        return visitor.visitComment(this);
    } else {
        return visitor.visitChildren(this);
    }
};




TransformsParser.CommentContext = CommentContext;

TransformsParser.prototype.comment = function() {

    var localctx = new CommentContext(this, this._ctx, this.state);
    this.enterRule(localctx, 150, TransformsParser.RULE_comment);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 866;
        _la = this._input.LA(1);
        if(!(((((_la - 97)) & ~0x1f) == 0 && ((1 << (_la - 97)) & ((1 << (TransformsParser.SINGLE_LINE_COMMENT_SQL - 97)) | (1 << (TransformsParser.SINGLE_LINE_COMMENT_C - 97)) | (1 << (TransformsParser.MULTILINE_COMMENT - 97)))) !== 0))) {
        this._errHandler.recoverInline(this);
        }
        else {
        	this._errHandler.reportMatch(this);
            this.consume();
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


TransformsParser.prototype.sempred = function(localctx, ruleIndex, predIndex) {
	switch(ruleIndex) {
	case 48:
			return this.expr_sempred(localctx, predIndex);
    default:
        throw "No predicate with index:" + ruleIndex;
   }
};

TransformsParser.prototype.expr_sempred = function(localctx, predIndex) {
	switch(predIndex) {
		case 0:
			return this.precpred(this._ctx, 23);
		case 1:
			return this.precpred(this._ctx, 22);
		case 2:
			return this.precpred(this._ctx, 21);
		case 3:
			return this.precpred(this._ctx, 20);
		case 4:
			return this.precpred(this._ctx, 19);
		case 5:
			return this.precpred(this._ctx, 18);
		case 6:
			return this.precpred(this._ctx, 17);
		case 7:
			return this.precpred(this._ctx, 16);
		case 8:
			return this.precpred(this._ctx, 15);
		case 9:
			return this.precpred(this._ctx, 14);
		case 10:
			return this.precpred(this._ctx, 13);
		case 11:
			return this.precpred(this._ctx, 10);
		case 12:
			return this.precpred(this._ctx, 9);
		case 13:
			return this.precpred(this._ctx, 7);
		case 14:
			return this.precpred(this._ctx, 29);
		case 15:
			return this.precpred(this._ctx, 27);
		case 16:
			return this.precpred(this._ctx, 26);
		case 17:
			return this.precpred(this._ctx, 25);
		case 18:
			return this.precpred(this._ctx, 24);
		default:
			throw "No predicate with index:" + predIndex;
	}
};


exports.TransformsParser = TransformsParser;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
TransformsLexer: __webpack_require__(3).TransformsLexer,
TransformsListener: __webpack_require__(1).TransformsListener,
TransformsParser: __webpack_require__(4).TransformsParser,
TransformsVisitor: __webpack_require__(2).TransformsVisitor
};


/***/ })
/******/ ]);